'use strict';

(function (angular) {
  angular.module('ibf').controller('adminNavCtrl', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', '$uibModal', 'environment', adminNavCtrl]);

  function adminNavCtrl($scope, alertify, $state, commonSrv, sessionSrv, $uibModal, environment) {
    var nav = this,
        common = commonSrv,
        session = sessionSrv;
    nav.standingOrderUrl = environment.v2Url + '#/standing_order/list';
    nav.marketingUrlGeneratorUrl = environment.v2Url + '#/marketingUrlGenerator';
    nav.balanceV2Url = environment.v2Url + '#/accounting/balance';
    nav.growers = [];
    nav.openStandingOrderPriceStatus = function () {
      $state.go('admin.standing_order_price_status');
    };

    nav.include = function (name) {
      return $state.includes('admin.' + name);
    };

    nav.isCurrent = function (name) {
      return $state.is('admin.' + name);
    };

    function init() {
      nav.name = common.getUserData().data.name;
      nav.validateSession();
    }

    nav.validateSession = function () {

      if (session.validate()) {
        nav.user = common.getUserData().data;
        common.setHeaders(common.getUserData().token);
      }
    };

    nav.redirectFarmDashboard = function () {
      window.open(common.config.looker_grower_dashboard_link);
    };

    nav.openLoginAsModal = function () {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/login-as-modal.html',
        controller: 'loginAsModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              growers: nav.growers
            };
          }
        }
      });
      modalInstance.result.then();
    };

    nav.logout = function () {
      session.logout();
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminNavCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminDashboardCtrl', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', 'adminSrv', adminDashboardCtrl]);

  function adminDashboardCtrl($scope, alertify, $state, commonSrv, sessionSrv, adminSrv) {
    var obj = this,
        common = commonSrv,
        admin = adminSrv;

    obj.isCurrent = function (name) {
      return $state.is('admin.dashboard.' + name);
    };
  }
})(angular);
//# sourceMappingURL=adminDashboardCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminDashboardMonthDate', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', 'adminSrv', '$filter', adminDashboardMonthDate]);

  function adminDashboardMonthDate($scope, alertify, $state, commonSrv, sessionSrv, adminSrv, $filter) {
    var obj = this,
        common = commonSrv,
        admin = adminSrv;
    obj.labels = [];

    obj.radioModel = 'Grower';
    obj.radioShowLabel = 'Sales';
    obj.data = [];
    obj.dataType = 'balance';

    obj.currentItem = {};
    obj.state = new valueItem();
    obj.grower = new valueItem();

    obj.series = [];
    obj.colors = [];

    obj.chartItem = {};
    obj.options = {
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var label = '';
            if (obj.radioShowLabel === 'Sales') label = tooltipItem.yLabel + ' : ' + $filter('currency')(tooltipItem.xLabel);else label = tooltipItem.yLabel + ' : ' + tooltipItem.xLabel;
            return label;
          }
        }
      }
    };

    $scope.$watch('obj.radioModel', function () {
      decideLabelAssignment();
    });

    $scope.$watch('obj.radioShowLabel', function () {
      decideLabelDataAssignment();
    });

    function init() {
      getBalanceGrowerState();
    }

    function getBalanceGrowerState() {
      admin.getGrowerState(function (results) {
        obj.grower = createArray(results.growers);
        obj.state = createArray(results.states);
        decideLabelAssignment();
        generateColors(Math.max(obj.grower.labels.length, obj.state.labels.length));
      }, function (error) {
        console.log(error);
      });
    }

    obj.onClick = function (points, evt) {
      if (points.length) {
        obj.chartItem.label = points[0]._model.label;
        obj.labels.forEach(function (item, index) {
          if (item === obj.chartItem.label) obj.chartItem.value = obj.data[index];
        });
      } else {
        obj.chartItem = {
          label: '',
          value: ''
        };
      }
    };

    function decideLabelAssignment() {
      switch (obj.radioModel) {
        case 'State':
          obj.currentItem = obj.state;
          assignToArray(obj.state);
          break;
        case 'Grower':
          obj.currentItem = obj.grower;
          assignToArray(obj.grower);
          break;
      }
    }

    function decideLabelDataAssignment() {
      switch (obj.radioShowLabel) {
        case 'Sales':
          obj.dataType = 'balance';
          break;
        case 'Boxes':
          obj.dataType = 'boxes';
          break;
      }
      assignToArray(obj.currentItem);
    }

    function createArray(array, object) {
      object = new valueItem();
      var totalBoxes = 0,
          total = 0;

      array = $filter('orderBy')(array, obj.dataType, true);
      array.forEach(function (item) {
        object.labels.push(item.name);
        object.balance.push(item.balance);
        object.boxes.push(item.boxes);
        total += item.balance;
        totalBoxes += item.boxes;
      });

      object.total = total;
      object.totalBoxes = totalBoxes;

      return object;
    }

    function assignToArray(selectedItem) {
      obj.series = obj.labels = selectedItem.labels;
      obj.data = selectedItem[obj.dataType];
      obj.total = selectedItem.total;
      obj.totalBoxes = selectedItem.totalBoxes;
    }

    obj.getMonthDate = function () {
      return { start: moment().startOf('month').format('MMMM D'), end: moment().format('MMMM D') };
    };

    function generateColors(length) {
      for (var index = 0; index < length; index++) {
        var color = "#000000".replace(/0/g, function () {
          return (~~(Math.random() * 16)).toString(16);
        });

        obj.colors.push({
          backgroundColor: color,
          pointBackgroundColor: color
        });
      }
    }

    function valueItem() {
      this.balance = [];
      this.labels = [];
      this.boxes = [];
      this.totalBoxes = 0;
      this.total = 0;
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminDashboardMonthDate.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminDashboardSalesMonth', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', 'adminSrv', '$filter', adminDashboardSalesMonth]);

  function adminDashboardSalesMonth($scope, alertify, $state, commonSrv, sessionSrv, adminSrv, $filter) {
    var obj = this,
        common = commonSrv,
        admin = adminSrv;
    var yearsIndex = [];

    obj.years = {};
    obj.series = [];
    obj.data = [];
    obj.radioModel = 'chart';
    obj.radioShowLabel = 'Sales';
    obj.radioWithCharge = 1;

    obj.labels = common.getMonthList().map(function (item) {
      return item.month;
    });

    obj.colors = [{
      backgroundColor: "rgba(114,147,203, 0.2)",
      pointBackgroundColor: "rgba(114,147,203, 1)",
      pointHoverBackgroundColor: "rgba(114,147,203, 0.8)",
      borderColor: "rgba(114,147,203, 1)",
      pointBorderColor: '#fff',
      pointHoverBorderColor: "rgba(114,147,203, 1)"
    }, {
      backgroundColor: "rgba(211,94,96, 0.2)",
      pointBackgroundColor: "rgba(213,94,96, 1)",
      pointHoverBackgroundColor: "rgba(211,94,96, 0.8)",
      borderColor: "rgba(211,94,96, 1)",
      pointBorderColor: '#fff',
      pointHoverBorderColor: "rgba(211,94,96, 1)"
    }, {
      backgroundColor: "rgba(0, 168, 107, 0.2)",
      pointBackgroundColor: "rgba(0, 168, 107, 1)",
      pointHoverBackgroundColor: "rgba(0, 168, 107, 0.8)",
      borderColor: "rgba(0, 168, 107, 1)",
      pointBorderColor: '#fff',
      pointHoverBorderColor: "rgba(0, 168, 107, 1)"
    }, {
      backgroundColor: "rgba(255, 255, 0, 1)",
      pointBackgroundColor: "rgba(255, 255, 107, 1)",
      pointHoverBackgroundColor: "rgba(255, 255, 107, 0.8)",
      borderColor: "rgba(255, 255, 107, 1)",
      pointBorderColor: '#fff',
      pointHoverBorderColor: "rgba(255, 255, 107, 1)"
    }, {
      backgroundColor: "rgba(232, 50, 147, 1)",
      pointBackgroundColor: "rgba(232, 50, 147, 1)",
      pointHoverBackgroundColor: "rgba(232, 50, 147, 0.8)",
      borderColor: "rgba(232, 50, 147, 1)",
      pointBorderColor: '#fff',
      pointHoverBorderColor: "rgba(232, 50, 147, 1)"
    }];

    $scope.$watch('obj.radioShowLabel', function () {
      if (yearsIndex.length) {
        decideLabelAssignment();
      }
    });

    $scope.$watch('obj.radioWithCharge', function () {
      if (yearsIndex.length) {
        decideLabelAssignment();
      }
    });

    function init() {
      balancePerMonth();
    }

    function balancePerMonth() {
      var params = { withCharge: obj.radioWithCharge };
      admin.getBalancePerMonth(params, function (results) {
        Object.keys(results).forEach(function (year) {
          yearsIndex.push(year);
          obj.years[year] = {
            months: [],
            boxes: [],
            totalBoxes: [0, 0],
            total: [0, 0]
          };
          Object.keys(results[year]).forEach(function (month) {
            var monthTotal = results[year][month].total;
            var monthBoxes = results[year][month].boxes;
            obj.years[year].months.push(monthTotal);
            obj.years[year].boxes.push(monthBoxes);
            obj.years[year].total[0] += monthTotal[0];
            obj.years[year].total[1] += monthTotal[1];
            obj.years[year].totalBoxes[0] += monthBoxes[0];
            obj.years[year].totalBoxes[1] += monthBoxes[1];
          });
        });

        obj.series = yearsIndex;
        // obj.data = [
        //   obj.years[yearsIndex[0]].months.map(isCharge => isCharge[obj.radioWithCharge]),
        //   obj.years[yearsIndex[1]].months.map(isCharge => isCharge[obj.radioWithCharge]),
        //   obj.years[yearsIndex[2]].months.map(isCharge => isCharge[obj.radioWithCharge])
        // ];

        obj.data = yearsIndex.map(function (year) {
          return obj.years[year].months.map(function (isCharge) {
            return isCharge[obj.radioWithCharge];
          });
        });
      }, function (error) {
        console.log(error);
      });
    }

    function decideLabelAssignment() {
      switch (obj.radioShowLabel) {
        case 'Sales':
          obj.data = yearsIndex.map(function (_, index) {
            return parseArrayWithCharge(index, 'months');
          });
          break;
        case 'Boxes':
          obj.data = yearsIndex.map(function (_, index) {
            return parseArrayWithCharge(index, 'boxes');
          });
          break;
      }
    }

    function parseArrayWithCharge(pos, dataType) {
      return obj.years[yearsIndex[pos]][dataType].map(function (isCharge) {
        return isCharge[obj.radioWithCharge];
      });
    }

    obj.onClick = function (points, evt) {
      console.log(points, evt);
    };

    obj.datasetOverride = [{
      yAxisID: 'y-axis-1'
    }];

    obj.options = {
      responsive: true,
      scales: {
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          display: true,
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var label = void 0;
            if (obj.radioShowLabel === 'Sales') {
              label = obj.series[tooltipItem.datasetIndex] + ': ' + $filter('currency')(tooltipItem.yLabel);
            } else {
              label = obj.series[tooltipItem.datasetIndex] + ': ' + tooltipItem.yLabel;
            }

            if (this.higlightRow) {
              this.higlightRow[0].removeClass('dashboard-row-1');
              this.higlightRow[1].removeClass('dashboard-row-2');
              this.higlightRow[2].removeClass('dashboard-row-3');
              this.higlightRow[3].removeClass('dashboard-row-4');
              this.higlightRow[4].removeClass('dashboard-row-5');
              this.higlightRow[5].removeClass('dashboard-row-6');
              this.higlightRow[6].removeClass('dashboard-row-7');
            }

            this.higlightRow = [$('#' + tooltipItem.xLabel + ' :nth-child(2)'), $('#' + tooltipItem.xLabel + ' :nth-child(3)'), $('#' + tooltipItem.xLabel + ' :nth-child(4)'), $('#' + tooltipItem.xLabel + ' :nth-child(5)'), $('#' + tooltipItem.xLabel + ' :nth-child(6)'), $('#' + tooltipItem.xLabel + ' :nth-child(7)'), $('#' + tooltipItem.xLabel + ' :nth-child(8)')];

            this.higlightRow[0].addClass('dashboard-row-1');
            this.higlightRow[1].addClass('dashboard-row-2');
            this.higlightRow[2].addClass('dashboard-row-3');
            this.higlightRow[3].addClass('dashboard-row-4');
            this.higlightRow[4].addClass('dashboard-row-5');
            this.higlightRow[5].addClass('dashboard-row-6');
            this.higlightRow[6].addClass('dashboard-row-7');

            return label;
          }
        }
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminDashboardSalesMonth.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminDashboardWeekDate', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', 'adminSrv', '$filter', adminDashboardWeekDate]);

  function adminDashboardWeekDate($scope, alertify, $state, commonSrv, sessionSrv, adminSrv, $filter) {
    var obj = this,
        common = commonSrv,
        admin = adminSrv;
    obj.labels = [];

    obj.radioModel = 'Grower';
    obj.radioShowLabel = 'Sales';
    obj.data = [];
    obj.dataType = 'balance';

    obj.currentItem = {};
    obj.state = new valueItem();
    obj.grower = new valueItem();

    obj.series = [];
    obj.colors = [];

    obj.chartItem = {};
    obj.options = {
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var label = '';
            if (obj.radioShowLabel === 'Sales') label = tooltipItem.yLabel + ' : ' + $filter('currency')(tooltipItem.xLabel);else label = tooltipItem.yLabel + ' : ' + tooltipItem.xLabel;
            return label;
          }
        }
      }
    };

    $scope.$watch('obj.radioModel', function () {
      decideLabelAssignment();
    });

    $scope.$watch('obj.radioShowLabel', function () {
      decideLabelDataAssignment();
    });

    function init() {
      getBalanceGrowerState();
    }

    function getBalanceGrowerState() {
      admin.getGrowerState(function (results) {
        obj.grower = createArray(results.growers);
        obj.state = createArray(results.states);
        decideLabelAssignment();
        generateColors(Math.max(obj.grower.labels.length, obj.state.labels.length));
      }, function (error) {
        console.log(error);
      });
    }

    obj.onClick = function (points, evt) {
      if (points.length) {
        obj.chartItem.label = points[0]._model.label;
        obj.labels.forEach(function (item, index) {
          if (item === obj.chartItem.label) obj.chartItem.value = obj.data[index];
        });
      } else {
        obj.chartItem = {
          label: '',
          value: ''
        };
      }
    };

    function decideLabelAssignment() {
      switch (obj.radioModel) {
        case 'State':
          obj.currentItem = obj.state;
          assignToArray(obj.state);
          break;
        case 'Grower':
          obj.currentItem = obj.grower;
          assignToArray(obj.grower);
          break;
      }
    }

    function decideLabelDataAssignment() {
      switch (obj.radioShowLabel) {
        case 'Sales':
          obj.dataType = 'balance';
          break;
        case 'Boxes':
          obj.dataType = 'boxes';
          break;
      }
      assignToArray(obj.currentItem);
    }

    function createArray(array, object) {
      object = new valueItem();
      var totalBoxes = 0,
          total = 0;

      array = $filter('orderBy')(array, obj.dataType, true);
      array.forEach(function (item) {
        object.labels.push(item.name);
        object.balance.push(item.balance);
        object.boxes.push(item.boxes);
        total += item.balance;
        totalBoxes += item.boxes;
      });

      object.total = total;
      object.totalBoxes = totalBoxes;

      return object;
    }

    function assignToArray(selectedItem) {
      obj.series = obj.labels = selectedItem.labels;
      obj.data = selectedItem[obj.dataType];
      obj.total = selectedItem.total;
      obj.totalBoxes = selectedItem.totalBoxes;
    }

    obj.getMonthDate = function () {
      return { start: moment().startOf('month').format('MMMM D'), end: moment().format('MMMM D') };
    };

    function generateColors(length) {
      for (var index = 0; index < length; index++) {
        var color = "#000000".replace(/0/g, function () {
          return (~~(Math.random() * 16)).toString(16);
        });

        obj.colors.push({
          backgroundColor: color,
          pointBackgroundColor: color
        });
      }
    }

    function valueItem() {
      this.balance = [];
      this.labels = [];
      this.boxes = [];
      this.totalBoxes = 0;
      this.total = 0;
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminDashboardWeekDate.js.map

'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (angular) {
  angular.module('ibf').controller('adminManageGrowerCtrl', ['$scope', 'alertify', 'commonSrv', '$state', 'growerSrv', '$q', adminManageGrowerCtrl]).controller('adminVarietyDetailCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$timeout', '$filter', 'FileUploader', '$uibModalInstance', 'config', adminVarietyDetailCtrl]).controller('adminProductGroupCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$uibModalInstance', 'config', adminProductGroupCtrl]).controller('adminColorDetailCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$uibModalInstance', 'config', adminColorDetailCtrl]).controller('adminPackingListCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'environment', '$uibModalInstance', 'config', 'floristSrv', "growerSrv", '$http', adminPackingListCtrl]).controller('adminCustomsCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'environment', '$uibModalInstance', 'config', adminCustomsCtrl]).controller('adminCustomsGroupCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'environment', '$uibModalInstance', 'config', adminCustomsGroupCtrl]).controller('adminProductGroupModalCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'growerSrv', '$uibModalInstance', 'config', adminProductGroupModalCtrl]).controller('adminClaimModalCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', '$uibModalInstance', 'config', 'floristSrv', '$state', 'environment', adminClaimModalCtrl]);

  function adminManageGrowerCtrl($scope, alertify, commonSrv, $state, growerSrv, $q) {

    var modal = this,
        common = commonSrv,
        gs = growerSrv;
    modal.edit = !!$state.params.grower;
    console.log('Edit' + ' ' + modal.edit, $state.params);
    modal.grower = $state.params.grower ? $state.params.grower : null;
    //modal.user = $state.params.user ? $state.params.user : null;
    modal.isLoading = false;

    function init() {

      modal.loadContries();
      modal.loadTimeZones();
      modal.listCities();

      modal.shipping = {
        shipping_monday: false,
        shipping_tuesday: false,
        shipping_wednesday: false,
        shipping_thursday: false,
        shipping_friday: false,
        shipping_saturday: false,
        shipping_sunday: false
      };
      if (modal.edit) {
        modal.retrieve();
      }
    }

    modal.dayHours = {
      hours: [{ hour: '00:00' }, { hour: '01:00' }, { hour: '02:00' }, { hour: '03:00' }, { hour: '04:00' }, { hour: '05:00' }, { hour: '06:00' }, { hour: '07:00' }, { hour: '08:00' }, { hour: '09:00' }, { hour: '10:00' }, { hour: '11:00' }, { hour: '12:00' }, { hour: '13:00' }, { hour: '14:00' }, { hour: '15:00' }, { hour: '16:00' }, { hour: '17:00' }, { hour: '18:00' }, { hour: '19:00' }, { hour: '20:00' }, { hour: '21:00' }, { hour: '22:00' }, { hour: '23:00' }]
    };

    function setAttributes(object) {
      modal.shipping = {
        shipping_monday: false,
        shipping_tuesday: false,
        shipping_wednesday: false,
        shipping_thursday: false,
        shipping_friday: false,
        shipping_saturday: false,
        shipping_sunday: false
      };
    }

    modal.listCities = function () {

      gs.listCities(function (data) {

        modal.cities = data;
        if (modal.cities.length > 0) {
          modal.cityMap = common.toMap(modal.cities, 'cityMap', '_KEY');
        }
      }, function (e) {
        alertify.error(e);
      });
    };

    // modal.selectCountry = function(){

    //   // let aux = [];
    //   // for(let i = 0; i < modal.cities.length; i++){
    //   //   if(modal.cities[i].country == modal.country._KEY){
    //   //     aux.push(modal.cities[i]);
    //   //   }
    //   // }
    //   modal.cities_select = aux;

    // }

    modal.retrieve = function () {

      var query = {
        domain: common.actual_domain,
        page: 1,
        row_model: 'grower_preference',
        size: 1000,
        where: [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'grower',
            'OP': '=',
            'VAL': modal.grower._KEY
          }]
        }]
        // fetch: ['printer_labels']
      };

      common.method.query(common.urls.find, query).then(function () {

        var response = common.response.post_query;
        // var fetched_results = response.data.fetched_results;

        //var country = common.toMap(modal.countries,"_KEY","_KEY")[modal.grower.country];
        if (modal.timezones && modal.timezones.length > 0) {
          var timeZone = common.toMap(modal.timezones, '_KEY', '_KEY')[modal.grower.time_zone];
        }
        var hours = modal.grower.business_hours ? modal.grower.business_hours.split('-') : null;

        if (modal.grower.city_ref) {
          modal.city = modal.grower.city_ref;
        } else {
          modal.city = modal.grower.city;
        }

        modal.company_name = modal.grower.company_name;
        modal.street = modal.grower.street;
        // modal.city = modal.grower.city;

        modal.country = modal.grower.country;
        modal.phone_number = modal.grower.phone_number;
        modal.email_address = modal.grower.email_address;
        modal.website = modal.grower.website;
        modal.vat_number = modal.grower.vat_number;
        modal.chamber_of_commerce = modal.grower.chamber_of_commerce;
        modal.excl_transport_cost = modal.grower.excl_transport_cost;
        modal.time_zone = timeZone;
        modal.hour_from = hours ? hours[0] : null;
        modal.hour_to = hours ? hours[1] : null;
        modal.zip_code = modal.grower.zip_code;

        // modal.first_name = modal.user.first_name;
        // modal.last_name = modal.user.last_name;
        // modal.cellphone = modal.user.cellphone;
        // modal.user_email = modal.user.user_email;
        // modal.confirm_user_email = modal.user.user_email;
        // modal.password = modal.user.password;
        // modal.confirm_user_password = modal.user.password;

        if (response.data.results && response.data.results.length > 0) {

          modal.grower_preferences = response.data.results[0];

          // var printer_labels = fetched_results.printer_labels;
          // printer_labels = fetched_results.printer_labels[Object.keys(printer_labels)[0]];

          // modal.printer_labels = printer_labels;
          modal.shipping.shipping_monday = modal.grower_preferences.shipping_monday;
          modal.shipping.shipping_tuesday = modal.grower_preferences.shipping_tuesday;
          modal.shipping.shipping_wednesday = modal.grower_preferences.shipping_wednesday;
          modal.shipping.shipping_thursday = modal.grower_preferences.shipping_thursday;
          modal.shipping.shipping_friday = modal.grower_preferences.shipping_friday;
          modal.shipping.shipping_saturday = modal.grower_preferences.shipping_saturday;
          modal.shipping.shipping_sunday = modal.grower_preferences.shipping_sunday;
        }
      });
      //obj.retrieve's end
    };

    modal.shippingDayByCountry = function (countryKey) {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'shipping_day',
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'country',
            'OP': '=',
            'VAL': countryKey
          }]
        }],
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data.results;
        setAttributes();
        if (response.length > 0) {
          angular.forEach(response, function (item) {
            switch (item.shipping_day) {
              case 'monday':
                modal.shipping.shipping_monday = true;
                break;
              case 'tuesday':
                modal.shipping.shipping_tuesday = true;
                break;
              case 'wednesday':
                modal.shipping.shipping_wednesday = true;
                break;
              case 'thursday':
                modal.shipping.shipping_thursday = true;
                break;
              case 'friday':
                modal.shipping.shipping_friday = true;
                break;
              case 'saturday':
                modal.shipping.shipping_saturday = true;
                break;
              default:
                modal.shipping.shipping_sunday = true;
            }
          });
        } else {
          alertify.log('No shipping preference for this country');
        }
      });
    };

    modal.loadContries = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'country',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        if (common.response.post_query.data.results) {
          modal.countries = common.response.post_query.data.results;
          angular.forEach(modal.countries, function (element) {
            element.country += ' (' + element.country_iso + ')';
          });
        } else {
          alertify.error('Internal error loading Contries');
        }
      });
    };

    modal.loadTimeZones = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'time_zone',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        if (common.response.post_query.data.results) {
          modal.timezones = common.response.post_query.data.results;
        } else {
          alertify.error('Internal error loading Time zones');
        }
      });
    };

    // modal.loadLabels = function(){
    //   var query = {
    //     "domain": common.actual_domain,
    //     "page": 1,
    //     "row_model": "printer_labels",
    //     "size": 1000
    //   }

    //   common.method.query(common.urls.find, query).then(function(){

    //     if(common.response.post_query.data.results){
    //       modal.labels = common.response.post_query.data.results;
    //     }else{
    //       alertify.error('Internal error loading Printer Labels');
    //     }

    //   });
    // }

    modal.close = function () {
      //$uibModalInstance.dismiss();
      $state.go('admin.accounting.growers');
    };

    modal.saveUser = function (query) {
      return common.method.query(common.urls.row, query).then(function () {
        var response = common.response.post_query.data;
        if (response.success) {
          modal.setAdminPermissions(response.keys[0]);
          modal.setShippingPreferences();
        }
        //$uibModalInstance.close();
        alertify.success('User Created.');
        $state.go('admin.accounting.growers');
      });
    };

    modal.setShippingPreferences = function () {

      if (modal.edit && modal.grower_preferences) {

        modal.shipping.grower = modal.grower._KEY;
        modal.shipping._KEY = modal.grower_preferences._KEY;
        // modal.shipping.printer_labels = modal.printer_labels._KEY;

        var query = {
          'domain': common.actual_domain,
          'rows': [modal.shipping],
          'row_model': 'grower_preference'
        };

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          if (!response.success) {
            alertify.error('Internal error editing shipping preferences.');
          }
        });
      } else if (modal.edit && modal.printer_labels && !modal.grower_preferences) {
        modal.shipping.grower = modal.grower._KEY;
        // modal.shipping.printer_labels = modal.printer_labels._KEY;

        var query = {
          'domain': common.actual_domain,
          'rows': [modal.shipping],
          'row_model': 'grower_preference'
        };

        common.method.query(common.urls.row, query).then(function () {
          var response = common.response.post_query.data;
          if (!response.success) {
            alertify.error('Internal error adding shipping preferences.');
          }
        });
      } else if (!modal.edit) {
        // if(modal.printer_labels){
        modal.shipping.grower = modal.user_admin.grower;
        // modal.shipping.printer_labels = modal.printer_labels._KEY;

        var query = {
          'domain': common.actual_domain,
          'rows': [modal.shipping],
          'row_model': 'grower_preference'
        };

        common.method.query(common.urls.row, query).then(function () {
          var response = common.response.post_query.data;
          if (!response.success) {
            alertify.error('Internal error adding shipping preferences.');
          }
        });
        // }
      } else {
        alertify.log('The user doesn\'t have grower preferences associated.');
      }
    };

    modal.setGrowerAdmin = function (admin) {
      var query = {
        'domain': common.actual_domain,
        'rows': [{
          'admin': admin.user,
          '_KEY': admin.grower
        }],
        'row_model': 'grower'
      };

      common.method.query(common.urls.update, query);
    };

    modal.setAdminPermissions = function (key) {
      modal.perm = {
        orders: true,
        inventory: true,
        auto_buys: true,
        standing_orders: true,
        claims: true,
        setup: true,
        user: key
      };
      var query = {
        'domain': common.actual_domain,
        'rows': [modal.perm],
        'row_model': 'grower_user_config'
      };

      common.method.query(common.urls.row, query).then(function () {
        var response = common.response.post_query.data;
      });
    };

    modal.registerUser = function (user) {

      var valid = true,
          msg = '';

      var aux_login_user = user.user_email.replace('@', '.');
      var username = aux_login_user.substr(0, aux_login_user.lastIndexOf('.'));

      var reg = {
        email: user.user_email,
        password: modal.user_password,
        name: user.first_name + ' ' + user.last_name,
        login: username,
        domain: common.actual_domain
      };

      common.method.get(common.urls.register, reg).then(function () {
        modal.isLoading = false;

        var response = common.response.get.data;
        if (response.success) {
          modal.user_query.rows[0].user_id = response.user.id;
          modal.user_admin = {
            user: response.user.id,
            grower: user.grower
          };

          modal.setGrowerAdmin(modal.user_admin);
          modal.saveUser(modal.user_query);
        } else {
          alertify.error('Cannot register user');
          var delete_grower = {
            'domain': common.actual_domain,
            'row_model': 'grower',
            'where': {
              'keys': [user.grower]
            }
          };
          common.method.query(common.urls.delete, delete_grower);
        }
      });
    };

    modal.createGrowerFolder = function (grower_key) {
      common.method.post(common.urls.addFolder, {
        parent_key: common.growers_folder_key,
        name: grower_key
      }).then(function () {

        var response = common.response.post.data;
        if (response.success) {
          console.log('Grower Folder Created');
        } else {
          alertify.error(response.error);
        }
      });
    };

    modal.save = function () {

      var valid = true,
          msg = '';
      modal.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (modal.growerForm.$invalid) {
        modal.isLoading = false;
        valid = false;
        msg = 'There are invalid fields';
      }

      if (!modal.edit && modal.confirm_user_password != modal.user_password) {
        valid = false;
        msg = 'User Passwords must match.';
      }

      if (!modal.edit && modal.confirm_user_email != modal.user_email) {
        valid = false;
        msg = 'User Emails must match.';
      }

      if (valid) {

        var grower = {
          company_name: modal.company_name,
          street: modal.street,
          city: modal.city.name,
          city_ref: modal.city._KEY,
          days_in_advance: modal.city.days_in_advance,
          country: modal.country._KEY,
          phone_number: modal.phone_number,
          email_address: modal.email_address,
          website: modal.website,
          vat_number: modal.vat_number,
          chamber_of_commerce: modal.chamber_of_commerce,
          time_zone: modal.time_zone._KEY,
          business_hours: modal.hour_from + '-' + modal.hour_to,
          zip_code: modal.zip_code,
          excl_transport_cost: modal.excl_transport_cost,
          active: true
        };

        var user_admin = {
          first_name: modal.first_name,
          last_name: modal.last_name,
          role: 'GROWER',
          grower: null,
          cellphone: modal.cellphone,
          user_email: modal.user_email,
          is_admin: true,
          active: true
        };

        // modal.grower_query = common.queryBuilder()
        //   .setDomain(common.actual_domain)
        //   .setModel('grower')
        //   .addObjectForCreate(grower)
        //   .compile();

        // modal.user_query = common.queryBuilder()
        //   .setDomain(common.actual_domain)
        //   .setModel('user')
        //   .addObjectForCreate(user_admin)
        //   .compile();

        if (modal.edit) {
          grower._KEY = modal.grower._KEY;

          var query = {
            domain: common.actual_domain,
            row_model: 'grower',
            rows: [grower]
          };

          common.method.query(common.urls.update, query).then(function () {
            var response = common.response.post_query.data;
            if (response.success) {
              alertify.success('Grower updated');
              modal.isLoading = false;
            } else {
              alertify.error('Cannot update grower');
            }
          });

          modal.setShippingPreferences();
        } else {
          // if(valid){

          modal.grower_query = {
            'domain': common.actual_domain,
            'rows': [grower],
            'row_model': 'grower'
          };

          modal.user_query = {
            'domain': common.actual_domain,
            'rows': [user_admin],
            'row_model': 'user'
          };

          common.method.query(common.urls.row, modal.grower_query).then(function () {

            var response = common.response.post_query.data.keys;
            var key = response[0];
            modal.user_query.rows[0].grower = key;
            modal.registerUser(modal.user_query.rows[0]);
            modal.createGrowerFolder(key);

            modal.isLoading = false;
          });
          // }
        }
      } else {
        modal.isLoading = false;
        alertify.error(msg);
      }
    };

    init();
  }

  function adminVarietyDetailCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $timeout, $filter, FileUploader, $uibModalInstance, config) {

    var modal = this,
        common = commonSrv;

    modal.isLoading = false;
    modal.current_variety = config.variety;
    modal.product_groups = $filter('orderBy')(config.product_groups, 'common_name');
    modal.colors = $filter('orderBy')(config.colors, 'color_name');
    modal.picture = false;
    modal.upload = false;

    $scope.fileAdded = function (files) {
      modal.thumbnail = URL.createObjectURL(files[0]);
      modal.upload = true;
    };

    function init() {
      if (modal.current_variety.image) {
        modal.picture = true;
        modal.thumbnail = common.actual_base_url + '/varieties/' + modal.current_variety.image.name + '?cb=' + $.now();
      } else {
        modal.thumbnail = 'images/nav-logo.png';
      }
    }

    modal.uploadImage = function (varietyKey, cb) {
      if (!modal.upload) {
        return cb();
      }
      var myBlob = common.dataURItoBlob(modal.myFile.compressed.dataURL);
      var myFile = new File([myBlob], 'name.jpg');
      var fd = new FormData();
      fd.append('file', myFile, 'variety_' + varietyKey + '.jpg');
      fd.append('model', JSON.stringify({ key: common.varieties_folder_key }));
      growerSrv.uploadFileToUrl(fd, cb);
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.save = function () {

      $scope.$broadcast('show-errors-check-validity');
      if (modal.adminVarietyDetail.$invalid) {
        modal.isLoading = false;
        // valid = false;

        if (!modal.current_variety.product_group) {
          alertify.error('Please assign a Product Group for this variety');
          return;
        }

        if (!modal.current_variety.variety_name || modal.current_variety.variety_name.length < 1) {
          alertify.error('Please assign a name for this variety');
          return;
        }

        if (!modal.current_variety.color) {
          alertify.error('Please assign a color for this variety');
          return;
        }
      }

      modal.isLoading = true;

      // if it is a new variety, try to find if the name is available

      productSrv.saveVariety(modal.current_variety, function (variety) {
        modal.uploadImage(variety._KEY, function () {
          modal.isLoading = false;
          modal.current_variety = null;
          $uibModalInstance.close();
        });
      }, function (error) {
        modal.isLoading = false;
        alertify.error(error);
      });
    };

    init();
  }

  function adminProductGroupModalCtrl($scope, alertify, commonSrv, adminSrv, growerSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.isLoading = true;
    modal.product = config.product;
    modal.tempImage = '';
    modal.exist = false;

    $scope.fileAdded = function (input) {
      modal.tempImage = URL.createObjectURL(input.files[0]);
    };

    function init() {
      modal.verifyImage();
    }

    modal.verifyImage = function () {
      modal.product.image = modal.product.image.split('?')[0];
      common.imageExists(modal.product.image, function () {
        modal.exist = true;
        modal.loading = false;
        modal.product.image = modal.product.image + '?t=' + new Date().getTime();
        $scope.$apply();
      }, function () {
        modal.exist = false;
        modal.loading = false;
      });
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.save = function () {
      if (modal.exist) {
        modal.loading = true;
        var query = common.sbx.insert('product_group', {
          '_KEY': modal.product._KEY,
          'highlight': modal.product.highlight
        });
        /*let query = common.queryBuilder()
          .setModel('product_group')
          .setDomain(common.actual_domain)
          .addObject({
            '_KEY': modal.product._KEY,
            'highlight': modal.product.highlight
          }).compile();*/

        common.method.update(query).then(function () {
          var data = common.response.post_query.data;
          if (data.success) {
            alertify.success('Product group has been updated.');
            modal.close();
          } else {
            alertify.error(data.msg);
          }
          modal.loading = false;
        });
      } else {
        alertify.error('You must upload the product group image first.');
      }
    };

    modal.uploadFile = function () {
      modal.loading = true;
      var myBlob = common.dataURItoBlob(modal.myFile.compressed.dataURL);
      var myFile = new File([myBlob], 'name.jpg');

      var fd = new FormData();
      fd.append('file', myFile, modal.product._KEY + '.jpg');
      fd.append('model', JSON.stringify({ key: common.product_group_folder_key }));

      growerSrv.uploadFileToUrl(fd, function (res) {
        if (res) {
          alertify.success('Product group image successfully uploaded.');
        } else {
          alertify.error('An error has occurred, please try again.');
        }
        modal.loading = false;
        modal.verifyImage();
      });
    };

    init();
  }

  ///
  function adminPackingListCtrl($scope, alertify, commonSrv, adminSrv, environment, $uibModalInstance, config, floristSrv, growerSrv, $http) {

    var modal = this,
        common = commonSrv,
        florist = floristSrv,
        gs = growerSrv;
    modal.isLoading = false;
    modal.all = true;
    modal.logs = '';
    modal.masterGrower = '';
    modal.date = config.date;
    modal.growers = [];
    modal.active = 0;
    modal.error = false;
    modal.totalOrders = 0;
    modal.loading = false;
    modal.grower_selected_csv = '';
    modal.check_grower_selected_csv = false;
    function init() {

      angular.forEach(config.growers, function (value, key) {
        if (value.grower_approved === value.orders) {
          value['selected'] = true;
          // modal.totalOrders += config.isFedex ? value.fedex_orders ? value.fedex_orders : 0 : value.dhl_orders ? value.dhl_orders : 0;
          modal.totalOrders += value.fedex_orders ? value.fedex_orders : 0;
        } else {
          value['selected'] = false;
        }
        modal.growers.push(value);
      });

      florist.getCountriesList(function (data) {
        angular.forEach(data.results, function (item) {

          modal.growers.forEach(function (element) {
            if (item._KEY === element.country) {
              element.country = item;
            }
          });
        });
      }, function (err) {
        alertify.error(err);
      });
    }

    modal.toggleMasterGrower = function (key) {
      modal.masterGrower = key;
    };
    modal.convertArrayBuffer = function (item) {

      var buf = new ArrayBuffer(item.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < item.length; i++) {
        view[i] = item.charCodeAt(i) & 0xFF;
      }return buf;
    };

    modal.generateExcel = function (item) {

      var wb = XLSX.utils.book_new();
      wb.SheetNames.push('Packing_list');
      var tableCartboxes = modal.generateTableCartboxes(item);
      var tableTotalShipment = Object.entries(modal.growerByCountries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            growerName = _ref2[0],
            arrayGrower = _ref2[1];

        var sortedGrowers = _.flatten(Object.values(arrayGrower)).sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });

        return modal.generateTableTotalShipment(growerName, sortedGrowers).concat(['']);
      });

      var dataTable = _.flatten(tableTotalShipment).concat([['Breakdown']]).concat(tableCartboxes);

      var ws = XLSX.utils.aoa_to_sheet(dataTable);

      wb.Sheets['Packing_list'] = ws;
      var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      saveAs(new Blob([modal.convertArrayBuffer(wbout)], { type: 'application/octet-stream' }), 'packing_list.xlsx');
    };

    modal.convertArrayBuffer = function (item) {

      var buf = new ArrayBuffer(item.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i < item.length; i++) {
        view[i] = item.charCodeAt(i) & 0xFF;
      }return buf;
    };

    modal.growerByCountries = function () {
      return modal.growers.reduce(function (obj, item) {
        if (!(item.country.country in obj)) {
          obj[item.country.country] = {
            growers: [item]
          };
        } else {
          obj[item.country.country].growers.push(item);
        }

        return obj;
      }, {});
    };

    modal.generateTableTotalShipment = function (growerName, array) {

      var head = [['Total shipment ' + (growerName ? growerName : '') + ':']];
      if (!array.length) return;
      var dataCsv = array.map(function (item) {

        var props = {};
        props.grower = item.name;
        props.value = item.orders;

        return props;
      });

      for (var item = 0; item < dataCsv.length; item++) {
        var cartbox = dataCsv[item];
        head.push([cartbox.grower, cartbox.value + ' ' + 'boxes']);
      }

      var total = array.reduce(function (a, b) {
        return a + b.orders;
      }, 0) + ' ' + 'boxes';
      var totalOrders = ['Totally', total];
      head.push(totalOrders);

      return head;
    };

    modal.generateTableCartboxes = function (array) {

      var head = [['Grower', 'Customer', 'Box type', 'Order #', 'Carrier info', 'Product group', 'Variety', 'Length', '# Bunches', 'Master grower']];

      var dataCsv = [];
      var box = _.flatten(modal.generateArrayCartbox(array));
      if (!box.length) return;

      dataCsv = box.map(function (item) {

        var stems_per_bunch = void 0,
            total_stems = void 0,
            variety = void 0;

        if (item.custom_item) {
          stems_per_bunch = item.stems_per_bunch.stems_per_bunch;
          total_stems = item.quantity * stems_per_bunch;
          variety = item.variety.variety_name + ' ' + '(' + item.variety.color.color_name + ')';
        } else if (item.custom) {
          variety = item.variety.variety_name + ' ' + '(' + item.variety && item.variety.color[0] && item.variety.color[0].hasOwnProperty("color_name") ? item.variety.color[0].color_name : '' + ')';
        } else {
          stems_per_bunch = item.items[0].stems_per_bunch.stems_per_bunch;
          total_stems = item.items[0].quantity * stems_per_bunch;
          variety = item.items[0].variety.variety_name + ' ' + '(' + item.items[0].variety.color.color_name + ')';
        }

        var props = {};
        props.grower = item.custom_item ? '' : item.grower.name;
        props.customer = item.custom_item ? '' : item.customer.company_name;
        props.box_type = item.custom_item ? '' : item.box.box_name + item.box.box_length + ' ' + '*' + item.box.box_width + '*' + item.box.box_heigth;
        props.consecutive = item.consecutive;
        props.carrier_info = item.shipment_status ? item.shipment_status : '';
        props.product_group = item.product_group.common_name;
        props.variety = variety;
        props.length = item.length ? item.length + ' ' + 'cm' : item.box.fixed_length + ' ' + 'cm';
        props.bunches = item.custom ? '' : total_stems / stems_per_bunch;
        props.masterGrower = item.grower.name;

        return props;
      });

      for (var item = 0; item < dataCsv.length; item++) {
        var cartbox = dataCsv[item];

        head.push([cartbox.grower, cartbox.customer, cartbox.box_type, cartbox.consecutive, cartbox.carrier_info, cartbox.product_group, cartbox.variety, cartbox.length, cartbox.bunches, cartbox.masterGrower]);
      }

      return head;
    };

    modal.generateArrayCartbox = function (array) {
      return array.map(function (item) {
        var box = [];

        if (item.custom) {
          box.push(item);
          item.items.map(function (article) {
            var _box$push;

            box.push((_box$push = {
              cart_box_item_key: article._KEY,
              grower: "",
              consecutive: "",
              box: "",
              product_group: article.product_group,
              box_only: article.variety.box_only,
              customizable: true,
              variety: article.variety,
              length: article.masterlist && article.masterlist.length,
              stems_per_bunch: article.stems_per_bunch,
              uom: article.uom,
              quantity: article.quantity
            }, _defineProperty(_box$push, 'uom', article.per_uom), _defineProperty(_box$push, 'customer', ""), _defineProperty(_box$push, 'inventory', article.inventory), _defineProperty(_box$push, 'custom_item', true), _defineProperty(_box$push, 'shipment_status', ""), _box$push));
          });
        } else {

          box.push(item);
        }
        return box;
      });
    };

    // Función para dividir los growers en bloques de 2
    function chunkArray(array, chunkSize) {
      var result = [];
      for (var i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    }

    // Función para procesar cada lote de growers
    function processGrowerChunk(chunk, paramsTemplate) {
      var params = Object.assign({}, paramsTemplate, {
        growers: chunk
      });

      return common.method.run({
        key: environment.cloudscript.OrderGeneratorGrouping,
        params: params
      });
    }

    // Fallback para procesar growers uno por uno en caso de fallo
    function fallbackProcessSingleGrower(grower, paramsTemplate) {
      var params = Object.assign({}, paramsTemplate, {
        growers: [grower] // Pasamos solo un grower
      });

      return common.method.run({
        key: environment.cloudscript.OrderGeneratorGrouping,
        params: params
      });
    }

    // Función para procesar growers en lotes de 2, con fallback
    function processGrowersInChunks(growers, paramsTemplate) {

      var growersChunks = chunkArray(growers, 2);
      var allResponses = [];

      // Usamos una Promise para ejecutar las llamadas secuenciales
      return growersChunks.reduce(function (promise, chunk) {
        return promise.then(function () {
          return processGrowerChunk(chunk, paramsTemplate);
        }).then(function (response) {
          if (!response.success) {
            throw new Error('Failed download. Selected an available master grower');
          }
          allResponses.push(response);
          return allResponses;
        }).catch(function (err) {
          console.log('Error en el lote con growers: ' + chunk + '. Intentando uno por uno.');

          // Si falla el lote, intentamos uno por uno
          return chunk.reduce(function (singlePromise, grower) {
            return singlePromise.then(function () {
              return fallbackProcessSingleGrower(grower, paramsTemplate);
            }).then(function (singleResponse) {
              if (!singleResponse.success) {
                throw new Error('Failed download on single grower.');
              }
              allResponses.push(singleResponse);
              return allResponses;
            });
          }, Promise.resolve()); // Empezamos con una promesa resuelta para procesar uno por uno
        });
      }, Promise.resolve()); // Iniciamos con una promesa resuelta
    }

    modal.generateExcelPackingList = function () {

      var growers = modal.growers.reduce(function (acc, grower) {

        if (grower._KEY && grower.selected) {
          acc.push(grower._KEY);
        }
        return acc;
      }, []);

      var params = {
        // growers,
        main_grower: modal.masterGrower,
        date: modal.date,
        download: true,
        sendEmail: false
      };

      modal.loading = true;
      alertify.log('Download process is starting, please wait for some moments.');

      processGrowersInChunks(growers, params).then(function (allResponses) {
        var cartboxes = [];
        // Al final puedes trabajar con todas las respuestas acumuladas
        allResponses.forEach(function (response) {
          if (response && response.success) {
            cartboxes = cartboxes.concat(response.box.cart_box.filter(function (box) {
              return box._KEY;
            }));
          }
        });

        $scope.$apply(function () {
          modal.loading = false;
        });

        modal.generateExcel(cartboxes.sort(function (a, b) {
          return a.grower.company_name.localeCompare(b.grower.company_name);
        }));
        alertify.success('Download successful');
      }).catch(function (err) {
        $scope.$apply(function () {
          modal.loading = false;
        });
        alertify.error('An error has occurred ');
      });

      // common.method
      //   .run({
      //     key: environment.cloudscript.OrderGeneratorGrouping,
      //     params,
      //   })
      //   .then(function (response) {
      //     console.log(response)
      //
      //     if (response.success) {
      //       modal.loading = false;
      //       modal.generateExcel(response.box.cart_box)
      //       // console.log("No llega")
      //       alertify.success('Download successful');
      //     } else {
      //       modal.loading = false;
      //       alertify.error('Failed download. Selected an available master grower');
      //     }
      //   })
      //   .catch(function (err) {
      //     modal.loading = false;
      //     console.log(err)
      //     alertify.error('An error has occurred on the server');
      //   });

    };
    modal.toggleMasterGrower = function (key) {

      modal.masterGrower = key;
    };

    modal.toggleAll = function (check) {
      modal.totalOrders = 0;
      modal.growers.forEach(function (item) {
        if (item.grower_approved === item.orders) {
          item.selected = modal.all;
          if (check) {
            modal.totalOrders += item.orders;
          }
        }
      });
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.checkGrowers = function (check, orders) {
      if (check) {
        modal.totalOrders += orders;
      } else {
        modal.totalOrders -= orders;
      }
    };

    modal.sendToMe = function () {
      // if(!modal.masterGrower){
      //   modal.error=true;
      //   return
      // }else{
      //   modal.error=false;
      // }
      var filterGrowerSelected = modal.growers.filter(function (item) {
        return item.selected;
      });

      var growers = filterGrowerSelected.reduce(function (acc, grower) {
        if (grower._KEY) {
          acc.push(grower._KEY);
        }
        return acc;
      }, []);
      var params = {
        growers: growers,
        main_grower: modal.masterGrower,
        date: modal.date
      };

      modal.active = 1;
      adminSrv.sendPackingListEmail(filterGrowerSelected, modal.date, function () {
        modal.logs = 'Email sent.\n' + modal.logs;
      });
      ////

      common.method.run({
        key: environment.cloudscript.OrderGeneratorGrouping,
        params: params
      }).then(function (response) {

        if (response.success) {
          alertify.success('The email has been sent');
        } else {
          alertify.error('Failed to send email.');
        }
      }).catch(function (err) {

        alertify.error('An error has occurred on the server');
      });

      ///
    };

    // ng-change="modal.checkGrowers(grower.selected,grower.fedex_orders ? grower.fedex_orders : 0)"

    modal.send = function (carrier) {

      var grower = common.getUserData();

      var isDutch = grower && grower.data && grower.data.metadata && grower.data.metadata.country && grower.data.metadata.country.country_iso ? grower.data.metadata.country.country_iso === "NL" : grower.grower_company_name === "HDB";

      common.confirmModal({
        title: 'Info',
        msj: 'Are you sure?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {
        modal.isLoading = true;
        modal.active = 1;
        var selected = [];

        if (isDutch) {
          if (!modal.grower_selected_csv) {
            modal.isLoading = false;
            alertify.error('Error: Select a grower to send packing list.');
            return;
          }

          gs.generateDutchCSV({
            email: true,
            date: modal.date,
            grower: modal.grower_selected_csv
          }, function (res) {
            if (res.success) {
              // modal.logs = 'Packing list sent to grower: ' + grower.name + '\n' + modal.logs;
              modal.logs = 'Proccess completed.\n' + modal.logs;
              modal.isLoading = false;
            } else {
              modal.logs = grower.name + ': ERROR OCCURRED!!\n' + modal.logs;
              modal.isLoading = false;
            }
          }, function (error) {
            modal.logs = grower.name + ': ERROR OCCURRED!!\n' + modal.logs;
          });
        } else {
          modal.growers.forEach(function (item) {
            if (item.selected) {
              selected.push(item);
            }
          });

          async.eachSeries(selected, function (grower, cbIter) {
            common.method.run({
              key: environment.cloudscript.orderGenerator,

              params: {
                email: true,
                date: modal.date,
                grower: grower._KEY
              }
            }).then(function (response) {
              if (response.success) {
                modal.logs = 'Packing list sent to grower: ' + grower.name + '\n' + modal.logs;
              } else {
                modal.logs = grower.name + ': ERROR OCCURRED!!\n' + modal.logs;
              }
              cbIter(null);
            }, function (error) {
              modal.logs = grower.name + ': ERROR OCCURRED!!\n' + modal.logs;
              cbIter(null);
            });
          }, function () {
            modal.logs = 'Proccess completed.\n' + modal.logs;
            modal.isLoading = false;
          });
        }
      });
    };

    init();
  }

  function adminCustomsCtrl($scope, alertify, commonSrv, adminSrv, environment, $uibModalInstance, config, $uibModal) {

    var modal = this,
        common = commonSrv;
    modal.isLoading = false;
    modal.all = true;
    modal.logs = '';
    modal.date = config.date;
    modal.growers = [];
    modal.customs = {};
    modal.active = 0;

    modal.growersToEmail = [];
    modal.showGroupEmailButton = false;
    modal.totalOrders = 0;

    function init() {
      modal.isDhl = config.isDhl;
      // console.log(config.growers)
      adminSrv.getCustomsByPacking({ date: config.date, growers: Object.keys(config.growers), isDhl: config.isDhl }, function (res) {
        modal.customs = res;
        // console.log(config.growers)
        angular.forEach(config.growers, function (value, key) {

          var country = value.country._KEY ? value.country._KEY : value.country;

          if (country === environment.country["EC"] || country === environment.country["CO"] || country === environment.country["CR"]) {
            value.hawb = '';

            // console.log("res[value._KEY]", res[value._KEY])
            // console.log("value", value)
            // console.log("\n\n")

            if (res[value._KEY] && res[value._KEY].hawb && !value.hawb) {
              value.hawb = res[value._KEY] ? res[value._KEY].hawb : '';
            }

            var newObj = Object.assign({}, value);
            if (res[value._KEY]) {
              newObj.carrier = res[value._KEY].carrier;
            }

            modal.growers.push(newObj);
          }
        });

        if (modal.growers.length === 0) {
          alertify.error('NOTE: Boxes will not be shipped from outside the US.');
        }
      });
    }

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.trigger = function (grower) {
      modal.isLoading = true;

      var query = common.sbx.with('carrier').andWhereContains('carrier', "fedex").compile();
      common.loadPage(query, 1, function (res) {
        var carrier = res.results[0]._KEY;
        if (!modal.customs[grower._KEY] || !modal.customs[grower._KEY]._KEY) {
          adminSrv.setCustoms([{
            grower: grower._KEY,
            packing_date: modal.date,
            hawb: grower.hawb,
            carrier: carrier,
            date_sent: new Date()
          }], function (keys) {
            modal.customs[grower._KEY] = {
              grower: grower._KEY,
              hawb: grower.hawb,
              carrier: carrier,
              packing_date: grower.packing_date,
              _KEY: keys[0]
            };

            modal.isLoading = false;
            alertify.success("Saved");
          });
        } else {
          adminSrv.updateCustoms([{
            _KEY: modal.customs[grower._KEY]._KEY,
            hawb: grower.hawb,
            carrier: carrier,
            date_sent: new Date()
          }], function () {
            modal.isLoading = false;
            alertify.success("Saved");
          });
        }
      });
    };

    modal.addGrowerKey = function (grower) {
      var orders = grower.fedex_orders ? grower.fedex_orders : 0;

      if (modal.growersToEmail.some(function (growerEmail) {
        return growerEmail.key === grower.key;
      })) {
        modal.growersToEmail = modal.growersToEmail.filter(function (growerKey) {
          return growerKey.key !== grower.key;
        });
        if (modal.growersToEmail.length === 0) {
          modal.showGroupEmailButton = false;
        }
        modal.totalOrders -= orders;
      } else {
        modal.showGroupEmailButton = true;
        modal.totalOrders += orders;
        modal.growersToEmail.push(grower);
      }
    };

    modal.openCustomsGroupModal = function () {
      var modalInstance = config.modalConfig.open({
        templateUrl: 'views/admin/customsGroupEmailModal.html',
        controller: 'adminCustomsGroupCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              closeAllModals: function closeAllModals() {
                return modal.close();
              },
              growers: modal.growersToEmail,
              isDhl: modal.isDhl,
              customs: modal.customs,
              date: modal.date
            };
          }
        }
      });

      modalInstance.result.then(function () {}, function (reason) {
        console.log(reason);
      });
    };

    modal.send = function () {
      common.confirmModal({
        title: 'Info',
        msj: 'Are you sure?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {

        if (modal.growers.some(function (i) {
          return i.hawb && (i.hawb.length < 11 || i.hawb.length > 12);
        })) {
          modal.isLoading = false;
          return alertify.error("HAWB must be 11 or 12 digits long");
        }

        modal.isLoading = true;
        modal.active = 1;
        var toInsert = [],
            toUpdate = [];
        var query = common.sbx.with('carrier').andWhereContains('carrier', "fedex").compile();
        common.loadPage(query, 1, function (res) {
          var carrier = res.results[0]._KEY;

          modal.growers.forEach(function (item) {
            if (item.hawb) {
              if (modal.customs[item._KEY] && item.hawb !== modal.customs[item._KEY].hawb) {
                toUpdate.push({ _KEY: modal.customs[item._KEY]._KEY, hawb: item.hawb, date_sent: new Date(), carrier: carrier });
              } else {
                if (!modal.customs[item._KEY]) {
                  toInsert.push({
                    grower: item._KEY,
                    packing_date: modal.date,
                    hawb: item.hawb,
                    date_sent: new Date(),
                    carrier: carrier
                  });
                }
              }
            }
          });
          async.parallel([function (cbParallel) {
            if (!toInsert.length) {
              return cbParallel();
            }
            adminSrv.setCustoms(toInsert, function (keys) {
              toInsert.forEach(function (item, index) {
                modal.customs[item.grower] = {
                  grower: item.grower,
                  hawb: item.hawb,
                  packing_date: item.packing_date,
                  _KEY: keys[index],
                  carrier: item.carrier
                };
              });
              cbParallel();
            });
          }, function (cbParallel) {
            if (!toUpdate.length) {
              return cbParallel();
            }
            adminSrv.updateCustoms(toUpdate, cbParallel);
          }], function () {
            modal.isLoading = false;
            alertify.success("Saved");
          });
        });
      });
    };

    modal.convertNumberDateToDate = function (number) {
      return common.convertNumberDateToDate(number);
    };

    init();
  }

  function adminCustomsGroupCtrl($scope, alertify, commonSrv, adminSrv, environment, $uibModalInstance, config) {

    var modal = this,
        common = commonSrv;
    modal.growers = [];
    modal.growerSelected = "";
    modal.hawb = "";
    modal.customs = [];
    modal.date = "";
    modal.isDhl = false;

    function init() {
      modal.isDhl = config.isDhl;
      modal.growers = config.growers;
      modal.date = config.date;
      modal.customs = config.customs;
    }

    modal.selectGrower = function (key) {
      modal.growerSelected = key;
    };

    modal.send = function () {
      if (!modal.growerSelected) {
        alertify.error("Please select the grower.");
        return;
      }
      if (!modal.hawb) {
        alertify.error("Please input the hawb code");
        return;
      }

      common.confirmModal({
        title: 'Info',
        msj: 'Are you sure?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {
        if (!modal.customs[modal.growerSelected]) {
          adminSrv.setCustoms([{
            grower: modal.growerSelected,
            packing_date: modal.date,
            hawb: modal.hawb,
            date_sent: new Date(),
            // grower_keys: JSON.stringify(modal.growers.map(grower => grower.key))
            grower_keys: "",
            grower_keys_list: JSON.stringify(modal.growers.map(function (grower) {
              return grower.key;
            }))
          }], function (keys) {
            modal.customs[modal.growerSelected] = {
              grower: modal.growerSelected,
              hawb: modal.hawb,
              packing_date: modal.date,
              _KEY: keys[0],
              // grower_keys: JSON.stringify(modal.growers.map(grower => grower.key))
              grower_keys: "",
              grower_keys_list: JSON.stringify(modal.growers.map(function (grower) {
                return grower.key;
              }))
            };
          });
          alertify.success("Email sent");
        } else {
          adminSrv.updateCustoms([{
            _KEY: modal.customs[modal.growerSelected]._KEY,
            hawb: modal.hawb,
            date_sent: new Date(),
            // grower_keys: JSON.stringify(modal.growers.map(grower => grower.key))
            grower_keys: "",
            grower_keys_list: JSON.stringify(modal.growers.map(function (grower) {
              return grower.key;
            }))
          }], function () {
            modal.isLoading = false;
            alertify.success("Email sent");
          });
        }

        config.closeAllModals();
        modal.close();
      });
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.trigger = function (key) {};

    init();
  }

  function adminProductGroupCtrl($scope, alertify, commonSrv, productSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.isLoading = false;

    modal.product_groups = config.product_groups;
    modal.group_types = config.group_types;

    function init() {}

    modal.typeConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['group_type'],
      placeholder: 'Select group type',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.group_type) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.group_type) + '</span>' + '</div>';
        }
      }
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (modal.adminGroupType.$invalid) {
        modal.isLoading = false;
        // valid = false;

        if (!modal.selectedType) {
          alertify.error('Please assign a Group Type for this product');
          return;
        }

        if (!modal.groupName || modal.groupName.length < 1) {
          alertify.error('Please assign a name for this product');
          return;
        }
      }

      alertify.success(modal.selectedType + ' ' + modal.groupName);
    };
  }

  function adminColorDetailCtrl($scope, alertify, commonSrv, productSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv,
        data = config;
    modal.title = data.config.edit ? 'Edit Color' : 'Add Color';
    modal.isLoading = false;
    modal.hexValid = /^#[0-9A-F]{6}$/i;

    for (var i = 1; i <= 7; i++) {
      modal['option' + i] = {
        format: 'hex',
        placeholder: 'Pick a color ' + i,
        pos: 'top right'
      };

      if (i > 1) {
        modal['option' + i].disabled = true;
      }

      modal['eventApi' + i] = {
        onChange: function onChange(api, color, $event) {
          console.log(api, color, $event);
          this.api.close();
          var elt = api.getElement();
          var modelElt = elt[0].attributes[0].nodeValue.split('.')[1];
          modal[modelElt] = color;
          console.log(modal[modelElt]);
          modal.option2.disabled = modal.myColor1 ? false : true;
          modal.option3.disabled = modal.myColor2 ? false : true;
          modal.option4.disabled = modal.myColor3 ? false : true;
          modal.option5.disabled = modal.myColor4 ? false : true;
          modal.option6.disabled = modal.myColor5 ? false : true;
          modal.option7.disabled = modal.myColor6 ? false : true;
          if (!modal.myColor1) {
            for (var i = 2; i <= 7; i++) {
              modal['option' + i].disabled = true;
              modal['myColor' + i] = '';
            }
          } else if (!modal.myColor2) {
            for (var i = 3; i <= 7; i++) {
              modal['option' + i].disabled = true;
              modal['myColor' + i] = '';
            }
          } else if (!modal.myColor3) {
            for (var i = 4; i <= 7; i++) {
              modal['option' + i].disabled = true;
              modal['myColor' + i] = '';
            }
          } else if (!modal.myColor4) {
            for (var i = 5; i <= 7; i++) {
              modal['option' + i].disabled = true;
              modal['myColor' + i] = '';
            }
          } else if (!modal.myColor5) {
            for (var i = 6; i <= 7; i++) {
              modal['option' + i].disabled = true;
              modal['myColor' + i] = '';
            }
          } else if (!modal.myColor6) {
            modal.option7.disabled = true;
            modal.myColor7 = '';
          }
        }
      };
    }

    if (data.config.dataColor) {
      modal.dataColor = data.config.dataColor;
      modal.colorName = modal.dataColor.color_name;
      modal.myColor1 = modal.dataColor.html_code_1;
      modal.myColor2 = modal.dataColor.html_code_2;
      modal.myColor3 = modal.dataColor.html_code_3;
      modal.myColor4 = modal.dataColor.html_code_4;
      modal.myColor5 = modal.dataColor.html_code_5;
      modal.myColor6 = modal.dataColor.html_code_6;
      modal.myColor7 = modal.dataColor.html_code_7;

      modal.option2.disabled = modal.myColor1 ? false : true;
      modal.option3.disabled = modal.myColor2 ? false : true;
      modal.option4.disabled = modal.myColor3 ? false : true;
      modal.option5.disabled = modal.myColor4 ? false : true;
      modal.option6.disabled = modal.myColor5 ? false : true;
      modal.option7.disabled = modal.myColor6 ? false : true;
      // modal.option7.disabled = modal.myColor7 ? false : true;
    }

    modal.extraOptions = {
      format: 'hex',
      placeholder: 'Pick a color'
    };

    modal.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    modal.save = function () {
      modal.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (modal.adminColorDetail.$invalid) {
        modal.isLoading = false;
        // valid = false;

        if (!modal.colorName) {
          alertify.error('Please assign a name for this color');
          return;
        }

        if (!modal.myColor1) {
          alertify.error('Please choose a color');
          return;
        }

        // if(!modal.hexValid.test(modal.myColor)){
        //   alertify.error("Please choose a valid color");
        //   return;
        // }
      }

      var color = {
        color_name: modal.colorName,
        html_code_1: modal.myColor1,
        html_code_2: modal.myColor2 ? modal.myColor2 : null,
        html_code_3: modal.myColor3 ? modal.myColor3 : null,
        html_code_4: modal.myColor4 ? modal.myColor4 : null,
        html_code_5: modal.myColor5 ? modal.myColor5 : null,
        html_code_6: modal.myColor6 ? modal.myColor6 : null,
        html_code_7: modal.myColor7 ? modal.myColor7 : null
      };

      if (data.config.edit) {
        color._KEY = modal.dataColor._KEY;
      }

      productSrv.saveColor(color, function (response) {
        modal.isLoading = false;
        $uibModalInstance.close();
        alertify.success(response);
      }, function (error) {
        modal.isLoading = false;
        alertify.error(error);
      });
    };
  }

  function adminClaimModalCtrl($scope, alertify, commonSrv, adminSrv, $uibModalInstance, config, floristSrv, $state, environment) {
    var modal = this,
        common = commonSrv,
        fs = floristSrv;
    modal.claim = config.claim;
    modal.claim.folderList = [];
    modal.isLoading = true;
    modal.loading = {};
    modal.showRevertButton = false;
    modal.imageNotFount = false;
    modal.deleteImageLoading = {};
    modal.previewFailed = {};
    modal.previewUrlByKey = {};

    function init() {
      modal.showRevertButton = common.getUserData().ibf_role === "SUPPORT" || common.getUserData().ibf_role === "ADMIN";
      modal.claim.incl_cost = !modal.claim.cart_box.grower.excl_transport_cost;

      if (!modal.claim.show_no_shipping_price && !modal.claim.incl_cost && modal.claim.total_claim_grower) {
        modal.claim.total_grower_no_shipping = modal.claim.total_claim_grower;
      }

      modal.claim.reasons = [];
      adminSrv.getClaimReasons(modal.claim._KEY, function (data) {
        if (data.length) {
          modal.claim.reasons = data.map(function (item) {
            return item.claim_reason.claim_reason;
          });
        }
      });

      common.method.run({
        key: environment.cloudscript.ibf_getClaim,

        params: {
          claim: modal.claim._KEY
        }
      }).then(function (response) {

        if (response.success && response.data && response.data.images) {

          if (response.data.images.length > 0) {
            modal.claim.folderList = response.data.images.map(function (image) {
              modal.loading[image.url] = true;
              return {
                url: image.url,
                key: image.key,
                content_type: image.content_type || image.mime_type || image.type || ''
              };
            });
          } else {
            modal.imageNotFount = true;
          }
        } else {
          modal.imageNotFount = true;
        }

        modal.isLoading = false;
      }, function (error) {
        modal.isLoading = false;
        modal.imageNotFount = true;
      });

      // var params = {key: modal.claim.claim_folder};
      // adminSrv.folderList(params, function (data) {
      //   modal.claim.folderList = data.map(image => {
      //     const baseUrl = commonSrv.actual_base_url;
      //     const imageUrl = `${baseUrl}/claims/${modal.claim._KEY}/${image.name}`;
      //     const loadingKey = imageUrl;
      //
      //     modal.loading[loadingKey] = true;
      //
      //
      //     return {
      //       url: imageUrl,
      //       key: image.key
      //     };
      //   });
      //
      //   if (!data.length) {
      //     modal.isLoading = false;
      //     modal.imageNotFount = true;
      //   }
      // }, function (error) {
      //   console.log(error);
      // })
    }

    modal.getClaimRoute = function (route) {
      var baseRoute = common.getUserData().ibf_role === 'ADMIN' ? 'admin.' : 'country.';
      return baseRoute + route;
    };

    modal.setClaimStatus = function () {
      modal.isLoading = true;
      fs.revertClaimStatus("Pending", modal.claim, function () {
        alertify.success('Request Claim Updated');
        modal.close();
        $state.go(modal.getClaimRoute("claims.pending"));
        modal.isLoading = false;
      }, function (error) {
        modal.isLoading = false;
        alertify.error(error);
      });
    };

    modal.deleteClaim = function (claim_key) {
      common.confirmModal({
        title: 'Unlock claim',
        msj: 'Are you sure to unlock this claim?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {
        var delete_claim = {
          'domain': common.actual_domain,
          'row_model': 'request_claim',
          'where': {
            'keys': [claim_key]
          }
        };
        modal.isLoading = true;
        common.method.query(common.urls.delete, delete_claim).then(function () {

          var res = common.response.post_query.data;

          if (res.success) {
            modal.isLoading = false;
            config.getClaims();
            alertify.success('The claim has been successfully unlocked');
            modal.close();
          } else {
            modal.isLoading = false;
            alertify.error('The claim could not be unlocked');
          }
        });
      });
    };

    modal.isVideo = function (item) {
      if (!item) return false;
      var url = item.url || item;
      var ct = item.content_type || '';
      if (ct && ct.indexOf('video') !== -1) return true;
      return (/\.(mp4|mov|avi|webm|ogg|mkv|flv|wmv|m4v)/i.test(decodeURIComponent(url))
      );
    };

    modal.fileExt = function (item) {
      if (!item) return '';
      var url = decodeURIComponent(item.url || item);
      var filenameMatch = /filename\*?=["']?([^"';]+)/i.exec(url);
      var name = filenameMatch ? filenameMatch[1] : url.split('?')[0];
      var extMatch = /\.([a-z0-9]+)$/i.exec(name);
      return extMatch ? extMatch[1].toUpperCase() : '';
    };

    modal.previewUrl = function (url) {
      if (!url || !environment.imageProxyUrl) {
        return url;
      }
      return environment.imageProxyUrl + '?url=' + encodeURIComponent(url);
    };

    modal.openPreview = function (item) {
      var previewUrl = item && modal.previewUrlByKey[item.url];
      if (previewUrl) {
        window.open(previewUrl, '_blank');
      }
    };

    modal.videoLoading = {};

    modal.initVideo = function (index, url) {
      modal.videoLoading[index] = true;
      setTimeout(function () {
        var el = document.getElementById('claim-video-' + index);
        if (!el) return;
        var done = function done() {
          $scope.$applyAsync(function () {
            modal.videoLoading[index] = false;
          });
        };
        el.addEventListener('loadedmetadata', done, { once: true });
        el.addEventListener('error', done, { once: true });
        el.src = url;
        el.load();
      }, 0);
    };

    modal.getImageClaim = function (item, index) {
      var url = item.url;

      function fail() {
        $scope.$applyAsync(function () {
          modal.previewFailed[url] = true;
          delete modal.loading[url];
        });
      }

      // Reading the S3 URL with XHR is blocked by CORS, so the image is loaded
      // straight from the proxy, which also strips the attachment disposition.
      var previewUrl = modal.previewUrl(url);
      modal.previewUrlByKey[url] = previewUrl;

      return new Promise(function (resolve) {
        setTimeout(resolve, (index + 1) * 700);
      }).then(function () {
        var imgs = document.getElementById(url);
        if (!imgs) {
          fail();
          return;
        }

        imgs.onload = function () {
          $scope.$applyAsync(function () {
            delete modal.loading[url];
          });
        };
        imgs.onerror = fail;
        imgs.src = previewUrl;
      });
    };

    modal.deleteImage = function (image) {
      var key = image.key;
      var url = '/content/v1/delete?key=' + key;
      common.confirmModal({
        title: 'Delete image',
        msj: 'Are you sure to delete this image?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {
        modal.deleteImageLoading[image.url] = true;

        common.method.post(url).then(function () {

          var response = common.response.post.data;

          if (response.success) {
            modal.deleteImageLoading[image.url] = false;
            alertify.success('The image has been successfully removed');
            modal.claim.folderList = modal.claim.folderList.filter(function (item, i) {
              return item.key != response.key;
            });
          } else {
            modal.deleteImageLoading[image.url] = false;
            alertify.error(response.error);
          }
        });
      });
    };

    modal.editClaim = function () {
      // window.location.href = '/admin/#/claim/update/'+modal.claim._KEY
      window.open('/admin/#/claim/update/' + modal.claim._KEY);
    };

    modal.setTotalClaim = function (incl_cost) {

      adminSrv.setTotalClaimGrower(modal.claim, incl_cost, function (res) {

        if (res.success) {
          config.getClaims();
          alertify.success('Total claim updated!');
          modal.close();
        } else {
          alertify.success('Total claim could not be edited!');
        }
      });
    };

    modal.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminModals.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminGrowerCtrl', ['$scope', '$filter', 'alertify', 'commonSrv', '$state', '$stateParams', '$uibModal', 'growerSrv', adminGrowerCtrl]);

  function adminGrowerCtrl($scope, $filter, alertify, commonSrv, $state, $stateParams, $uibModal, growerSrv) {

    var obj = this,
        common = commonSrv,
        gs = growerSrv;

    function init() {
      obj.loadUsers();
    }

    obj.grower_page = {
      page: 1,
      size: 50,
      total: 1,
      total_items: 1
    };

    $scope.$watch('obj.searchText', function () {
      obj.filteredGrowers = $filter('objectFilter')(obj.growers, obj.searchText, ['company_name', 'city', 'phone_number', 'email_address', 'first_name', 'last_name']);
      obj.grower_page.total_items = obj.filteredGrowers.length;
      obj.grower_page.total = Math.round(obj.filteredGrowers.length / obj.filteredGrowers.size);
      obj.grower_page.page = 1;
      obj.growerPerPage();
    });

    obj.loadGrowers = function () {

      var query = commonSrv.sbx.with('grower').setPage(obj.grower_page.page).fetchModels(['city_ref', 'country']).setPageSize(obj.grower_page.size).compile();
      /*const query = commonSrv.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('grower')
        .setPage(obj.grower_page.page)
        .fetchModels(['city_ref', 'country'])
        .setPageSize(obj.grower_page.size)
        .compile();*/

      common.loadAllPages(query, function (data) {
        obj.growers = $filter('orderBy')(data.results, 'company_name');
        var fetched_results = data.fetched_results;
        obj.growers.forEach(function (gr) {
          gr.city_ref = fetched_results.city[gr.city_ref];
          gr.country = fetched_results.country[gr.country];
          if (obj.contactMap[gr._KEY]) {
            gr.first_name = obj.contactMap[gr._KEY].first_name;
            gr.last_name = obj.contactMap[gr._KEY].last_name;
          }
        });

        obj.filteredGrowers = obj.growers.slice(0);
        obj.grower_page.total_items = obj.filteredGrowers.length;
        obj.grower_page.total = Math.round(obj.filteredGrowers.length / obj.filteredGrowers.size);
        obj.grower_page.page = 1;
        obj.growerPerPage();
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.growerPerPage = function () {
      var begin = (obj.grower_page.page - 1) * obj.grower_page.size,
          end = begin + obj.grower_page.size;
      obj.growers_page = obj.filteredGrowers.slice(begin, end);
    };

    obj.loadUsers = function () {
      //.addCondition("AND", "product_group", "=", variety.product_group._KEY)
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'user',
        'size': 1000,
        'where': [{
          'ANDOR': 'AND',
          'GROUP': [{
            'ANDOR': 'AND',
            'FIELD': 'role',
            'OP': '=',
            'VAL': 'GROWER'
          }]
        }]
      };

      common.method.query(common.urls.find, query).then(function () {

        obj.contacts = common.response.post_query.data.results;

        obj.contactMap = common.toMap(obj.contacts, 'contactos', 'grower');
        obj.loadGrowers();
      });
    };

    obj.add_grower = function () {
      $state.go('admin.add_grower');
    };

    obj.edit_grower = function (grower) {
      $state.go('admin.add_grower', {
        grower: grower,
        user: obj.contactMap[grower._KEY]
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminGrowerCtrl.js.map

'use strict';

(function (angular) {
    angular.module('ibf').controller('adminCustomersCtrl', ['$scope', 'alertify', 'commonSrv', 'growerSrv', '$uibModal', adminCustomersCtrl]).controller('adminCustomersDetailCtrl', ['$scope', '$state', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$uibModalInstance', 'config', adminCustomersDetailCtrl]).controller('adminCustomersAccManagerCtrl', ['$scope', '$state', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$uibModalInstance', 'config', adminCustomersAccManagerCtrl]);

    function adminCustomersCtrl($scope, alertify, commonSrv, growerSrv, $uibModal) {

        var obj = this,
            common = commonSrv,
            grower = growerSrv;

        obj.optionsFilter = [{ id: 1, type: 'name' }, { id: 2, type: 'state' }, { id: 3, type: 'margin' }];

        function init() {
            obj.loadCustomers();
            obj.loadUsers();
        }

        obj.filterConfig = {
            create: false,
            highlight: true,
            valueField: 'id',
            delimiter: '|',
            searchField: ['type'],
            placeholder: 'Filter by',
            maxItems: 1,
            render: {
                option: function option(data, escape) {
                    return '<div class="option">' + '<span class="title">' + escape(data.type) + '</span>' + '</div>';
                },
                item: function item(data, escape) {
                    return '<div class="item">' + '<span class="item">' + escape(data.type) + '</span>' + '</div>';
                }
            }
        };

        obj.addCustomer = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/admin/customerModal.html',
                controller: 'adminCustomersDetailCtrl',
                controllerAs: 'modal',
                bindToController: true,
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    config: function config() {
                        return {
                            item: null
                        };
                    }
                }
            });
            modalInstance.result.then(function (data) {});
        };

        obj.accountManager = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/admin/customer.account_manager.html',
                controller: 'adminCustomersAccManagerCtrl',
                controllerAs: 'modal',
                bindToController: true,
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    config: function config() {
                        return {
                            item: null
                        };
                    }
                }
            });
            modalInstance.result.then(function (data) {});
        };

        obj.loadCustomers = function () {
            var query = common.sbx.with('customer').fetchModels(['state', 'country', 'time_zone']).setPage(1).setPageSize(1000).compile();
            /*var query = common.queryBuilder()
                .setDomain(common.actual_domain)
                .setModel('customer')
                .fetchModels(['state', 'country', 'time_zone'])
                .setPage(1)
                .setPageSize(1000)
                .compile();*/

            common.method.query(common.urls.find, query).then(function () {
                var response = common.response.post_query.data;
                if (response.results.length > 0) {
                    obj.fetchedResults = response.fetched_results;
                    obj.customers = response.results;
                }
            });
        };

        obj.loadUsers = function () {
            grower.userList(function (res) {
                if (res.data.length > 0) {
                    obj.customerList = common.toMap(res.data, 'floristList', 'user_id');
                }
            }, function (err) {
                alertify.error(err);
            }, 'FLORIST');
        };

        init();
    } //End adminCustomersCtrl

    function adminCustomersDetailCtrl($scope, $state, alertify, commonSrv, productSrv, growerSrv, $uibModalInstance, config) {
        var modal = this,
            common = commonSrv;

        modal.dayHours = {
            hours: [{ hour: '00:00' }, { hour: '01:00' }, { hour: '02:00' }, { hour: '03:00' }, { hour: '04:00' }, { hour: '05:00' }, { hour: '06:00' }, { hour: '07:00' }, { hour: '08:00' }, { hour: '09:00' }, { hour: '10:00' }, { hour: '11:00' }, { hour: '12:00' }, { hour: '13:00' }, { hour: '14:00' }, { hour: '15:00' }, { hour: '16:00' }, { hour: '17:00' }, { hour: '18:00' }, { hour: '19:00' }, { hour: '20:00' }, { hour: '21:00' }, { hour: '22:00' }, { hour: '23:00' }]
        };

        function init() {
            getStates();
            getTimeZones();
            getCountry();
            modal.resaleCertificate = false;
            modal.margin = common.margin_actual;
        }

        function getStates() {
            var query = {
                'domain': common.actual_domain,
                'page': 1,
                'row_model': 'state',
                'size': 1000
            };

            common.method.query(common.urls.find, query).then(function () {
                if (common.response.post_query.data.results) {
                    modal.states = common.response.post_query.data.results;
                    angular.forEach(modal.states, function (element) {
                        element.state += ' (' + element.state_iso + ')';
                    });
                } else {
                    alertify.error('Internal error loading states');
                }
            });
        }

        function getTimeZones() {
            var query = {
                'domain': common.actual_domain,
                'page': 1,
                'row_model': 'time_zone',
                'size': 1000
            };

            common.method.query(common.urls.find, query).then(function () {
                if (common.response.post_query.data.results) {
                    modal.timezones = common.response.post_query.data.results;
                } else {
                    alertify.error('Internal error loading Time zones');
                }
            });
        }

        function getCountry() {
            var query = {
                'domain': common.actual_domain,
                'page': 1,
                'row_model': 'country',
                'size': 1000
            };

            common.method.query(common.urls.find, query).then(function () {
                if (common.response.post_query.data.results) {
                    modal.countries = common.response.post_query.data.results;
                    angular.forEach(modal.countries, function (element) {
                        element.country += ' (' + element.country_iso + ')';
                        if (element.country_iso == 'US') {
                            modal.country = element;
                        }
                    });
                } else {
                    alertify.error('Internal error loading Contries');
                }
            });
        }

        modal.checkState = function () {

            if (modal.state.state_iso == 'NY') {
                common.confirmModal({
                    title: 'Resale Certificate Required',
                    msj: 'Do you have a \'Resale Certificate\'?',
                    saveText: 'Yes',
                    cancelText: 'No'
                }, function () {
                    modal.resaleCertificate = true;
                });
            }
        };

        modal.save = function () {
            var msg = '';
            var valid = true;
            modal.isLoading = true;
            $scope.$broadcast('show-errors-check-validity');
            if (modal.customerForm.$invalid) {
                valid = false;
                msg = 'There are invalid fields';
            }

            if (modal.confirmPassword != modal.password) {
                valid = false;
                msg = 'User Passwords must match.';
            }

            if (modal.confirmEmail != modal.email) {
                valid = false;
                msg = 'User Emails must match.';
            }

            if (valid && modal.state != null && modal.state.state_iso == 'NY' && !modal.resaleCertificate) {
                msg = 'Resale Certificate not provided';
            }

            if (valid) {
                var customer = {
                    company_name: modal.name,
                    street: modal.street,
                    state: modal.state._KEY,
                    zipcode: modal.zip_code,
                    city: modal.city,
                    country: modal.country._KEY,
                    office_phone: modal.office_phone,
                    office_email: modal.office_email,
                    business_hours: modal.hour_from + '-' + modal.hour_to,
                    time_zone: modal.time_zone._KEY,
                    margin: modal.margin
                    // website: modal.website,
                };

                if (modal.state != null && modal.state.state_iso == 'NY') {
                    customer.tax_id = modal.tax;
                }

                var user_info = {
                    first_name: modal.firstName,
                    last_name: modal.lastName,
                    role: 'FLORIST',
                    customer: null,
                    cellphone: modal.cellPhone,
                    user_email: modal.email,
                    is_admin: true,
                    active: true
                };

                modal.customer_query = {
                    'domain': common.actual_domain,
                    'rows': [customer],
                    'row_model': 'customer'
                };

                modal.user_query = {
                    'domain': common.actual_domain,
                    'rows': [user_info],
                    'row_model': 'user'
                };

                common.method.query(common.urls.row, modal.customer_query).then(function () {
                    var response = common.response.post_query.data.keys;
                    var key = response[0];
                    modal.user_query.rows[0].customer = key;
                    modal.registerUser(modal.user_query.rows[0]);
                    modal.createCustomerFolder(key);
                    modal.isLoading = false;
                });
            } else {
                modal.isLoading = false;
                alertify.error(msg);
            }
            // $uibModalInstance.close();
        };

        modal.createCustomerFolder = function (customer_key) {
            common.method.post(common.urls.addFolder, {
                parent_key: common.florist_folder_key,
                name: customer_key
            }).then(function () {

                var response = common.response.post.data;
                if (response.success) {
                    console.log('Customer Folder Created');
                } else {
                    alertify.error(response.error);
                }
            });
        };

        modal.registerUser = function (user) {
            var valid = true,
                msg = '';

            var aux_login_user = user.user_email.replace('@', '.');
            var username = aux_login_user.substr(0, aux_login_user.lastIndexOf('.'));
            var reg = {
                email: user.user_email,
                password: modal.password,
                name: user.first_name + ' ' + user.last_name,
                login: username,
                domain: common.actual_domain
            };

            common.method.get(common.urls.register, reg).then(function () {
                modal.isLoading = false;
                var response = common.response.get.data;
                if (response.success) {
                    modal.user_query.rows[0].user_id = response.user.id;
                    modal.user_info = {
                        user: response.user.id,
                        customer: user.customer
                    };

                    modal.setCustomerAdmin(modal.user_info);
                    modal.saveUser(modal.user_query);
                } else {
                    alertify.error('Cannot register user');
                    var delete_customer = {
                        'domain': common.actual_domain,
                        'row_model': 'customer',
                        'where': {
                            'keys': [user.customer]
                        }
                    };

                    common.method.query(common.urls.delete, delete_customer);
                }
            });
        };

        modal.setCustomerAdmin = function (admin) {
            var query = {
                'domain': common.actual_domain,
                'rows': [{
                    'admin': admin.user,
                    '_KEY': admin.customer
                }],
                'row_model': 'customer'
            };

            common.method.query(common.urls.update, query);
        };

        modal.saveUser = function (query) {
            return common.method.query(common.urls.row, query).then(function () {
                var response = common.response.post_query.data;
                if (response.success) {
                    modal.setAdminPermissions(response.keys[0]);
                }
                //$uibModalInstance.close();
                alertify.success('Customer Created.');
                $state.go('admin.customers');
            });
        };

        modal.setAdminPermissions = function (key) {
            modal.perm = {
                user: key,
                ibuyflowers: true,
                auto_buy: true,
                standing_orders: true,
                purchase_orders: true,
                claims: true,
                accounting: true
            };

            var query = {
                'domain': common.actual_domain,
                'rows': [modal.perm],
                'row_model': 'customer_user_config'
            };

            common.method.query(common.urls.row, query).then(function () {
                var response = common.response.post_query.data;
            });
        };

        modal.close = function () {
            $uibModalInstance.dismiss();
        };

        init();
    }
    function adminCustomersAccManagerCtrl($scope, $state, alertify, commonSrv, productSrv, growerSrv, $uibModalInstance, config) {
        var modal = this,
            common = commonSrv;

        function init() {
            modal.loadCustomers();
        }

        modal.selected = {};

        modal.select = function (customer) {
            if (!modal.selected[customer._KEY]) {
                modal.selected[customer._KEY] = customer;
            } else {
                delete modal.selected[customer._KEY];
            }
        };

        modal.loadCustomers = function () {
            modal.customers = [];
            var query = common.sbx.with('customer').compile();
            /*var query = common.queryBuilder()
                .setDomain(common.actual_domain)
                .setModel('customer')
                .compile();*/

            common.loadAllPages(query, function (response) {
                modal.customers = response.results;
            }, function () {});
        };

        modal.close = function () {
            $uibModalInstance.dismiss();
        };

        modal.save = function () {

            if (!modal.acc_manager) {
                return alertify.error('Please enter a valid account manager email.');
            }

            var customer_array = Object.keys(modal.selected);
            if (!customer_array.length) {
                return alertify.error('Select min. One customer to set account manager.');
            }

            modal.isSaving = true;

            /*var query = common.queryBuilder()
                .setDomain(common.actual_domain)
                .setModel('customer');
             for (var i = 0; i < customer_array.length; i++) {
                var element = customer_array[i];
                query.addObject({
                    '_KEY': element,
                    'acc_manager': modal.acc_manager
                });
            }
            query = query.compile();*/
            var array = [];
            customer_array.forEach(function (customer) {
                array.push({ '_KEY': customer,
                    'acc_manager': modal.acc_manager });
            });
            var query = common.sbx.insert('customer', array);

            common.method.query(common.urls.update, query).then(function () {
                var data = common.response.post_query.data;
                if (data.success) {
                    modal.loadCustomers();
                    alertify.success('Updated Acc. Manager');
                } else {
                    alertify.error(data.msg);
                }
                modal.isSaving = false;
            });
        };

        init();
    }
})(angular);
//# sourceMappingURL=adminCustomersCtrl.js.map

'use strict';

(function (angular) {
	angular.module('ibf').controller('adminPendingAutoBuysCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', adminPendingAutoBuysCtrl]);

	function adminPendingAutoBuysCtrl($scope, alertify, commonSrv, $uibModal) {
		var obj = this,
		    common = commonSrv,
		    fs = floristSrv;
		obj.auto = 'Auto buys controller';
	}
})(angular);
//# sourceMappingURL=adminPendingAutoBuysCtrl.js.map

'use strict';

(function (angular) {
	angular.module('ibf').controller('adminStandingOrdersCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', 'floristSrv', adminStandingOrdersCtrl]);

	function adminStandingOrdersCtrl($scope, alertify, commonSrv, $uibModal, floristSrv) {
		var obj = this,
		    common = commonSrv,
		    fs = floristSrv;

		function init() {
			obj.getOrders();
		}
		/******************************************
   * Get the standing order for the grower
   */
		obj.getOrders = function () {

			fs.getStandingOrders(null, function (data) {
				obj.orders = data.orders;
				obj.order_items = data.collection;
				obj.map = data.map;
			}, function (error) {
				alertify.error(error);
			});
		};

		/******************************************
   * order detail modal
   */
		obj.detail = function (order) {

			console.log(order);
			var detailInstance = $uibModal.open({
				templateUrl: 'views/grower/standingorders.detail.html',
				controller: 'standingOrderDetailCtrl',
				controllerAs: 'obj',
				size: 'lg',
				resolve: {
					config: {
						order: order,
						items: obj.order_items[order.cart_box._KEY]
					}
				}
			});

			detailInstance.result.then(function (data) {});
		};

		init();
	}
})(angular);
//# sourceMappingURL=adminStandingOrdersCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminClaimsCtrl', ['$scope', 'alertify', 'commonSrv', '$state', '$stateParams', adminClaimsCtrl]);

  function adminClaimsCtrl($scope, alertify, commonSrv, $state, $stateParams) {
    var obj = this,
        common = commonSrv;

    function init() {
      obj.activeTab = $stateParams.tab ? obj.tabs[$stateParams.tab] : 0;
    }

    obj.gotoTab = function (tab) {
      $state.go('admin.claims', { tab: tab });
    };

    obj.isCurrent = function (name) {
      return $state.is('admin.claims.' + name);
    };

    obj.getClaimRoute = function (route) {
      var baseRoute = common.getUserData().ibf_role === 'ADMIN' ? 'admin.' : 'country.';
      return baseRoute + route;
    };

    obj.include = function (name) {
      return $state.includes('admin.claims.' + name);
    };

    obj.tabs = {
      'Pending': 0,
      'Done': 1
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminClaimsCtrl.js.map

'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (angular) {
  angular.module('ibf').controller('adminAcceptedClaimsCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'floristSrv', '$uibModal', '$filter', adminAcceptedClaimsCtrl]);

  function adminAcceptedClaimsCtrl($scope, alertify, commonSrv, adminSrv, floristSrv, $uibModal, $filter) {
    var obj = this,
        common = commonSrv;

    obj.claims = [];
    obj.growers = [];
    obj.isLoading = true;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 50;
    obj.filteredClaims = [];
    obj.searchText = '';
    obj.yearsList = common.getYearList(-1, 3);
    obj.monthList = common.getMonthList();

    obj.selectedMonth = new Date().getMonth();
    obj.selectedYear = new Date().getFullYear();
    obj.selectedGrower = 'all';
    obj.arrived = true;

    obj.total_claim = 0;
    obj.total_claim_grower = 0;

    function init() {
      obj.getClaims();
    }

    obj.fedexStripeUpdate = function (claim, type) {

      var query = common.sbx.insert('request_claim', _defineProperty({ _KEY: claim._KEY }, type, claim[type]));

      common.method.update(query).then(function (data) {
        if (data.success) {
          common.salesforceSync({ action: 'update', model: 'request_claim', key: claim._KEY });
          alertify.success('claim updated.');
        } else {
          alertify.error('Error updating, try again.');
        }
      });
    };

    obj.openStride = function (cartbox) {
      window.open('https://dashboard.stripe.com/payments/' + cartbox.charge_code, '_blank');
    };

    obj.openClaim = function (claim) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/claimModal.html',
        controller: 'adminClaimModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              claim: claim,
              getClaims: function getClaims() {
                alertify.log("Loading claims...");
                obj.getClaims();
              }
            };
          }
        }
      });
      modalInstance.result.then();
    };

    obj.getClaims = function () {
      obj.isLoading = true;
      var date = { year: obj.selectedYear, month: obj.selectedMonth, dateType: 'settled_date', arrived: obj.arrived };
      var grower = obj.selectedGrower !== 'all' ? obj.selectedGrower : undefined;
      adminSrv.getClaims('', 'Accepted', date, grower, function (data) {
        var growerMap = {};
        data.forEach(function (item) {
          var grower = item.cart_box.grower;
          growerMap[grower._KEY] = grower;
        });
        Object.keys(growerMap).forEach(function (key) {
          if (key !== 'all' && !obj.growers.some(function (g) {
            return g._KEY === key;
          })) {
            obj.growers.push(growerMap[key]);
          }
        });
        obj.growers = obj.growers.filter(function (g) {
          return g._KEY !== 'all';
        }).sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });
        if (!obj.growers.some(function (g) {
          return g._KEY === 'all';
        })) {
          obj.growers.unshift({ _KEY: 'all', company_name: 'All Growers' });
        }
        obj.claims = data;
        obj.filteredClaims = data;
        obj.totalItems = obj.filteredClaims.length;
        obj.filterList();
        obj.isLoading = false;
      }, function () {
        alertify.error('Error occurred, try again.');
      });
    };

    obj.filterList = function () {
      if (obj.searchText || obj.selectedGrower !== 'all') {
        obj.filteredClaims = $filter('filter')(obj.claims, function (value) {
          var nameCustomer = value.cart_box.customer.company_name.toLowerCase();
          var nameGrower = value.cart_box.grower.name.toLowerCase();
          var claimCons = String(value.consecutive);
          var orderCons = String(value.cart_box.consecutive);
          var prodGroup = value.cart_box_item.product_group.common_name.toLowerCase();
          var variety = value.cart_box_item.variety.variety_name.toLowerCase();
          var uom = value.cart_box_item.uom.uom.toLowerCase();

          return nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || nameGrower.indexOf(obj.searchText.toLowerCase()) !== -1 || claimCons.indexOf(obj.searchText.toLowerCase()) !== -1 || orderCons.indexOf(obj.searchText.toLowerCase()) !== -1 || prodGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.indexOf(obj.searchText.toLowerCase()) !== -1 || uom.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.filteredClaims = obj.claims.slice();
      }

      obj.total_claim = 0;
      obj.total_claim_grower = 0;
      obj.filteredClaims.forEach(function (claim) {
        obj.total_claim += claim.total_claim;
        obj.total_claim_grower += claim.total_claim_grower;
      });

      obj.totalItems = obj.filteredClaims.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminAcceptedClaimsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminVoidClaimsCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'floristSrv', '$uibModal', '$filter', adminVoidClaimsCtrl]);

  function adminVoidClaimsCtrl($scope, alertify, commonSrv, adminSrv, floristSrv, $uibModal, $filter) {
    var obj = this,
        common = commonSrv;

    obj.claims = [];
    obj.isLoading = true;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.isAdmin = false;
    obj.itemsPerPage = 20;
    obj.filteredClaims = [];
    obj.searchText = '';
    obj.yearsList = common.getYearList(-1, 3);
    obj.monthList = common.getMonthList();

    obj.selectedMonth = new Date().getMonth();
    obj.selectedYear = new Date().getFullYear();
    obj.arrived = true;

    function init() {
      obj.getClaims();
      obj.isAdmin = common.getUserData().ibf_role === 'ADMIN';
    }

    obj.editClaim = function (claim) {
      // window.location.href = '/admin/#/claim/update/'+claim._KEY
      window.open('/admin/#/claim/update/' + claim._KEY);
    };

    obj.openClaim = function (claim) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/claimModal.html',
        controller: 'adminClaimModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              claim: claim,
              getClaims: function getClaims() {
                alertify.log("Loading claims...");
                obj.getClaims();
              }
            };
          }
        }
      });
      modalInstance.result.then();
    };

    obj.getClaims = function () {
      var date = { year: obj.selectedYear, month: obj.selectedMonth, dateType: 'claim_dated', arrived: obj.arrived };
      adminSrv.getClaims('', 'Void', date, null, function (data) {
        obj.claims = data;

        obj.filteredClaims = obj.claims.slice();
        obj.totalItems = obj.filteredClaims.length;
        obj.isLoading = false;
      }, function () {
        alertify.error('Error occurred, try again.');
      });
    };

    obj.setClaimState = function (claim, status) {
      obj.isLoading = true;

      floristSrv.setClaimStatus(status, claim, function () {
        obj.isLoading = false;
        alertify.success('Request Claim Updated');
        obj.getClaims();
      }, function (error) {
        alertify.error(error);
      });
    };

    obj.filterList = function () {
      if (obj.searchText) {
        obj.filteredClaims = $filter('filter')(obj.claims, function (value) {
          var nameCustomer = value.cart_box.customer.company_name.toLowerCase();
          var nameGrower = value.cart_box.grower.name.toLowerCase();
          var claimCons = String(value.consecutive);
          var orderCons = String(value.cart_box.consecutive);
          var prodGroup = value.cart_box_item.product_group.common_name.toLowerCase();
          var variety = value.cart_box_item.variety.variety_name.toLowerCase();
          var uom = value.cart_box_item.uom.uom.toLowerCase();
          return nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || nameGrower.indexOf(obj.searchText.toLowerCase()) !== -1 || claimCons.indexOf(obj.searchText.toLowerCase()) !== -1 || orderCons.indexOf(obj.searchText.toLowerCase()) !== -1 || prodGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.indexOf(obj.searchText.toLowerCase()) !== -1 || uom.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.filteredClaims = obj.claims.slice();
      }

      obj.totalItems = obj.filteredClaims.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminVoidClaimsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminPendingClaimsCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'floristSrv', '$uibModal', '$filter', adminPendingClaimsCtrl]);

  function adminPendingClaimsCtrl($scope, alertify, commonSrv, adminSrv, floristSrv, $uibModal, $filter) {
    var obj = this,
        common = commonSrv;

    obj.claims = [];
    obj.isLoading = true;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.isAdmin = false;
    obj.itemsPerPage = 20;
    obj.filteredClaims = [];
    obj.searchText = '';
    obj.yearsList = common.getYearList(-1, 3);
    obj.monthList = common.getMonthList();

    obj.selectedMonth = new Date().getMonth();
    obj.selectedYear = new Date().getFullYear();
    obj.arrived = true;

    function init() {
      obj.getClaims();
      obj.isAdmin = common.getUserData().ibf_role === 'ADMIN';
    }

    obj.editClaim = function (claim) {
      // window.location.href = '/admin/#/claim/update/' + claim._KEY
      window.open('/admin/#/claim/update/' + claim._KEY);
    };

    obj.openClaim = function (claim) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/claimModal.html',
        controller: 'adminClaimModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              claim: claim,
              getClaims: function getClaims() {
                alertify.log("Loading claims...");
                obj.getClaims();
              }
            };
          }
        }
      });
      modalInstance.result.then();
    };

    obj.getClaims = function () {
      var date = { year: obj.selectedYear, month: obj.selectedMonth, dateType: 'claim_dated', arrived: obj.arrived };
      adminSrv.getClaims('', '=', date, null, function (data) {
        obj.claims = data;

        obj.filteredClaims = obj.claims.slice();
        obj.totalItems = obj.filteredClaims.length;
        obj.isLoading = false;
      }, function () {
        alertify.error('Error occurred, try again.');
      });
    };

    obj.setClaimState = function (claim, status) {
      obj.isLoading = true;

      floristSrv.setClaimStatus(status, claim, function () {
        obj.isLoading = false;
        alertify.success('Request Claim Updated');
        obj.getClaims();
      }, function (error) {
        alertify.error(error);
      });
    };

    obj.filterList = function () {
      if (obj.searchText) {
        obj.filteredClaims = $filter('filter')(obj.claims, function (value) {
          var nameCustomer = value.cart_box.customer.company_name.toLowerCase();
          var nameGrower = value.cart_box.grower.name.toLowerCase();
          var claimCons = String(value.consecutive);
          var orderCons = String(value.cart_box.consecutive);
          var prodGroup = value.cart_box_item.product_group.common_name.toLowerCase();
          var variety = value.cart_box_item.variety.variety_name.toLowerCase();
          var uom = value.cart_box_item.uom.uom.toLowerCase();
          return nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || nameGrower.indexOf(obj.searchText.toLowerCase()) !== -1 || claimCons.indexOf(obj.searchText.toLowerCase()) !== -1 || orderCons.indexOf(obj.searchText.toLowerCase()) !== -1 || prodGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.indexOf(obj.searchText.toLowerCase()) !== -1 || uom.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.filteredClaims = obj.claims.slice();
      }

      obj.totalItems = obj.filteredClaims.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminPendingClaimsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminRejectedClaimsCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'floristSrv', '$uibModal', '$filter', adminRejectedClaimsCtrl]);

  function adminRejectedClaimsCtrl($scope, alertify, commonSrv, adminSrv, floristSrv, $uibModal, $filter) {
    var obj = this,
        common = commonSrv;

    obj.claims = [];
    obj.isLoading = true;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.filteredClaims = [];
    obj.searchText = '';
    obj.yearsList = common.getYearList(-1, 3);
    obj.monthList = common.getMonthList();

    obj.selectedMonth = new Date().getMonth();
    obj.selectedYear = new Date().getFullYear();

    function init() {
      obj.getClaims();
    }

    obj.openClaim = function (claim) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/claimModal.html',
        controller: 'adminClaimModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              claim: claim,
              getClaims: function getClaims() {
                alertify.log("Loading claims...");
                obj.getClaims();
              }
            };
          }
        }
      });
      modalInstance.result.then();
    };

    obj.getClaims = function () {
      var date = { year: obj.selectedYear, month: obj.selectedMonth, dateType: 'claim_dated' };
      adminSrv.getClaims('', 'Rejected', date, null, function (data) {
        obj.claims = data;
        obj.filteredClaims = data;
        obj.totalItems = obj.filteredClaims.length;
        obj.isLoading = false;
      }, function () {
        alertify.error('Error occurred, try again.');
      });
    };

    obj.filterList = function () {
      if (obj.searchText) {
        obj.filteredClaims = $filter('filter')(obj.claims, function (value) {
          var nameCustomer = value.cart_box.customer.company_name.toLowerCase();
          var nameGrower = value.cart_box.grower.name.toLowerCase();
          var claimCons = String(value.consecutive);
          var orderCons = String(value.cart_box.consecutive);
          var prodGroup = value.cart_box_item.product_group.common_name.toLowerCase();
          var variety = value.cart_box_item.variety.variety_name.toLowerCase();
          var uom = value.cart_box_item.uom.uom.toLowerCase();
          return nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || nameGrower.indexOf(obj.searchText.toLowerCase()) !== -1 || claimCons.indexOf(obj.searchText.toLowerCase()) !== -1 || orderCons.indexOf(obj.searchText.toLowerCase()) !== -1 || prodGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.indexOf(obj.searchText.toLowerCase()) !== -1 || uom.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.filteredClaims = obj.claims.slice();
      }

      obj.totalItems = obj.filteredClaims.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminRejectedClaimsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminProductCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', adminProductCtrl]);

  function adminProductCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv) {
    var obj = this,
        common = commonSrv;

    function init() {
      obj.activeTab = $stateParams.tab ? obj.tabs[$stateParams.tab] : 0;
    }

    obj.gotoTab = function (tab) {
      $state.go('admin.products', { tab: tab });
    };

    obj.isCurrent = function (name) {
      return $state.is('admin.products.' + name);
    };

    obj.include = function (name) {
      return $state.includes('admin.products.' + name);
    };

    obj.tabs = {
      'product_group': 0,
      'variety': 1,
      'color': 2,
      'group_type': 3,
      'weekly_inventory': 4,
      'inventory': 5,
      'marketing': 6,
      'seasons': 7,
      'update_inventory': 8
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminProductCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminProductInventoryCtrl', ['$scope', 'alertify', '$state', '$stateParams', '$filter', 'commonSrv', 'sessionSrv', 'growerSrv', 'adminSrv', adminProductInventoryCtrl]);

  function adminProductInventoryCtrl($scope, alertify, $state, $stateParams, $filter, commonSrv, sessionSrv, growerSrv, adminSrv) {
    var obj = this,
        today = new Date();

    obj.conditions = {
      start_date: '',
      end_date: '',
      grower: 'all',
      growers: []
    };
    obj.fetched = false;
    obj.loading = false;
    obj.weeks = [];
    obj.growersMap = {};
    obj.productsMap = {};

    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 10;
    obj.pageItems = [];

    obj.weeksItemsPerPage = 6;
    obj.weekPageItems = [];

    obj.startingWeeks = 5;

    obj.masterlistByGrower = {};

    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];
    obj.popup1 = {
      opened: false
    };

    obj.popup2 = {
      opened: false
    };

    obj.open1 = function () {
      obj.popup1.opened = true;
    };

    function getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    obj.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: getMonday(new Date()),
      startingDay: 1
    };

    // Disable weekend selection
    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && date.getDay() !== 1;
    }

    obj.checkDates = function () {
      if (obj.conditions.start_date && obj.conditions.end_date) {
        if (obj.conditions.start_date > obj.conditions.end_date) {
          alertify.error('The end date must be a Friday after the start date.');
          obj.conditions.end_date = null;
        }
      }
    };

    function generateWeeks() {
      obj.weeks = [];
      var currentWeek = obj.conditions.start_date;
      while (currentWeek < obj.conditions.end_date) {
        var _init = currentWeek;
        var end = new Date(_init.getFullYear(), _init.getMonth(), _init.getDate() + 4);
        currentWeek = new Date(_init.getFullYear(), _init.getMonth(), _init.getDate() + 7);
        obj.weeks.push(commonSrv.convertDateToNumberDate(_init) + ' - ' + commonSrv.convertDateToNumberDate(end));
      }
    }

    function addWeekAndDay(date, weeks, days) {
      var date2 = new Date(date);
      return new Date(date2.setDate(date2.getDate() + 7 * weeks + days));
    }

    obj.generate = function () {
      obj.startingWeeks = 5;
      if (!obj.conditions.start_date) return alertify.error('You must fill start date input.');

      obj.conditions.end_date = addWeekAndDay(obj.conditions.start_date, obj.startingWeeks, 4);
      generateWeeks();
      obj.conditions.end_date = addWeekAndDay(obj.conditions.start_date, obj.startingWeeks, 6);

      obj.loading = true;

      adminSrv.getInventory(obj.conditions, function (data) {
        data.results = $filter('orderBy')(data.results, 'week');
        obj.growersInventory = Object.keys(data.fetched_results.grower).map(function (key) {
          var grower = data.fetched_results.grower[key];
          var filtered = data.results.filter(function (item) {
            return item.grower === grower._KEY;
          });
          grower.inventory = {};
          obj.weeks.forEach(function (week) {
            grower.inventory[week] = 0;
          });
          filtered.forEach(function (item) {
            var key = item.week + ' - ' + (item.end_date - 3);
            if (item.quantity) {
              grower.inventory[key] += 1;
            }
          });
          return grower;
        }).sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });

        obj.startingWeeks++;

        obj.getWeekPage();

        obj.totalItems = obj.growersInventory.length;
        obj.getPage();
        obj.loading = false;
      });
    };

    obj.getWeekPage = function () {
      var init = obj.startingWeeks - obj.weeksItemsPerPage;
      var end = obj.weeksItemsPerPage + init;
      obj.weekPageItems = obj.weeks.slice(init, end);
    };

    obj.addPage = function (val) {
      obj.startingWeeks += val;

      if (obj.startingWeeks > obj.weeks.length) {
        var date = obj.conditions.end_date;
        var conditions = {
          grower: obj.conditions.grower,
          start_date: addWeekAndDay(date, 0, 1), //CAMBIAR LAS FECHAS DE PRUEBA DE LUNES A LUNES
          end_date: addWeekAndDay(date, 1, 0) //CAMBIAR LAS FECHAS DE PRUEBA DE LUNES A LUNES
        };

        obj.conditions.end_date = conditions.end_date;

        adminSrv.getInventory(conditions, function (data) {
          data.results = $filter('orderBy')(data.results, 'week');

          var dates = commonSrv.convertDateToNumberDate(conditions.start_date) + ' - ' + commonSrv.convertDateToNumberDate(addWeekAndDay(date, 0, 5));
          obj.weeks.push(dates);
          obj.growersInventory.forEach(function (grower) {
            var filtered = data.results.filter(function (item) {
              return item.grower === grower._KEY;
            });
            grower.inventory[dates] = 0;
            filtered.forEach(function (item) {
              if (item.quantity) {
                grower.inventory[dates] += 1;
              }
            });
          });
          obj.getWeekPage();
        });
      } else if (obj.startingWeeks >= obj.weeksItemsPerPage) {
        obj.getWeekPage();
      }
    };

    obj.getPage = function (apply) {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }
      obj.pageItems = obj.growersInventory.slice(init, end);
      if (apply) {
        $scope.$apply();
      }
    };

    function init() {
      obj.loading = true;

      growerSrv.list(function (res) {
        obj.conditions.growers = res.data;
        obj.conditions.growers.forEach(function (grower) {
          obj.growersMap[grower._KEY] = grower;
        });

        async.parallel([function (cb) {
          var query = commonSrv.sbx.with('variety').fetchModels(['product_group']).compile();
          commonSrv.loadAllPages(query, function (data) {
            obj.varieties = $filter('orderBy')(data.results, 'product_group.common_name');
            obj.productsMap = data.fetched_results.product_group;
            obj.products = Object.keys(obj.productsMap).map(function (key) {
              return obj.productsMap[key];
            });
            cb(null);
          }, function (err) {
            cb(err);
          });
        }, function (cb) {
          var query = commonSrv.sbx.with('add_masterlist').andWhereIsEqual('active', true).andWhereIn('grower', Object.keys(obj.growersMap)).fetchModels(['grower']).compile();
          commonSrv.loadAllPages(query, function (data) {
            Object.keys(data.fetched_results.grower).map(function (key) {
              obj.masterlistByGrower[key] = data.results.filter(function (item) {
                return item.grower === key;
              }).length;
            });
            cb(null);
          });
        }], function (error, data) {
          obj.loading = false;
        });
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminProductInventoryCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminProductWeeklyInventoryCtrl', ['$scope', 'alertify', '$state', '$stateParams', '$filter', 'commonSrv', 'sessionSrv', 'growerSrv', 'adminSrv', 'environment', adminProductWeeklyInventoryCtrl]);

  function adminProductWeeklyInventoryCtrl($scope, alertify, $state, $stateParams, $filter, commonSrv, sessionSrv, growerSrv, adminSrv, environment) {
    var obj = this,
        today = new Date();

    obj.conditions = {
      start_date: '',
      end_date: '',
      grower: 'select',
      growers: [],
      country: '',
      product: '',
      variety: ''
    };

    obj.fetching = false;
    obj.loading = false;
    obj.masterlistByWeek = [];
    obj.weeks = [];
    obj.countries = [];
    obj.masterlist = [];
    obj.masterVarieties = [];
    obj.growers = [];
    obj.varieties = [];
    obj.products = [];
    obj.masterProducts = [];
    obj.countriesMap = {};
    obj.colorMap = {};
    obj.gradeMap = {};
    obj.growersMap = {};
    obj.productsMap = {};
    obj.varietiesMap = {};
    obj.masterlistMap = {};
    obj.masterlistByWeekMap = {};

    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 50;
    obj.pageItems = [];

    obj.weeksItemsPerPage = 9;
    obj.weekPageItems = [];
    obj.currentWeekPage = 0;
    obj.fetchedWeeks = 9;

    obj.format = 'dd-MMMM-yyyy';
    obj.altInputFormats = ['M!/d!/yyyy'];

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        console.log(value);
        if (value && value !== 'all') {
          var pg = obj.productsMap[value];
          if (!pg.loaded) {
            obj.loading = true;
            commonSrv.method.run({
              key: environment.cloudscript.getFromRedisFiltered,
              params: { model: 'variety', filters: [{ key: 'product_group', value: pg._KEY }] }
            }).then(function (res) {
              obj.loading = false;
              if (res.success) {
                pg.loaded = true;
                var varieties = res.results.map(function (item) {
                  item.product_group = _.cloneDeep(pg);
                  obj.varietiesMap[item._KEY] = item;
                  return item;
                }).map(function (item) {
                  item.color = obj.colorMap[item.color];
                  return item;
                });
                obj.masterlist.forEach(function (item) {
                  item.variety = obj.varietiesMap[item.variety];
                });
                obj.varieties = varieties;
                obj.masterVarieties = obj.masterVarieties.concat(varieties).sort(function (a, b) {
                  return a.variety_name.localeCompare(b.variety_name);
                });
                if (obj.conditions.variety) {
                  obj.varietySelectize.setValue('');
                }
                obj.varietySelectize.refreshOptions(false);
              } else {
                return alertify.error('Error occurred, please try again.');
              }
            });
          } else {
            obj.varieties = $filter('filter')(obj.masterVarieties, { product_group: value });
            if (obj.conditions.variety) {
              obj.varietySelectize.setValue('');
            }
            obj.varietySelectize.refreshOptions(false);
          }
        }
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.productSelectize = selectize;
      }
    };

    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument

        obj.varietySelectize = selectize;
      }
    };

    obj.popup1 = {
      opened: false
    };

    obj.open1 = function () {
      obj.popup1.opened = true;
    };

    function getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
          diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    obj.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      minDate: getMonday(new Date()),
      startingDay: 1
    };

    // Disable weekend selection
    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && date.getDay() !== 1;
    }

    function generateWeeks() {
      obj.weeks = [];
      var currentWeek = obj.conditions.start_date;
      while (currentWeek < obj.conditions.end_date) {
        var _init = currentWeek;
        var toCalculate = new Date(_init.getFullYear(), _init.getMonth(), _init.getDate() + 2);
        currentWeek = new Date(_init.getFullYear(), _init.getMonth(), _init.getDate() + 7);
        obj.weeks.push({ label: commonSrv.convertDateToNumberDate(_init), number: toCalculate.getWeek() });
      }
    }

    function addWeekAndDay(date, weeks, days) {
      var date2 = new Date(date);
      return new Date(date2.setDate(date2.getDate() + 7 * weeks + days));
    }

    obj.fetchInventories = function (conditions) {
      obj.loading = true;
      obj.fetching = true;
      var pagedConditions = [];
      var final = new Date(conditions.end_date);
      var init = new Date(conditions.start_date);
      while (init < final) {
        var aux = { start_date: new Date(init), end_date: null };
        aux.end_date = new Date(init.setDate(init.getDate() + 6));
        pagedConditions.push(_.cloneDeep(_.merge(conditions, aux)));
        init.setDate(init.getDate() + 1);
      }
      async.eachSeries(pagedConditions, function (condition, next) {
        adminSrv.getInventoryWithoutFetch(condition, function (data) {
          data.results = $filter('orderBy')(data.results, 'week');

          data.results.forEach(function (item) {
            var m = obj.masterlistMap[item.masterlist];
            if (m.active) {
              var key0 = m.grower._KEY + '_' + m.product_group._KEY;
              var key1 = obj.conditions.product === 'all' ? key0 : m._KEY;
              var key2 = item.week;
              if (!obj.masterlistByWeekMap[key1]) {
                var fp = obj.conditions.product === 'all';
                var grade = m.grade ? '<strong>' + m.grade.grade + '</strong> ' : '';
                var variety = m.variety.variety_name ? m.product_group.common_name + ' ' + m.variety.variety_name + ' ' + m.variety.color.color_name + ' ' + grade + (m.length || 'n/a') + 'cm' : m.search_name;
                var name = !fp ? variety : m.product_group.common_name;
                obj.masterlistByWeekMap[key1] = {
                  growerName: obj.growersMap[item.grower].company_name,
                  name: name,
                  weeks: {},
                  quantity: 0,
                  fromProduct: fp,
                  qpm: {}
                };
              }
              if (!obj.masterlistByWeekMap[key1].qpm[m._KEY]) {
                obj.masterlistByWeekMap[key1].qpm[m._KEY] = 0;
              }
              obj.masterlistByWeekMap[key1].qpm[m._KEY] += 1;
              obj.weeks.forEach(function (week) {
                if (!obj.masterlistByWeekMap[key1].weeks[week.label]) {
                  obj.masterlistByWeekMap[key1].weeks[week.label] = {};
                }
              });
              if (!obj.masterlistByWeekMap[key1].weeks[key2][m._KEY]) {
                obj.masterlistByWeekMap[key1].weeks[key2][m._KEY] = 0;
              }
              obj.masterlistByWeekMap[key1].weeks[key2][m._KEY] += item.quantity;
            }
          });

          obj.masterlistByWeek = Object.keys(obj.masterlistByWeekMap).map(function (key) {
            var item = _.cloneDeep(obj.masterlistByWeekMap[key]);
            item.quantity = Object.keys(item.qpm).length;
            Object.keys(item.weeks).forEach(function (key2) {
              item.weeks[key2] = Object.keys(item.weeks[key2]).reduce(function (current, key3) {
                var aux = item.weeks[key2][key3];
                if (aux) {
                  current.quantity += aux;
                  current.actives += 1;
                }
                return current;
              }, { quantity: 0, actives: 0 });
            });
            return item;
          }).sort(function (a, b) {
            var compare1 = a.growerName.localeCompare(b.growerName);
            var compare2 = a.name.localeCompare(b.name);
            return compare1 === 0 ? compare2 : compare1;
          });
          obj.totalItems = obj.masterlistByWeek.length;
          obj.getWeekPage();
          obj.getPage();
          next();
        });
      }, function () {
        console.log(obj.masterlistByWeekMap);
        console.log(obj.masterlistByWeek);
        obj.loading = false;
        obj.fetching = false;
      });
    };

    obj.generate = function () {
      obj.masterlistByWeekMap = {};
      obj.masterlistByWeek = [];
      obj.currentWeekPage = 0;
      if (!obj.conditions.start_date) return alertify.error('You must fill start date input.');
      if (!obj.conditions.product) return alertify.error('You must fill product group input.');

      obj.conditions.end_date = addWeekAndDay(obj.conditions.start_date, obj.weeksItemsPerPage - 1, 6);
      generateWeeks();

      var conditions = {
        country: obj.conditions.country,
        product: obj.conditions.product,
        variety: obj.conditions.variety,
        grower: obj.conditions.grower,
        growers: obj.conditions.growers.map(function (item) {
          return item._KEY;
        }),
        start_date: obj.conditions.start_date,
        end_date: obj.conditions.end_date
      };

      obj.fetchInventories(conditions);
    };

    obj.getWeekPage = function () {
      var init = obj.fetchedWeeks + obj.currentWeekPage - obj.weeksItemsPerPage;
      var end = obj.weeksItemsPerPage + init;
      obj.weekPageItems = obj.weeks.slice(init, end);
    };

    obj.addPage = function (val) {
      obj.currentWeekPage += val;

      if (obj.fetchedWeeks + obj.currentWeekPage > obj.weeks.length) {
        var date = obj.conditions.end_date;
        var conditions = {
          country: obj.conditions.country,
          product: obj.conditions.product,
          variety: obj.conditions.variety,
          grower: obj.conditions.grower,
          growers: obj.conditions.growers.map(function (item) {
            return item._KEY;
          }),
          start_date: addWeekAndDay(date, 0, 1),
          end_date: addWeekAndDay(date, 1, 0)
        };

        obj.conditions.end_date = conditions.end_date;
        generateWeeks();

        obj.fetchInventories(conditions);
      } else if (obj.fetchedWeeks >= obj.weeksItemsPerPage) {
        obj.getWeekPage();
      }
    };

    obj.getPage = function (apply) {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }
      obj.pageItems = obj.masterlistByWeek.slice(init, end);
      if (apply) {
        $scope.$apply();
      }
    };

    obj.filterGrowersList = function () {
      if (obj.growers.length) {
        obj.conditions.growers = obj.growers.filter(function (grower) {
          return grower.country === obj.conditions.country;
        });
        obj.conditions.grower = 'select';
        // obj.filterProductList();
      }
    };

    obj.getMasterlistByGrower = function () {
      var grower = obj.growersMap[obj.conditions.grower];
      if (!grower.loaded) {
        obj.loading = true;
        commonSrv.method.run({
          key: environment.cloudscript.getFromRedisFiltered,
          params: { model: 'add_masterlist', filters: [{ key: 'grower', value: obj.conditions.grower }] }
        }).then(function (res) {
          obj.loading = false;
          if (res.success) {
            grower.loaded = true;
            var masterlist = res.results.map(function (item) {
              item.grower = obj.growersMap[item.grower];
              item.grade = obj.gradeMap[item.grade];
              // item.variety = obj.varietiesMap[item.variety];
              item.product_group = obj.productsMap[item.product_group];
              obj.masterlistMap[item._KEY] = item;
              return item;
            }).filter(function (item) {
              return item.active && Boolean(item.grower);
            });
            obj.masterlist = obj.masterlist.concat(masterlist);
            obj.filterProductList();
          } else {
            return alertify.error('Error occurred, please try again.');
          }
        });
      } else {
        obj.filterProductList();
      }
    };

    obj.filterProductList = function () {
      var candidates = obj.masterlist.reduce(function (previous, current) {
        var product = current.product_group;
        if (previous[product._KEY]) {
          return previous;
        }
        if (current.grower._KEY === obj.conditions.grower) {
          previous[product._KEY] = product;
        }
        return previous;
      }, {});
      obj.products = Object.keys(candidates).map(function (key) {
        return candidates[key];
      }).sort(function (a, b) {
        return a.common_name.localeCompare(b.common_name);
      });
      obj.products.unshift({ _KEY: 'all', common_name: 'All Products' });
      obj.conditions.product = obj.products[0]._KEY;
    };

    function init() {
      var totalItems = Math.round((screen.availWidth - 570) / 90);
      obj.weeksItemsPerPage = totalItems;
      obj.fetchedWeeks = totalItems;

      obj.loading = true;

      obj.conditions.start_date = getMonday(new Date());

      async.waterfall([function (cb) {
        commonSrv.listCountries(function (data) {
          obj.countries = data.countries;
          obj.countries.forEach(function (country) {
            obj.countriesMap[country._KEY] = country;
          });
          obj.conditions.country = obj.countries[0]._KEY;
          cb(null);
        }, function (err) {
          cb(err);
        });
      }, function (cb) {
        commonSrv.method.run({
          key: environment.cloudscript.loadDependencies,
          params: { includes: ['grower', 'color', 'grade', 'product_group'] }
        }).then(function (res) {
          if (res.success) {
            res = res.results;
            res.grower = res.grower.filter(function (item) {
              return item.active;
            });
            obj.colorMap = commonSrv.arrayToMap(res.color, '_KEY');
            obj.gradeMap = commonSrv.arrayToMap(res.grade, '_KEY');
            obj.growersMap = commonSrv.arrayToMap(res.grower, '_KEY');
            // obj.varietiesMap = commonSrv.arrayToMap(res.variety, '_KEY');
            obj.productsMap = commonSrv.arrayToMap(res.product_group, '_KEY');

            // obj.masterVarieties = res.variety.map(item => {
            //   item.color = obj.colorMap[item.color];
            //   return item;
            // }).sort((a, b) => a.variety_name.localeCompare(b.variety_name));
            obj.masterProducts = res.product_group.sort(function (a, b) {
              return a.common_name && b.common_name && a.common_name.localeCompare(b.common_name);
            });
            obj.growers = res.grower.sort(function (a, b) {
              return a.company_name.localeCompare(b.company_name);
            });

            return cb(null);
          }
          cb(new Error('Error occurred, please try again.'));
        });
      }], function (err, box) {
        obj.loading = false;
        if (err) {
          return alertify.error('Error occurred, please try again.');
        }
        obj.filterGrowersList();
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminProductWeeklyInventoryCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminProductMarketingCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', '$state', '$stateParams', '$uibModal', '$filter', 'environment', adminProductMarketingCtrl]);

  function adminProductMarketingCtrl($scope, alertify, commonSrv, adminSrv, $state, $stateParams, $uibModal, $filter, environment) {
    var obj = this,
        common = commonSrv;

    obj.marketingUrl = environment.v2Url + '#/products/marketing';

    function init() {
      common.method.literalGet(window.location.pathname + 'mail_base.html').then(function (res) {
        obj.htmlBase = res.data;
      });
    }

    init();

    obj.conditions = {
      arrival_date: '',
      customer: environment.dummyCustomer
    };
    obj.popup1 = {
      opened: false
    };
    obj.popup2 = {
      opened: false
    };
    obj.popup3 = {
      opened: false
    };

    obj.open = function (key) {
      obj[key].opened = true;
    };

    obj.isLoading = false;
    obj.fetched = false;
    obj.pageItems = [];
    obj.groups = [];
    obj.masterVarieties = [];
    obj.varieties = [];
    obj.products = [];
    obj.growers = [];
    obj.inventories = [];
    obj.filteredInventories = [];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 10;
    obj.masterlistMapInventory = {};
    obj.htmls = [];

    obj.query = {
      grower: '',
      product: '',
      variety: ''
    };

    obj.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        if (value) {
          obj.varieties = $filter('filter')(obj.masterVarieties, { product_group: value });
        }

        if (obj.query.variety) {
          obj.varietySelectize.setValue('');
        }

        obj.varietySelectize.refreshOptions(false);

        obj.filterList();

        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        obj.productSelectize = selectize;
      }
    };

    obj.varietyConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      searchField: ['variety_name'],
      placeholder: 'Select Variety',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.variety_name) + ' (' + escape(data.color.color_name) + ')' + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        obj.filterList();
        $scope.$apply();
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument

        obj.varietySelectize = selectize;
      }
    };

    obj.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      minDate: new Date()
    };

    obj.dateOptions2 = {
      formatYear: 'yy',
      minDate: new Date()
    };

    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    obj.getPage = function () {
      var init = (obj.currentPage - 1) * obj.itemsPerPage;
      var end = obj.currentPage * obj.itemsPerPage;
      if (end > obj.totalItems) {
        end = obj.totalItems;
      }
      obj.pageItems = obj.filteredInventories.slice(init, end);
    };

    obj.addInventory = function (item) {
      if (!obj.groups[0] || !obj.groups[0].isCreating) {
        obj.groups.unshift({
          items: [],
          arrival_date: common.convertDateToNumberDate(obj.conditions.arrival_date),
          isCreating: true,
          start_date: new Date(obj.conditions.arrival_date),
          end_date: new Date(obj.conditions.arrival_date),
          off: 15
        });
      }
      var element = obj.groups[0].items.find(function (i) {
        return i._KEY === item.masterlist._KEY;
      });
      if (!element) {
        obj.groups[0].items.push({
          _KEY: item.masterlist._KEY,
          name: item.name
        });
        obj.groups[0].items.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      } else {
        alertify.error('Masterlist currently added.');
      }
    };

    obj.removeItem = function (index) {
      obj.groups[0].items.splice(index, 1);
      if (!obj.groups[0].items.length) {
        obj.removeGroup(0);
      }
    };

    obj.removeGroup = function (index) {
      var group = obj.groups[index];
      if (!group.isCreating) {
        obj.isLoading = true;
        adminSrv.removeGroup(group, function (res) {
          if (res.success) {
            obj.groups.splice(index, 1);
            alertify.success('Promo remove successfully.');
          } else {
            alertify.error('Error occurred, please try again.');
          }
          obj.isLoading = false;
        });
      } else {
        obj.groups.splice(index, 1);
      }
    };

    obj.copyText = function (text, successMessage) {
      common.copyToClipboard(text);
      alertify.success(successMessage);
    };

    obj.copyHtml = function (group) {
      var modal = $uibModal.open({
        templateUrl: 'views/admin/product.marketing.generate-html.html',
        controller: 'adminProductMarketingGenerateHtmlCtrl',
        controllerAs: 'obj',
        backdrop: 'static',
        keyboard: false,
        size: 'md'
      });

      modal.result.then(function (texts) {
        group.inventories = [];

        group.items.forEach(function (item) {
          group.inventories.push(obj.masterlistMapInventory[item._KEY]);
        });

        group.inventories = group.inventories.filter(function (item) {
          return !!item;
        }).map(function (item) {
          item.masterlist.variety.product_group = item.masterlist.product_group;
          return item;
        }).sortByVariety('masterlist.variety');

        var packages = group.inventories.reduce(function (acc, item) {
          var key = item.masterlist.variety._KEY + '_' + item.masterlist.product_group._KEY;
          if (!acc[key]) {
            acc[key] = {
              name: item.masterlist.product_group.common_name + ' ' + item.masterlist.variety.variety_name,
              images: item.images,
              lengths: []
            };
          }
          acc[key].lengths.push({
            length: item.masterlist.length + ' ' + (item.masterlist.length !== 'n/a' ? 'cm' : ''),
            stemPrice: $filter('currency')(item.price / item.masterlist.stems_per_bunch.stems_per_bunch * (1 - group.off), '$', 2) + '/ stem',
            bunchPrice: $filter('currency')(item.price * (1 - group.off), '$', 2) + '/ bunch'
          });
          return acc;
        }, {});

        packages = Object.keys(packages).map(function (key) {
          return packages[key];
        });

        if (packages.length) {
          var chunked = _.chunk(packages, 2);
          var rows = chunked.map(function (items) {
            return '<tr>' + items.map(function (item) {
              var lengths = item.lengths.map(function (length) {
                return '<tr style="height: 35px;">\n                            <td class="name-max-width" style="font-weight: bold;">\n                              <span style="color: #23496d;">' + length.length + ' ' + length.stemPrice + ' - ' + length.bunchPrice + '</span>\n                            </td>\n                          </tr>';
              }).join('');

              var component = '\n                  <table style="background-color: white; border-spacing: 0; border: 1px solid #dedede; color: black;">\n                    <tr>\n                      <td style="padding: 0;">\n                        <a href="' + group.url + '" target="_blank">\n                          <div style="background: url(' + common.actual_base_url + '/' + item.images[0] + ') no-repeat; background-size: cover; background-position-y: center;" class="card-max-width"></div>\n                        </a>\n                      </td>\n                    </tr>\n\n                    <tr style="height: 56px;">\n                      <td class="name-max-width" style="height: 56px; font-weight: bold; vertical-align: text-top;">\n                        <a style="color: #00a4bd; font-size: 20px; text-decoration: underline !important; line-height: 1.2;" href="' + group.url + '" target="_blank">\n                          ' + item.name + '\n                        </a>\n                      </td>\n                    </tr>\n\n                    ' + lengths + '\n                  </table>\n                ';
              return '<td>' + component + '</td>';
            }).join('<td class="space-between-sides"></td>') + '</tr>';
          }).join('<td class="space-between-ends"></td>');
          var html = obj.htmlBase;
          var table = '<table><tbody>' + rows + '</tbody></table>';
          html = html.replace('{replace here}', table);
          html = html.replace('{replace header here}', texts.header);
          html = html.replace('{replace footer here}', texts.footer);
          html = html.replace('{replace group url here}', group.url);
          // html = html.replace('{replace phone here}', texts.phone);
          // html = html.replace('{replace name here}', texts.name);
          // html = html.replace('{replace email1 here}', texts.email);
          // html = html.replace('{replace email2 here}', texts.email);
          obj.htmls.push(Object.assign({ id: obj.htmls.length + 1, html: html }, texts));
          common.method.run({
            key: environment.cloudscript.updatePromoEmailTemplate,
            params: { template: html }
          }).then(function (res) {
            if (res.success) {
              alertify.success('Template updated successfully.');
            } else {
              alertify.error(res.error);
            }
          }, function () {
            alertify.error('There was a error, please try again.');
          });
        } else {
          alertify.error('There is not inventory available.');
        }
      });
    };

    obj.saveGroup = function (group) {
      obj.isLoading = true;
      var eta = common.convertDateToNumberDate(obj.conditions.arrival_date);
      adminSrv.saveGroup(group, eta, function (data) {
        if (data.success) {
          adminSrv.getPromoGroups(eta, function (data) {
            obj.isLoading = false;
            if (data.success) {
              obj.groups = data.groups.map(function (group) {
                group.items = Object.keys(group.items).map(function (key) {
                  return group.items[key];
                }).sort(function (a, b) {
                  return a.name.localeCompare(b.name);
                });
                return group;
              });
            } else {
              alertify.error(data.error);
            }
          });
          alertify.success('Promo group created.');
        } else {
          alertify.error('Error occurred, please try again.');
          obj.isLoading = false;
        }
      });
    };

    obj.getInventory = function () {
      obj.isLoading = true;
      obj.inventories = [];
      obj.filteredInventories = [];
      obj.groups = [];
      obj.growers = [];
      obj.pageItems = [];
      obj.searchText = '';
      var conditions = Object.assign({}, obj.conditions);
      conditions.arrival_date = common.convertDateToNumberDate(conditions.arrival_date);
      adminSrv.getPromoInventory(conditions, function (data) {
        if (data.success) {
          obj.inventories = data.inventories;
          var varietiesMap = {};
          var productsMap = {};
          var growersMap = {};
          obj.inventories.forEach(function (item) {
            item.name = item.name + ' ' + item.length + 'cm - ' + item.total_box + ' Bunch/Box - ' + item.masterlist.stems_per_bunch.stems_per_bunch + ' Stem/Bunch';
            obj.masterlistMapInventory[item.masterlist._KEY] = item;

            if (!productsMap[item.masterlist.product_group._KEY]) {
              productsMap[item.masterlist.product_group._KEY] = [];
              obj.products.push(item.masterlist.product_group);
            }

            if (!varietiesMap[item.masterlist.variety._KEY]) {
              varietiesMap[item.masterlist.variety._KEY] = [];
              obj.masterVarieties.push(item.masterlist.variety);
            }

            if (!growersMap[item.grower]) {
              growersMap[item.grower] = [];
              obj.growers.push({ _KEY: item.grower, company_name: item.grower_name });
            }
          });
          obj.inventories.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
          obj.growers.sort(function (a, b) {
            return a.company_name.localeCompare(b.company_name);
          });
          obj.fetched = true;
          obj.filterList();
        } else {
          alertify.error(data.error);
        }
        adminSrv.getPromoGroups(conditions.arrival_date, function (data) {
          obj.isLoading = false;
          if (data.success) {
            obj.groups = data.groups.map(function (group) {
              group.items = Object.keys(group.items).map(function (key) {
                return group.items[key];
              }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
              });
              return group;
            });
          }
        });
      });
    };

    obj.filterList = function () {
      if (obj.query.grower || obj.query.product || obj.query.variety) {
        obj.filteredInventories = $filter('filter')(obj.inventories, function (value) {
          var condition = true;

          if (obj.query.grower) {
            condition = value.grower === obj.query.grower;
          }

          if (obj.query.product && condition) {
            condition = value.masterlist.product_group._KEY === obj.query.product;
          }

          if (obj.query.variety && condition) {
            condition = value.masterlist.variety._KEY === obj.query.variety;
          }

          return condition;
        });
      } else {
        obj.filteredInventories = obj.inventories.slice();
      }

      obj.totalItems = obj.filteredInventories.length;
      obj.currentPage = 1;
      obj.getPage();
    };
  }
})(angular);
//# sourceMappingURL=adminProductMarketingCtrl.js.map

'use strict';

(function (angular, markdown) {
  angular.module('ibf').controller('adminProductMarketingGenerateHtmlCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModalInstance', adminProductMarketingGenerateHtmlCtrl]);

  function adminProductMarketingGenerateHtmlCtrl($scope, alertify, commonSrv, $uibModalInstance) {
    var obj = this,
        common = commonSrv;
    obj.texts = {
      header: 'It\'s **Tuesday Bloom Sale!** Enjoy great savings each Tuesday all year around. Check out this week\'s sale below. Delivery is next (CHANGE DATE HERE, ex. Tuesday, January 22). Hurry up, this sale is only **valid today** or while supply lasts!  Prices shown are based upon a complete box. Custom pack prices may vary.',
      footer: 'If you have any questions, please don\'t hesitate to contact us.',
      name: '',
      phone: '',
      email: ''
    };

    function init() {}

    obj.close = function () {
      $uibModalInstance.dismiss();
    };

    obj.save = function () {
      if (!obj.texts.header || !obj.texts.footer) {
        // || !obj.texts.email || !obj.texts.name || !obj.texts.phone) {
        return alertify.error('You must fill all inputs.');
      }
      obj.texts.header = markdown.toHTML(obj.texts.header).replace(/\n/g, "<br>").replace(/<br><br>/g, '<br>');
      obj.texts.footer = markdown.toHTML(obj.texts.footer).replace(/\n/g, "<br>").replace(/<br><br>/g, '<br>');
      $uibModalInstance.close(obj.texts);
    };

    init();
  }
})(angular, markdown);
//# sourceMappingURL=adminProductMarketingGenerateHtmlCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminProductGroupCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$stateParams', '$uibModal', '$filter', adminProductGroupCtrl]);

  function adminProductGroupCtrl($scope, alertify, commonSrv, productSrv, $state, $stateParams, $uibModal, $filter) {
    var obj = this,
        common = commonSrv;

    obj.isLoading = true;
    obj.products = [];
    obj.filteredProducts = [];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 30;
    obj.searchText = '';

    function init() {
      obj.getProductGroups();
    }

    obj.openProductGroup = function (product) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/productGroupModal.html',
        controller: 'adminProductGroupModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              product: angular.copy(product)
            };
          }
        }
      });

      modalInstance.result.then(function () {
        obj.getProductGroups();
      }, function (reason) {
        obj.getProductGroups();
      });
    };

    obj.getProductGroups = function () {
      var query = common.sbx.with('product_group').andWhereIsEqual('hidden', false).andWhereIsEqual('canceled', false).compile();

      common.loadAllPages(query, function (res) {
        obj.products = res.results;

        obj.products.forEach(function (item) {
          item.image = common.actual_base_url + '/product_groups/' + item._KEY + '.jpg?t=' + new Date().getTime();
        });

        obj.filteredProducts = obj.products;
        obj.totalItems = obj.filteredProducts.length;

        obj.isLoading = false;
      });
    };

    obj.filterList = function () {
      if (obj.searchText) {
        obj.filteredProducts = $filter('filter')(obj.products, function (value) {
          var common_name = value.common_name.toLowerCase();
          var botanical_name = value.botanical_name.toLowerCase();
          return common_name.indexOf(obj.searchText.toLowerCase()) !== -1 || botanical_name.indexOf(obj.searchText.toLowerCase()) !== -1;
        });
      } else {
        obj.filteredProducts = obj.products.slice();
      }

      obj.totalItems = obj.filteredProducts.length;
      obj.currentPage = 1;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminProductGroupCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminShoppingListCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$stateParams', adminShoppingListCtrl]);

  function adminShoppingListCtrl($scope, alertify, commonSrv, productSrv, $state, $stateParams) {

    var obj = this;

    obj.isCurrent = function (name) {
      return $state.is('admin.shopping_list.' + name);
    };

    obj.gotoTab = function (tab) {
      $state.go('admin.shopping_list', { tab: tab });
    };

    function init() {
      obj.activeTab = $stateParams.tab ? obj.tabs[$stateParams.tab] : 0;
    }

    obj.tabs = {
      'shopping_lists': 0,
      'products': 1
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminShoppingListCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminVarietyCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'floristSrv', '$state', '$stateParams', '$uibModal', '$filter', adminVarietyCtrl]);

  function adminVarietyCtrl($scope, alertify, commonSrv, productSrv, floristSrv, $state, $stateParams, $uibModal, $filter) {

    var obj = this,
        common = commonSrv,
        florist = floristSrv;
    obj.searchingText = false;
    obj.isLoading = false;
    obj.filteredVarieties = [];
    obj.isLoading = true;
    obj.showAddVariety = false;

    function init() {
      obj.loadProductGroups();
      obj.loadColors();
      obj.loadVarieties();

      var supportUsers = common.getConfig().admin_support_users;

      if (common.getUserData().ibf_role === 'ADMIN' || supportUsers && supportUsers.length > 0 && supportUsers.includes(common.getUserData().key)) {
        obj.showAddVariety = true;
      }
    }

    obj.variety_page = {
      page: 1,
      size: 50,
      total: 1,
      total_items: 1
    };

    obj.systemPictures = function (elem) {
      var url = common.actual_base_url + '/varieties/variety_' + elem._KEY + '.jpg';
      common.checkPicture(url, elem).then(function (result) {
        obj.pictureRes = result;
      });
    };

    obj.updateVariety = function (variety) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/product.variety.detail.html',
        controller: 'adminVarietyDetailCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              variety: variety,
              product_groups: obj.product_groups,
              colors: obj.colors
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadVarieties();
      });
    };

    obj.openReplacement = function (variety) {
      console.log(variety);
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/product.variety.replacement.html',
        controller: 'adminVarietyReplacementCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'modal-xl',
        resolve: {
          config: function config() {
            return {
              variety: variety
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadVarieties();
      });
    };

    obj.add_variety = function () {
      obj.updateVariety({
        variety_name: null,
        color: null,
        product_group: null,
        is_combo: null
      });
    };

    obj.select = function (variety) {
      obj.updateVariety(angular.copy(variety));
    };

    obj.loadProductGroups = function () {
      productSrv.listProductGroups(1, 1000, function (res) {
        obj.product_groups = res.data;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadColors = function () {

      productSrv.listProductColors(1, 1000, function (res) {
        obj.colors = res.data;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.verifyColors = function (list) {

      for (var i = 0; i < list.length; i++) {
        var color_array = [];
        for (var j = 1; j < 8; j++) {
          var tmp = 'html_code_' + j;

          if (list[i].color[tmp]) {
            color_array.push(list[i].color[tmp]);
          }
        }
        list[i].color_array = color_array;
      }
      obj.varieties = list;
    };

    obj.loadVarieties = function () {

      obj.varieties = [];
      async.parallel([function (cb) {
        productSrv.listVarieties(1, 1000, function (res) {
          obj.varieties = $filter('orderBy')(res.data, 'product_group.common_name');
          obj.verifyColors(obj.varieties);
          obj.variety_page.total_items = res.row_count;
          obj.filterList();
          cb(null, obj.varieties);
        }, function (err) {
          alertify.error(err);
        });
      }, function (cb) {
        var params = { key: common.varieties_folder_key };
        florist.folderList(params, function (contents) {
          cb(null, contents);
        }, function (err) {
          alertify.error(err);
        });
      }], function (err, results) {
        var images_keys = results[1];
        obj.varieties = obj.varieties.map(function (variety) {
          variety.image = images_keys.find(function (image_key) {
            var imageKey = image_key.name.replace('variety_', '').replace('.jpg', '');
            return variety._KEY === imageKey;
          });
          return variety;
        });
        obj.isLoading = false;
      });
    };

    obj.varietyPerPage = function () {
      obj.begin = (obj.variety_page.page - 1) * obj.variety_page.size;
      obj.end = obj.begin + obj.variety_page.size;
      obj.filteredVarieties = obj.varieties.slice(obj.begin, obj.end);
    };

    obj.filterList = function () {
      obj.limitSearch = 50;
      if (obj.searchText) {
        obj.searchingText = true;
        obj.filteredVarieties = $filter('filter')(obj.varieties, { $: obj.searchText });
      } else {
        obj.searchingText = false;
        obj.filteredVarieties = obj.varieties.slice();
      }
    };

    obj.showMore = function () {
      obj.limitSearch += 50;
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminVarietyCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminVarietyReplacementCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'floristSrv', '$filter', '$uibModalInstance', 'config', adminVarietyReplacementCtrl]);

  function adminVarietyReplacementCtrl($scope, alertify, commonSrv, productSrv, floristSrv, $filter, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.variety = config.variety;
    modal.isLoading = false;
    modal.replacements = [];
    modal.totalItems = 0;
    modal.currentPage = 1;
    modal.itemsPerPage = 10;
    modal.list = [];
    modal.pageItems = [];
    modal.products = [];
    modal.colors = [];
    modal.color = 'all';

    modal.getPage = function (apply) {
      var init = (modal.currentPage - 1) * modal.itemsPerPage;
      var end = modal.currentPage * modal.itemsPerPage;
      if (end > modal.totalItems) {
        end = modal.totalItems;
      }
      modal.pageItems = modal.list.slice(init, end);
      if (apply) {
        $scope.$apply();
      }
    };

    modal.productConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      //labelField: 'common_name',
      delimiter: '|',
      searchField: ['common_name', 'category', 'botanical_name'],
      placeholder: 'Select Product Group',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.common_name) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.common_name) + '</span>' + '</div>';
        }
      },
      onChange: function onChange(value) {
        modal.filterList(false);
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument
        modal.productSelectize = selectize;
      }
    };

    function getReplacements(cb) {
      productSrv.getReplacement(modal.variety._KEY).then(function (data) {
        modal.replacements = data.sortByVariety('replace');
        var replaceKeys = modal.replacements.map(function (i) {
          return i.replace._KEY;
        });
        cb(null, replaceKeys);
      });
    }

    function init() {
      modal.isLoading = true;
      async.waterfall([function (cb) {
        getReplacements(cb);
      }, function (replaceKeys, cb) {
        var query = common.sbx.with('variety').fetchModels(['product_group', 'color']).compile();
        common.loadAllPages(query, function (data) {
          var products = data.fetched_results.product_group;
          var colors = data.fetched_results.color;
          data.results = data.results.reduce(function (current, variety) {
            if (variety._KEY !== modal.variety._KEY) {
              variety.product_group = products[variety.product_group];
              variety.color = colors[variety.color];
              variety.removable = replaceKeys.indexOf(variety._KEY) !== -1;
              current.push(variety);
            }
            return current;
          }, []);
          modal.varieties = data.results.sortByVariety();
          var productsMap = {};
          modal.varieties.forEach(function (item) {
            productsMap[item.product_group._KEY] = item.product_group;
          });
          modal.products = Object.keys(productsMap).map(function (key) {
            return productsMap[key];
          }).sort(function (a, b) {
            return a.common_name.localeCompare(b.common_name);
          });
          modal.colors = Object.keys(colors).map(function (key) {
            return colors[key];
          }).sort(function (a, b) {
            return a.color_name.localeCompare(b.color_name);
          });
          modal.products.unshift({ common_name: 'All Products', _KEY: 'all' });
          modal.colors.unshift({ color_name: 'All Colors', _KEY: 'all' });
          modal.product = 'all';
          cb(null, {});
        }, function (err) {
          cb(err);
        });
      }], function (err) {
        modal.isLoading = false;
        if (err) {
          return alertify.error(err.message);
        }
        modal.filterList(true);
      });
    }

    modal.addReplacement = function (item) {
      modal.isLoading = true;
      item.removable = true;
      var replace = { variety: modal.variety._KEY, replace: item._KEY };
      var query = common.sbx.insert('replacement', replace);

      common.method.insert(query).then(function (data) {
        if (data.success) {
          alertify.success('Added successfully');
          getReplacements(function (r) {
            modal.isLoading = false;
          });
        } else {
          alertify.error('error occurred, try again.');
          modal.isLoading = false;
        }
      });
    };

    modal.removeReplacementFromVariety = function (variety) {
      var replacement = modal.replacements.find(function (item) {
        return item.replace._KEY === variety._KEY;
      });
      modal.removeReplacement(replacement, variety);
    };

    modal.removeReplacement = function (replacement, variety) {
      modal.isLoading = true;
      if (!variety) {
        variety = modal.varieties.find(function (item) {
          return item._KEY === replacement.replace._KEY;
        });
      }
      variety.removable = false;
      var query = common.sbx.with('replacement').whereWithKeys([replacement._KEY]).compile();

      common.method.query(common.urls.delete, query).then(function () {
        var data = common.response.post_query.data;
        if (data.success) {
          alertify.success('Removed successfully.');
          getReplacements(function (r) {
            modal.isLoading = false;
          });
        } else {
          alertify.error('error occurred, try again.');
          modal.isLoading = false;
        }
      });
    };

    modal.filterList = function (first) {
      if (modal.product || modal.color) {
        modal.list = $filter('filter')(modal.varieties, function (value) {
          return (modal.product === 'all' || value.product_group._KEY === modal.product) && (modal.color === 'all' || value.color._KEY === modal.color);
        });
      } else {
        modal.list = modal.varieties.slice();
      }

      modal.totalItems = modal.list.length;
      modal.currentPage = 1;
      modal.getPage(!first);
    };

    modal.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminVarietyReplacementCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminColorCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$stateParams', '$uibModal', '$filter', adminColorCtrl]);

  function adminColorCtrl($scope, alertify, commonSrv, productSrv, $state, $stateParams, $uibModal, $filter) {

    var obj = this,
        common = commonSrv;

    obj.isLoading = false;
    obj.showAddColor = false;

    function init() {
      obj.loadColors();

      var supportUsers = common.getConfig().admin_support_users;

      if (common.getUserData().ibf_role === 'ADMIN' || supportUsers && supportUsers.length > 0 && supportUsers.includes(common.getUserData().key)) {
        obj.showAddColor = true;
      }
    }

    obj.color_page = {
      page: 1,
      size: 50,
      total: 1,
      total_items: 1
    };

    obj.set_color = function (color) {
      return '{color: ' + color + '}';
    };

    obj.loadColors = function () {

      obj.colors = [];
      var query = commonSrv.sbx.with('color').compile();
      //let query = commonSrv.queryBuilder().setDomain(common.actual_domain).setModel('color').compile();
      //productSrv.listProductColors(obj.color_page.page, obj.color_page.size, function (res) {
      common.loadAllPages(query, function (res) {

        obj.colors = $filter('orderBy')(res.results, 'color_name');
        angular.forEach(res.results, function (color) {
          color.colors = [];
          for (var i = 1; i < 8; i++) {
            var tmp = 'html_code_' + i;
            if (color[tmp]) {
              color.colors.push(color[tmp]);
            }
          }
        });

        obj.filteredColors = obj.colors.slice(0);
        obj.color_page.total_items = obj.filteredColors.length;
        obj.color_page.page = 1;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.add_color = function (data) {

      if (!data) {
        data = {
          edit: false
        };
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/product.color.detail.html',
        controller: 'adminColorDetailCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        size: 'sm',
        resolve: {
          config: function config() {
            return {
              config: data
            };
          }
        }
      });

      modalInstance.result.then(function (data) {
        obj.loadColors();
      });
    }; // End add_color function

    obj.edit = function (color) {
      obj.add_color({
        dataColor: color,
        edit: true
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminColorCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('boxesTabsCtrl', ['$scope', 'alertify', '$stateParams', '$state', boxesTabsCtrl]).controller('dimFactorCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', dimFactorCtrl]).controller('adminBoxesCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', 'productSrv', adminBoxesCtrl]).controller('adminBoxDetailCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', 'growerSrv', '$uibModalInstance', 'config', adminBoxDetailCtrl]).controller('freightCostCtrl', ['$scope', 'alertify', 'commonSrv', 'growerSrv', '$uibModal', '$filter', freightCostCtrl]).controller('freightCostModalCtrl', ['$scope', '$uibModalInstance', 'commonSrv', 'productSrv', 'config', 'alertify', freightCostModalCtrl]).controller('holidayTagCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', holidayTagCtrl]).controller('bannerUploadCtrl', ['$scope', 'alertify', 'commonSrv', 'growerSrv', bannerUploadCtrl]);

  function boxesTabsCtrl($scope, alertify, $stateParams, $state) {
    var obj = this;

    function init() {}

    obj.isCurrent = function (name) {
      return $state.is('admin.boxes.' + name);
    };

    init();
  }

  function dimFactorCtrl($scope, alertify, commonSrv, productSrv, growerSrv) {
    var obj = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv;

    function init() {
      obj.showPanel = false;
      obj.loadFactors();
      obj.loadCountries();
      obj.loadCarriers();
    }

    obj.reset = function () {
      obj.country = null;
      obj.carrier = null;
      obj.factor_calculator = null;
    };

    obj.addFactor = function () {
      obj.reset();
      obj.isAdding = true;
      obj.isEdit = false;
      obj.showPanel = true;
      obj.editKey = null;
    };
    obj.editFactor = function (factor) {
      obj.isAdding = false;
      obj.isEdit = true;
      obj.editKey = factor._KEY;
      obj.country = factor.country;
      obj.carrier = factor.carrier;
      obj.factor_calculator = factor.factor_calculator;
      obj.showPanel = true;
    };

    obj.loadFactors = function () {
      ps.listFactors(function (list) {
        obj.factors = list.data;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadCarriers = function () {
      console.log('GROWER SERVICE', gs);
      gs.listCarriers(function (carry) {

        obj.carriers = carry.data;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadCountries = function () {
      common.listCountries(function (data) {
        obj.countries = data.countries;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.save = function (key) {

      var save_url = key ? common.urls.update : common.urls.row;

      $scope.$broadcast('show-errors-check-validity');
      if (obj.adminForm.$invalid) {
        obj.isLoading = false;
        valid = false;
        alertify.error('There are invalid fields');
        return;
      }

      var query = {
        carrier: obj.carrier._KEY,
        country: obj.country._KEY,
        factor_calculator: obj.factor_calculator
      };
      if (key) {
        query._KEY = key;
      }

      ps.saveDimFactor(query, save_url, function () {
        alertify.success('Data Saved.');
        obj.showPanel = false;
        obj.reset();
        obj.loadFactors();
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.delete = function () {};
    init();
  }

  function adminBoxesCtrl($scope, alertify, commonSrv, $uibModal, productSrv) {
    var obj = this,
        common = commonSrv,
        ps = productSrv;

    function init() {
      obj.loadBoxes();
      obj.loadFactors();
    }

    obj.box_page = {
      page: 1,
      size: 10,
      total: 1,
      total_items: 1
    };

    obj.loadBoxes = function () {
      ps.listBoxes(obj.box_page.page, obj.box_page.size, function (res) {

        console.log(res.data);
        obj.boxes = res.data;
        obj.box_page.total_items = res.row_count;
        obj.box_page.total = res.total_pages;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadFactors = function () {
      ps.listFactors(function (list) {
        obj.factors = list.data;
        obj.factorsMap = {};

        for (var i = 0; i < obj.factors.length; i++) {
          if (obj.factors[i].carrier.carrier !== 'Fedex') {
            continue;
          }
          if (!obj.factorsMap[obj.factors[i].country._KEY]) {
            obj.factorsMap[obj.factors[i].country._KEY] = [obj.factors[i]];
          } else {
            obj.factorsMap[obj.factors[i].country._KEY].push(obj.factors[i]);
          }
        }
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.boxModal = function (box) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/boxModal.html',
        controller: 'adminBoxDetailCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              box: box
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadBoxes();
      });
    };

    init();
  }

  function adminBoxDetailCtrl($scope, alertify, commonSrv, productSrv, growerSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv;

    function init() {
      modal.loadCountries();
    }

    modal.boxesOptions = [{ val: true, label: 'Single Box' }, { val: false, label: 'Combo Box' }];

    if (config.box) {
      console.log(config.box);
      modal.isEdit = true;
      modal.save_url = common.urls.update;
      modal.box_length = config.box.box_length;
      modal.country = config.box.country;
      modal.box_width = config.box.box_width;
      modal.box_heigth = config.box.box_heigth;
      modal.max_length = config.box.box_max_length.toString();
      modal.name = config.box.box_name;
      modal.key = config.box._KEY;
      modal.isNormal = config.box.fixed_length ? false : true;
      modal.fixed_length = config.box.fixed_length;
      modal.box_cost = config.box.box_cost;
    } else {
      modal.isEdit = false;
      modal.isNormal = true;
      modal.save_url = common.urls.row;
    }

    modal.loadCountries = function () {
      common.listCountries(function (data) {
        modal.countries = data.countries;
      }, function (err) {
        alertify.error(err);
      });
    };

    modal.save = function () {

      var valid = true;
      var msg = 'Box created';

      modal.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (modal.adminForm.$invalid) {
        modal.isLoading = false;
        valid = false;
        alertify.error('There are invalid fields');
        return;
      }

      modal.current_box = {
        'box_length': modal.box_length,
        'country': modal.country._KEY,
        'box_width': modal.box_width,
        'box_heigth': modal.box_heigth,
        'box_max_length': modal.max_length || 0,
        'fixed_length': modal.fixed_length,
        'box_name': modal.name,
        'box_cost': modal.box_cost
      };

      if (valid) {
        if (config.box) {
          modal.current_box._KEY = modal.key;msg = 'Box updated';
        }
        modal.current_box.isNormal = modal.isNormal;
        ps.saveBoxes(modal.current_box, modal.save_url, function (box) {
          modal.isLoading = false;
          modal.current_box = null;
          alertify.success(msg);
          $uibModalInstance.close();
        }, function (error) {
          modal.isLoading = false;
          alertify.error(error);
        });
      } else {
        alertify.error('Internal error');
        modal.isLoading = false;
      }
    };

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    init();
  }

  function freightCostCtrl($scope, alertify, commonSrv, growerSrv, $uibModal, $filter) {
    var obj = this,
        common = commonSrv,
        gs = growerSrv;

    function init() {
      obj.loadCarriers();
      obj.loadValues();
    }

    obj.loadValues = function () {
      var query = commonSrv.sbx.with('freight_cost').setPage(1).setPageSize(1000).compile();
      /*var query = commonSrv.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('freight_cost')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          obj.values = $filter('orderBy')(res.results, 'year');
          obj.yearMap = {};

          for (var i = 0; i < obj.values.length; i++) {
            if (obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier]) {
              obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].carrier = obj.values[i].carrier;
              switch (parseInt(obj.values[i].month)) {
                case 0:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jan = obj.values[i];
                  break;
                case 1:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Feb = obj.values[i];
                  break;
                case 2:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Mar = obj.values[i];
                  break;
                case 3:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Apr = obj.values[i];
                  break;
                case 4:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].May = obj.values[i];
                  break;
                case 5:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jun = obj.values[i];
                  break;
                case 6:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jul = obj.values[i];
                  break;
                case 7:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Aug = obj.values[i];
                  break;
                case 8:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Sep = obj.values[i];
                  break;
                case 9:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Oct = obj.values[i];
                  break;
                case 10:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Nov = obj.values[i];
                  break;
                case 11:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Dec = obj.values[i];
                  break;
              }
            } else {
              obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier] = {};
              //obj.yearMap[obj.values[i].year+"-"+obj.values[i].carrier].key = obj.values[i]._KEY;
              obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].year = obj.values[i].year;
              obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].cost = obj.values[i].freight_cost;
              obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].carrier = obj.values[i].carrier;
              switch (parseInt(obj.values[i].month)) {
                case 0:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jan = obj.values[i];
                  break;
                case 1:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Feb = obj.values[i];
                  break;
                case 2:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Mar = obj.values[i];
                  break;
                case 3:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Apr = obj.values[i];
                  break;
                case 4:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].May = obj.values[i];
                  break;
                case 5:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jun = obj.values[i];
                  break;
                case 6:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Jul = obj.values[i];
                  break;
                case 7:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Aug = obj.values[i];
                  break;
                case 8:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Sep = obj.values[i];
                  break;
                case 9:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Oct = obj.values[i];
                  break;
                case 10:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Nov = obj.values[i];
                  break;
                case 11:
                  obj.yearMap[obj.values[i].year + '-' + obj.values[i].carrier].Dec = obj.values[i];
                  break;
              }
            }
          }

          //obj.yearMap = common.toMap(obj.values, 'yearMap', 'year');
          obj.years = [];
          for (var elem in obj.yearMap) {
            obj.years.push(obj.yearMap[elem]);
          }
          console.log(obj.years);
        } else {
          alertify.error('Internal error');
        }
      });
    };

    obj.loadCarriers = function () {
      gs.listCarriers(function (carry) {

        obj.carriers = carry.data;
        obj.carriers.push({ _KEY: '', carrier: 'Both' });
        obj.carrier = obj.carriers[obj.carriers.length - 1];
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.addValues = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/freightModal.html',
        controller: 'freightCostModalCtrl',
        controllerAs: 'obj',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              year_set: null,
              carriers: obj.carriers
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadValues();
      });
    };

    obj.editValues = function (set) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/freightModal.html',
        controller: 'freightCostModalCtrl',
        controllerAs: 'obj',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              year_set: set,
              carriers: obj.carriers
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadValues();
      });
    };

    init();
  }

  function freightCostModalCtrl($scope, $uibModalInstance, commonSrv, productSrv, config, alertify) {
    var obj = this,
        common = commonSrv,
        ps = productSrv;
    obj.carriers = angular.copy(config.carriers);
    obj.carriers.splice(obj.carriers.length - 1, 1);
    obj.carriers = common.toMap(obj.carriers, 'carriers', '_KEY');
    obj.years = common.iterator(2014, 2030);

    function init() {

      obj.set = config.year_set ? config.year_set : null;
      obj.title = config.year_set ? 'Edit year' : 'Add year';
      obj.months = ps.getMonths();
      obj.monthMap = common.toMap(obj.months, 'months', 'month_short');
      if (obj.set) {
        obj.save_url = common.urls.update;
        obj.values = {
          Jan: obj.set.Jan,
          Feb: obj.set.Feb,
          Mar: obj.set.Mar,
          Apr: obj.set.Apr,
          May: obj.set.May,
          Jun: obj.set.Jun,
          Jul: obj.set.Jul,
          Aug: obj.set.Aug,
          Sep: obj.set.Sep,
          Oct: obj.set.Oct,
          Nov: obj.set.Nov,
          Dec: obj.set.Dec
        };
        obj.year = obj.set.year.toString();
        obj.cost = obj.set.cost;
        obj.carrier = obj.carriers[obj.set.carrier];
      } else {
        obj.save_url = common.urls.row;
      }
    }

    obj.cancel = function () {
      $uibModalInstance.dismiss();
    };

    obj.save = function () {

      obj.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (obj.form.$invalid) {
        obj.isLoading = false;
        valid = false;
        alertify.error('There are invalid fields');
        return;
      }

      var query = common.sbx.with('freight_cost').andWhereIsEqual('year', obj.year).andWhereIsEqual('carrier', obj.carrier._KEY).setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('freight_cost')
        .addCondition('AND', 'year', '=', obj.year)
        .addCondition('AND', 'carrier', '=', obj.carrier._KEY)
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.results.length > 0 && !obj.set) {
          alertify.error('The values for the year and carrier: ' + obj.year + ' ' + obj.carrier.carrier + ' has been entered, please go to \'Edit\' for modify the values.');
        } else {
          var rows = [];
          if (obj.set) {
            angular.forEach(obj.values, function (item, key) {

              rows.push({
                'month': obj.monthMap[key].month_number,
                'value': item.value,
                'year': obj.year,
                'freight_cost': obj.cost,
                'carrier': obj.carrier._KEY,
                '_KEY': item._KEY
              });
            });
          } else {
            angular.forEach(obj.values, function (value, key) {
              rows.push({
                'month': obj.monthMap[key].month_number,
                'value': value.value,
                'year': obj.year,
                'freight_cost': obj.cost,
                'carrier': obj.carrier._KEY
              });
            });
          }

          var query = {
            'domain': common.actual_domain,
            'row_model': 'freight_cost',
            'rows': rows
          };

          common.method.query(obj.save_url, query).then(function () {
            var res = common.response.post_query.data;

            if (res.success) {
              alertify.success('Values Added.');
              $uibModalInstance.close();
            } else {
              alertify.error('Internal error.');
              $uibModalInstance.close();
            }
          });
        }
      });

      //
    };

    init();
  }

  function holidayTagCtrl($scope, alertify, commonSrv, adminSrv) {
    var obj = this,
        common = commonSrv,
        admin = adminSrv;
    obj.config = {};
    obj.loading = true;
    obj.holyDay = '';

    function init() {
      obj.loadConfig();
    }

    obj.loadConfig = function () {
      admin.loadConfig(function (item) {
        obj.config = item;
        obj.config.config = JSON.parse(obj.config.config);
        obj.holyDay = obj.config.config.holyDay;
        obj.loading = false;
      });
    };

    obj.updateConfig = function () {
      obj.loading = true;
      var data = {
        app: obj.config.id,
        domain: common.actual_domain,
        config: obj.config.config
      };

      admin.updateConfig(data, function () {
        alertify.success('Holiday updated successfully.');
        obj.loadConfig();
      }, function () {
        alertify.error('Error occurred, try again.');
        obj.loadConfig();
      });
    };

    init();
  }

  function bannerUploadCtrl($scope, alertify, commonSrv, growerSrv) {
    var obj = this,
        common = commonSrv;
    obj.loading = false;
    obj.currentBanner = common.actual_base_url + '/images/banner-arrival.gif';
    obj.tempImage = '';

    $scope.fileAdded = function (input) {
      obj.tempImage = URL.createObjectURL(input.files[0]);
    };

    obj.updateBanner = function () {
      obj.loading = true;
      var myBlob = common.dataURItoBlob(obj.myFile.dataURL);
      var myFile = new File([myBlob], 'name.gif');
      console.log(myBlob);
      console.log(myFile);

      var fd = new FormData();
      fd.append('file', myFile, 'banner-arrival.gif');
      fd.append('model', JSON.stringify({ key: commonSrv.images_folder_key }));

      growerSrv.uploadFileToUrl(fd, function (res) {
        if (res) {
          obj.currentBanner = obj.tempImage;
          alertify.success('Banner upload successfully.');
        } else {
          alertify.error('An error has occurred, please try again.');
        }
        obj.loading = false;
      });
    };
  }
})(angular);
//# sourceMappingURL=adminBoxesCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminGroupTypeCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$state', '$stateParams', '$uibModal', '$filter', adminGroupTypeCtrl]).controller('adminGroupTypeDetailCtrl', ['$scope', 'alertify', 'commonSrv', 'productSrv', '$uibModalInstance', 'config', adminGroupTypeDetailCtrl]);

  function adminGroupTypeCtrl($scope, alertify, commonSrv, productSrv, $state, $stateParams, $uibModal, $filter) {

    var obj = this,
        common = commonSrv;

    obj.showAddGroupType = false;
    obj.isLoading = false;

    $scope.$watch('obj.searchText', function () {
      obj.filteredGroupTypes = $filter('objectFilter')(obj.groupTypes, obj.searchText, ['group_type', 'index_order']);
      obj.groupType_page.total_items = obj.filteredGroupTypes.length;
      obj.groupType_page.total = Math.round(obj.filteredGroupTypes.length / obj.groupType_page.size);
      obj.groupType_page.page = 1;
      obj.groupTypePerPage();
    });

    function init() {
      obj.loadGroupTypes();

      if (common.getUserData().ibf_role === 'ADMIN') {
        obj.showAddGroupType = true;
      }
    }

    obj.groupType_page = {
      page: 1,
      size: 50,
      total: 1,
      total_items: 1
    };

    obj.loadGroupTypes = function () {
      obj.groupTypes = [];
      var query = commonSrv.sbx.with('group_type').compile();
      //let query = commonSrv.queryBuilder().setDomain(common.actual_domain).setModel('group_type').compile();
      //productSrv.listProductColors(obj.groupType_page.page, obj.groupType_page.size, function (res) {
      common.loadAllPages(query, function (res) {

        obj.groupTypes = $filter('orderBy')(res.results, 'group_type');
        obj.filteredGroupTypes = obj.groupTypes.slice(0);
        obj.groupType_page.total_items = obj.filteredGroupTypes.length;
        obj.groupType_page.total = Math.round(obj.filteredGroupTypes.length / obj.groupType_page.size);
        obj.groupType_page.page = 1;
        obj.groupTypePerPage();
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.groupTypePerPage = function () {
      var from = (obj.groupType_page.page - 1) * obj.groupType_page.size;
      var to = from + obj.groupType_page.size;
      obj.groupType_page_data = obj.filteredGroupTypes.slice(from, to);
    };

    obj.add_groupType = function (data) {
      if (!data) {
        data = {
          edit: false
        };
      }
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/product.group-type.detail.html',
        controller: 'adminGroupTypeDetailCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        size: 'sm',
        resolve: {
          config: function config() {
            return {
              config: data
            };
          }
        }
      });

      modalInstance.result.then(function (data) {
        obj.loadGroupTypes();
      });
    };

    obj.edit = function (groupType) {
      obj.add_groupType({
        dataGroupType: groupType,
        edit: true
      });
    };

    init();
  }

  function adminGroupTypeDetailCtrl($scope, alertify, commonSrv, productSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv,
        data = config;
    modal.title = data.config.edit ? 'Edit Group Type' : 'Add Group Type';
    modal.isLoading = false;

    if (data.config.dataGroupType) {
      modal.dataGroupType = data.config.dataGroupType;
      modal.groupType = modal.dataGroupType.group_type;
      modal.indexOrder = modal.dataGroupType.index_order;
    }

    modal.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    modal.save = function () {
      modal.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (modal.adminGroupTypeDetail.$invalid) {
        modal.isLoading = false;

        if (!modal.groupType) {
          alertify.error('Please assign a name for this group type');
          return;
        }

        if (!modal.indexOrder) {
          alertify.error('Please assgin an index order for this group type');
          return;
        }
      }

      var groupType = {
        group_type: modal.groupType,
        index_order: modal.indexOrder
      };

      if (data.config.edit) {
        groupType._KEY = modal.dataGroupType._KEY;
      }

      productSrv.saveGroupType(groupType, function (response) {
        modal.isLoading = false;
        $uibModalInstance.close();
        alertify.success(response);
      }, function (error) {
        modal.isLoading = false;
        alertify.error(error);
      });
    };
  }
})(angular);
//# sourceMappingURL=adminGroupTypeCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminPurchaseListCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'adminSrv', '$filter', 'environment', adminPurchaseListCtrl]);

  function adminPurchaseListCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, adminSrv, $filter, environment) {
    var obj = this,
        common = commonSrv;
    obj.date = new Date();
    obj.filteredPurchases = [];
    obj.purchases = [];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 20;
    obj.isLoading = false;
    obj.conditions = {
      customer: '',
      order: '',
      purchase: '',
      date: common.convertDateToNumberDate(obj.date)
    };

    obj.dateOptions = {};

    function init() {
      obj.loadPurchase('date');
    }

    obj.dateChanged = function () {
      obj.conditions.date = common.convertDateToNumberDate(obj.date);
      obj.loadPurchase('date');
    };

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    obj.openSbx = function (purchase) {
      var model = common.actual_domain === 129 ? 924 : 834;
      var url = 'https://sbxcloud.com/#!/app/data/' + common.actual_domain + '/model/' + model + '/list';
      var params = '?qr=%5B%7B%22ANDOR%22:%22AND%22,%22GROUP%22:%5B%7B%22ANDOR%22:%22AND%22,%22VAL%22:%22' + purchase.consecutive + '%22,%22FIELD%22:%22purchase.consecutive%22,%22OP%22:%22%3D%22%7D%5D%7D%5D';
      window.open(url + params, '_blank');
    };

    obj.openGoogle = function (purchase) {
      window.open('https://mail.google.com/mail/u/0/#search/PO+%23' + purchase.consecutive + '+is+placed+for+arrival+on', '_blank');
    };

    obj.resendEmails = function (purchase) {
      common.method.run({
        key: environment.cloudscript.mailCheckout,
        params: {
          purchase_key: purchase._KEY,
          user: purchase.customer_user._KEY
        }
      }).then(function (response) {
        if (response.success) {
          alertify.success('Emails send.');
        } else {
          alertify.error('Error occurred, please try again.');
        }
      }, function () {
        alertify.error('Error occurred, please try again.');
      });
    };

    obj.loadPurchase = function (type) {
      if (obj.conditions[type]) {
        var copy = angular.copy(obj.conditions);
        copy.customer = '';
        copy.purchase = '';
        copy.order = '';
        copy.date = 0;
        copy[type] = obj.conditions[type];
        obj.isLoading = true;
        adminSrv.getPurchases(copy, function (res) {
          if (res.success) {
            obj.purchases = res.purchases;
            obj.filteredPurchases = obj.purchases.slice();
            obj.totalItems = obj.purchases.length;

            if (!obj.totalItems) {
              alertify.log('No purchase found to given conditions.');
            }
          } else {
            alertify.error(res.error);
          }
          obj.isLoading = false;
        });
      } else {
        alertify.error('You must fill ' + type + ' text box.');
      }
    };

    obj.clear = function () {
      obj.purchases = [];
      obj.conditions = {
        customer: '',
        order: '',
        purchase: ''
      };
      obj.filteredPurchases = [];
      obj.totalItems = 0;
      obj.currentPage = 1;
      obj.dateChanged();
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminPurchaseListCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminPurchaseDetailCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', 'floristSrv', adminPurchaseDetailCtrl]);

  function adminPurchaseDetailCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv, floristSrv) {

    var obj = this,
        common = commonSrv,
        florist = floristSrv;
    var countryMap = {};
    obj.total_bunches = 0;
    obj.total_prices = 0;
    obj.notReady = true;
    obj.callFinish = [false, false];

    function init() {
      obj.loadCountries();
      obj.loadCartbox();
      obj.loadPurchase();
    }

    obj.getImage = function (item) {
      var country = countryMap[item.grower.country];
      if (country) {
        return common.actual_base_url + '/flags/' + country.country_iso + '_flag.png';
      }
      return null;
    };

    obj.loadCountries = function () {
      florist.getCountriesList(function (data) {
        angular.forEach(data.results, function (item) {
          countryMap[item._KEY] = item;
        });
        obj.countries = data.results;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.loadPurchase = function () {
      florist.getPurchaseOrder($stateParams.purchaseId, function (data) {
        obj.info = data.results[0];
      });
    };

    obj.loadCartbox = function () {
      florist.getCartBoxByPurchase($stateParams.purchaseId, function (data) {
        var temp = [];
        var total_prices = 0;
        angular.forEach(data.results, function (item) {
          obj.total_bunches = obj.total_bunches + parseInt(item.current_items);
          total_prices = total_prices + parseFloat(item.price) * (1 - item.off);
          temp.push(item);
        });
        obj.total_prices = total_prices;
        obj.list = temp;
      }, function (err) {
        alertify.error(err);
      });
    };

    obj.showDetail = function (cartbox) {
      var modalInstance = florist.showDetailCartBox({
        cartbox: cartbox
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminPurchaseDetailCtrl.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  'use strict';

  angular.module('ibf').controller('adminPurchasePackingCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', '$uibModal', 'adminSrv', '$filter', 'environment', '$rootScope', adminPurchasePackingCtrl]).controller('adminPurchasePackingPickDateCtrl', ['$scope', 'alertify', 'floristSrv', 'growerSrv', 'adminSrv', 'commonSrv', '$uibModalInstance', 'config', '$rootScope', adminPurchasePackingPickDateCtrl]).controller('adminPurchasePackingMultiPickDateCtrl', ['$scope', 'alertify', 'floristSrv', 'growerSrv', 'adminSrv', 'commonSrv', '$uibModalInstance', 'config', adminPurchasePackingMultiPickDateCtrl]).controller('adminPurchasePackingChangeAddressCtrl', ['$scope', 'alertify', 'floristSrv', 'growerSrv', 'adminSrv', 'commonSrv', '$uibModalInstance', 'config', adminPurchasePackingChangeAddressCtrl]);

  function adminPurchasePackingCtrl($scope, alertify, $state, $stateParams, commonSrv, $uibModal, adminSrv, $filter, environment, $rootScope) {
    $scope.closeDays = [];
    var obj = this,
        common = commonSrv,
        admin = adminSrv;
    obj.user = common.getUserData();
    obj.chargeCode = '';
    obj.filterApproved = '';
    obj.packing_date = new Date();
    obj.filteredCartboxes = [];
    obj.searchText = '';
    obj.carrier = '';
    obj.countries = [];
    obj.allCartboxes = [];
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.itemsPerPage = 30;
    obj.isSupportUser = false;
    obj.issue = 0;
    obj.reasons = ['Payment', 'Supply', 'FedEx'];
    obj.checkedAllItems = false;
    obj.checkedItems = false;
    obj.closeDays = [];
    $rootScope.closedDays = [];
    obj.loadingMonth = false;
    obj.dates = {
      selected: [],
      existing: [],
      lastAdjustedMonth: []
    };

    // let minDate = new Date();
    // minDate.setDate(minDate.getDate() - 7);
    $scope.$watchCollection('obj.dates.selected', function (selectedDates) {

      if (!obj.dates || !Array.isArray(selectedDates) || selectedDates.length === 0) {
        return;
      }

      var selectedDate = selectedDates[selectedDates.length - 1];

      if (!selectedDate) {
        return;
      }

      var isDateAlreadyInExisting = obj.dates.existing.some(function (existingDate) {
        return existingDate.start_date === selectedDate.start_date && existingDate.end_date === selectedDate.end_date;
      });

      if (!isDateAlreadyInExisting && !obj.loadingMonth) {

        obj.loadingMonth = true;
        obj.loadCartBoxes(selectedDate.start_date, selectedDate.end_date, function () {
          obj.loadingMonth = false;
        });

        obj.dates.existing.push(selectedDate);
      }
    });
    $scope.$watch('selectedMonth', function (newValue) {
      if (newValue && !obj.loadingMonth) {
        if (obj.cartboxes.length > 0 && shouldAdjustMonth(newValue, obj)) {
          adjustMonthSelection(newValue);
        }
      }
    }, true);

    function disabled() {

      return obj.loadingMonth;
    }

    obj.growers = {};
    obj.dateOptions = {
      // minDate: minDate,
      dateDisabled: disabled,
      customClass: getPurchaseDays
    };

    function getPurchaseDays(data) {
      var date = data.date,
          mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

        for (var i = 0; i < obj.allCartboxes.length; i++) {
          var cartbox = obj.allCartboxes[i];
          var packing_date = common.convertNumberDateToDate(cartbox.packing_date);
          var currentDay = new Date(packing_date).getTime();
          if (dayToCheck === currentDay) {
            return 'activeClass';
          }
        }
      }

      return '';
    }
    function getCurrentMonthRange() {
      var currentMonth = new Date().getMonth() + 1;
      var currentYear = new Date().getFullYear();

      var startDate = Number('' + currentYear + currentMonth.toString().padStart(2, '0') + '01');
      var lastDay = new Date(currentYear, currentMonth, 0).getDate();
      var endDate = Number('' + currentYear + currentMonth.toString().padStart(2, '0') + lastDay);

      return { start_date: startDate, end_date: endDate };
    }

    function adjustMonthSelection(date) {

      var adjustedMonth = new Date(date);
      adjustedMonth.setMonth(adjustedMonth.getMonth());

      var adjustedMonthDetails = getMonthDetails(adjustedMonth);

      var isSelected = obj.dates.selected.some(function (d) {
        return new Date(d.start_date).getTime() === new Date(adjustedMonthDetails.start_date).getTime() && new Date(d.end_date).getTime() === new Date(adjustedMonthDetails.end_date).getTime();
      });

      if (isSelected) {

        obj.dates.selected = [];
        obj.dates.existing.push(adjustedMonthDetails);
      } else {

        obj.dates.selected = [adjustedMonthDetails];
      }
    }
    function shouldAdjustMonth(date, obj) {
      if (!date) return false;

      var currentMonth = date.getMonth();
      var currentYear = date.getFullYear();
      var dateKey = currentYear + '-' + currentMonth;
      if (obj.dates.lastAdjustedMonth.includes(dateKey)) {
        return false;
      }

      obj.dates.lastAdjustedMonth.push(dateKey);

      return true;
    }
    function getMonthDetails(date) {
      var currentMonth = new Date(date).getMonth();
      var currentYear = new Date(date).getFullYear();

      var startDate = Number('' + currentYear + (currentMonth + 1).toString().padStart(2, '0') + '01');
      var lastDay = new Date(currentYear, currentMonth + 1, 0).getDate();
      var endDate = Number('' + currentYear + (currentMonth + 1).toString().padStart(2, '0') + lastDay);

      return { month: currentMonth, year: currentYear, start_date: startDate, end_date: endDate };
    }

    obj.loadCartBoxes = function loadCartBoxes(startDate, endDate, callback) {
      // obj.isLoading = true;
      obj.loadingMonth = true;

      var query = common.sbx.with('cart_box').andWhereIsNotNull('purchase').andWhereGreaterOrEqualThan('packing_date', startDate).andWhereLessOrEqualThan('packing_date', endDate);

      if (obj.user.ibf_role === 'COUNTRY_MANAGER') {
        var countries = obj.user.countries.map(function (item) {
          return item.country;
        });
        query.andWhereIn('grower.country', countries);
      }

      common.loadAllPages(query.compile(), function (res) {
        obj.allCartboxes = obj.allCartboxes || [];
        obj.allCartboxes = [].concat(_toConsumableArray(obj.allCartboxes), _toConsumableArray(res.results));

        if (obj.allCartboxes.length) {
          obj.dates.selected.push({ start_date: startDate, end_date: endDate });
          obj.dates.existing.push({ start_date: startDate, end_date: endDate });
        }

        obj.loadingMonth = false;
        //obj.load();
        if (callback) callback();
      }, function (err) {
        obj.loadingMonth = false;
        //  obj.load();
        if (callback) callback();
      });
    };

    function init() {
      var supportUsers = common.getConfig().admin_support_users;

      if (supportUsers && supportUsers.length > 0) {
        obj.isSupportUser = supportUsers.includes(obj.user.data.key) && obj.user.ibf_role !== "COUNTRY_MANAGER";
        obj.load();
      }

      var _getCurrentMonthRange = getCurrentMonthRange(),
          start_date = _getCurrentMonthRange.start_date,
          end_date = _getCurrentMonthRange.end_date;

      obj.loadCartBoxes(start_date, end_date, function () {});
    }

    ///

    obj.updateCartboxCarrier = function (cartboxKey) {

      common.confirmModal({
        title: 'Warning',
        msj: 'Are you sure? \n do you want to change this box carrier from DHL to FedEx?',
        save: 'Yes',
        cancel: 'No'
      }, function () {
        var dialog = common.showDialogProgress({ msj: 'Updating carrier..' });

        var query = common.sbx.with('carrier').andWhereContains('carrier', "fedex").compile();
        common.loadPage(query, 1, function (res) {

          var query = {
            domain: common.actual_domain,
            row_model: 'cart_box',
            rows: [{
              _KEY: cartboxKey,
              carrier: res.results[0]._KEY
            }]
          };

          common.method.query(common.urls.update, query).then(function () {
            var response = common.response.post_query.data;
            if (response.success) {
              dialog.close();
              alertify.success('Carrier updated successfully');
              obj.load();
            } else {
              dialog.close();
              alertify.error('An error occurred while updating the carrier');
            }
          });
        });
      });
    };

    obj.onChangeChecked = function (_KEY) {
      var items = obj.filteredCartboxes.map(function (item) {
        if (item._KEY === _KEY) {
          item.checked = !item.checked;
        }
        return item;
      });

      obj.checkedAllItems = items.every(function (item) {
        return item.checked;
      });
    };

    obj.toggleAllItems = function () {

      obj.checkedAllItems = !obj.checkedAllItems;
      obj.filteredCartboxes.forEach(function (item) {
        item.checked = obj.checkedAllItems;
      });
    };

    obj.deleteMultipleOrders = function () {

      var cartboxes = obj.filteredCartboxes.filter(function (item) {
        return item.checked;
      });

      if (!cartboxes.length) return;

      common.confirmModal({
        title: '',
        msj: 'Are you sure you want to delete purchase orders?',
        saveText: 'Yes, delete',
        cancelText: 'No, go back',
        size: 'sm',
        showIssue: true

      }, function () {
        var dialog = common.showDialogProgress({
          msj: 'Deleting..'
        });
        cartboxes.forEach(function (item) {
          item.issue = obj.reasons[obj.issue];
        });

        var tasks = cartboxes.map(function (cartbox) {
          return function (cb) {
            admin.deleteBoxPurchase(cartbox, function (res) {
              return cb(null, { ok: true, cartbox: cartbox, res: res });
            }, function (err) {
              return cb(null, { ok: false, cartbox: cartbox, err: err });
            });
          };
        });

        async.parallelLimit(tasks, 2, function (_ignored, results) {
          var settled = results || [];
          var successes = settled.filter(function (r) {
            return r.ok;
          });
          var failures = settled.filter(function (r) {
            return !r.ok;
          });

          dialog.close();
          obj.checkedAllItems = false;
          obj.load();

          if (!settled.length) return;

          if (failures.length) {
            alertify.error(failures.length + ' order(s) could not be deleted');
          } else {
            alertify.success('Orders have been removed');
          }

          var escape = function escape(s) {
            return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
          };

          var row = function row(r, isLast) {
            var product = r.cartbox.product_group && r.cartbox.product_group.common_name || '—';
            return '<div style="display:flex;align-items:baseline;gap:14px;padding:9px 14px;' + (isLast ? '' : 'border-bottom:1px solid #f3f4f6;') + '">' + '<span style="font-family:\'SF Mono\',Menlo,Monaco,Consolas,monospace;' + 'font-size:12px;font-weight:600;color:#111827;letter-spacing:0.01em;' + 'min-width:72px;">#' + escape(r.cartbox.consecutive) + '</span>' + '<span style="font-size:12px;color:#6b7280;font-weight:400;' + 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escape(product) + '</span>' + '</div>';
          };

          var section = function section(items, label, accent) {
            if (!items.length) return '';
            var rows = items.map(function (r, i) {
              return row(r, i === items.length - 1);
            }).join('');
            return '<div style="margin-bottom:18px;">' + '<div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;padding:0 2px;">' + '<span style="display:inline-block;width:6px;height:6px;border-radius:50%;' + 'background:' + accent + ';"></span>' + '<span style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;' + 'font-weight:700;color:' + accent + ';">' + label + '</span>' + '<span style="font-size:11px;color:#9ca3af;font-weight:500;' + 'letter-spacing:0.02em;">' + items.length + ' order' + (items.length === 1 ? '' : 's') + '</span>' + '</div>' + '<div style="max-height:180px;overflow-y:auto;border:1px solid #e5e7eb;' + 'border-radius:4px;background:#fafaf9;">' + rows + '</div>' + '</div>';
          };

          var msj = '<div style="text-align:left;font-family:-apple-system,BlinkMacSystemFont,' + '\'Helvetica Neue\',Helvetica,Arial,sans-serif;font-weight:400;' + 'font-size:13px;line-height:1.5;color:#111827;margin-top:-4px;">' + '<div style="display:flex;align-items:baseline;gap:12px;' + 'padding-bottom:14px;margin-bottom:18px;' + 'border-bottom:1px solid #e5e7eb;">' + '<span style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;' + 'color:#9ca3af;font-weight:700;">Batch result</span>' + '<span style="margin-left:auto;font-size:12px;color:#6b7280;">' + (successes.length ? '<span style="color:#047857;font-weight:600;">' + successes.length + ' succeeded' + '</span>' : '') + (successes.length && failures.length ? '<span style="color:#d1d5db;padding:0 9px;">·</span>' : '') + (failures.length ? '<span style="color:#b91c1c;font-weight:600;">' + failures.length + ' failed' + '</span>' : '') + '</span>' + '</div>' + section(successes, 'Deleted', '#047857') + section(failures, 'Not deleted', '#b91c1c') + '</div>';

          common.confirmModal({
            title: 'Delete summary',
            msj: msj,
            trustMsj: true,
            alignRight: true,
            saveText: 'Done',
            size: 'md',
            hideCancel: true,
            showButton: false
          }, function () {});
        });
      });
    };
    obj.loadCustomerAddresses = function (customer, defaultAddress) {

      if (customer) {
        common.method.run({
          key: environment.cloudscript.loadAddress,
          params: { customer: customer }
        }).then(function (response) {

          if (response.success) {
            var addressList = response.results.addresses;
            var filterDefaultAddress = addressList.filter(function (address) {
              return !address._KEY;
            });
            var matchingActualAddress = filterDefaultAddress.find(function (address) {
              return address.address.includes(defaultAddress.address);
            });

            if (matchingActualAddress && matchingActualAddress.closedDays) {
              $rootScope.closedDays = filterDefaultAddress.filter(function (address) {
                return address.closedDays;
              });
            } else {
              $rootScope.closedDays = [];
            }

            if (!matchingActualAddress) {

              $rootScope.closedDays = addressList.filter(function (address) {
                return address.closedDays;
              });
            }
          }
        });
      }
    };

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    obj.openStride = function (cartbox) {
      if (!cartbox.charge_code) {
        if (cartbox.charge_error) {
          if (JSON.parse(cartbox.charge_error).charge_code) {
            window.open('https://dashboard.stripe.com/payments/' + JSON.parse(cartbox.charge_error).charge_code, '_blank');
          } else {
            var msj = JSON.parse(cartbox.charge_error) ? JSON.parse(cartbox.charge_error).message : "";
            common.confirmModal({
              title: 'Charge error',
              msj: msj,
              saveText: 'Ok',
              hideCancel: true,
              size: 'sm'
            }, function () {});
          }
        } else {
          common.promptModal({
            msj: 'Add Stripe Charge Code:',
            saveText: 'Update',
            cancelText: 'Close'
          }, function (charge_code) {
            charge_code = charge_code.trim();
            if (charge_code.indexOf('ch_') === 0) {
              var query = common.sbx.insert('cart_box', {
                '_KEY': cartbox._KEY,
                'charge_code': charge_code
              });
              common.method.update(query).then(function () {
                dialog.close();
                var data = common.response.post_query.data;
                if (data.success) {
                  alertify.success('Charge code has been updated for order ' + cartbox.consecutive);
                } else {
                  alertify.error(data.msg);
                }
              }, function (err) {
                console.log(err);
                obj.load();
              }).finally(function () {
                obj.load();
              });
            } else {
              alertify.error('Must be a valid charge code.');
            }
          });
        }
      } else {
        if (cartbox.charge_code.indexOf('ch_') !== -1) {
          window.open('https://dashboard.stripe.com/payments/' + cartbox.charge_code, '_blank');
        } else {
          var model = common.actual_domain === 129 ? 1381 : 1002;
          obj.openOnSbx(cartbox.charge_code, 'audit', model);
        }
      }
    };

    obj.openGoogle = function (cartbox) {
      window.open('https://mail.google.com/mail/u/0/#search/' + cartbox.consecutive, '_blank');
    };

    obj.openOnSbx = function (key, opt, model) {
      if (obj.user.ibf_role === 'ADMIN') {
        if (opt !== 'audit') {
          model = common.actual_domain === 129 ? model : 834;
        }
        var params = void 0;
        if (opt === 'order' || opt === 'audit') {
          params = '%7B%22keys%22:%5B%22' + key + '%22%5D%7D';
        } else {
          params = '%5B%7B%22ANDOR%22:%22AND%22,%22GROUP%22:%5B%7B%22ANDOR%22:%22AND%22,%22VAL%22:%22' + key + '%22,%22FIELD%22:%22' + opt + '%22,%22OP%22:%22%3D%22%7D,%7B%22ANDOR%22:%22AND%22,%22VAL%22:%22' + common.convertDateToNumberDate(obj.packing_date) + '%22,%22FIELD%22:%22packing_date%22,%22OP%22:%22%3D%22%7D,%7B%22ANDOR%22:%22AND%22,%22VAL%22:null,%22FIELD%22:%22purchase%22,%22OP%22:%22IS%20NOT%22%7D%5D%7D%5D';
        }
        window.open('https://sbxcloud.com/#!/app/data/' + common.actual_domain + '/model/' + model + '/list?qr=' + params, '_blank');
      }
    };

    obj.getIconAndColor = function (cartbox, type) {
      var validation = cartbox.charge_code && (cartbox.charge_code.indexOf('ch_') !== -1 || cartbox.charge_code.indexOf('pi_') !== -1);

      switch (true) {
        case !cartbox.charge_code && !cartbox.charge_error:
          return type === 1 ? 'btn-danger' : 'fa-remove';
        case !!(!cartbox.charge_code && cartbox.charge_error):
          return type === 1 ? 'btn-warning' : 'fa-exclamation-triangle';
        case validation:
          return type === 1 ? 'btn-info' : 'fa-credit-card';
        case !validation:

          return type === 1 ? 'btn-gift' : 'fa-gift';
      }
    };

    obj.getCount = function () {
      var val1 = (obj.currentPage - 1) * obj.itemsPerPage + 1;
      var val2 = obj.currentPage * obj.itemsPerPage;
      if (val2 < obj.totalItems) {
        return '<strong>Showing</strong> ' + val1 + ' <strong>to</strong> ' + val2 + ' <strong>of</strong> ' + obj.totalItems;
      } else {
        return '<strong>Showing</strong> ' + val1 + ' <strong>to</strong> ' + obj.totalItems + ' <strong>of</strong> ' + obj.totalItems;
      }
    };

    obj.load = function () {
      if (!obj.packing_date) {
        return;
      }

      obj.country = null;

      obj.isLoading = true;
      obj.cartboxes = [];
      obj.filteredCartboxes = [];
      obj.growers = {};
      var query = common.getBaseQueryCartBox().andWhereIsNotNull('purchase').andWhereIsEqual('packing_date', common.convertDateToNumberDate(obj.packing_date));

      if (obj.user.ibf_role === 'COUNTRY_MANAGER') {
        var countries = obj.user.countries.map(function (item) {
          return item.country;
        });
        query.andWhereIn('grower.country', countries);
      }

      common.loadAllPages(query.compile(), function (res) {
        obj.isLoading = false;
        if (!res.results.length) {
          return;
        }
        common.fetchCartBox(res, function (data) {

          obj.cartboxes = data.results.map(function (cartbox) {

            if (cartbox.customer.closed_days) {
              cartbox.customer.closed_days = cartbox.customer.closed_days.replace(/,/g, ", ");
            }
            if (cartbox.charge_error) {

              if (cartbox.charge_error.includes("}") && JSON.parse(cartbox.charge_error)) {
                var error_message = JSON.parse(cartbox.charge_error).message;
                var date = JSON.parse(cartbox.charge_error).date;
                if (error_message) {
                  cartbox.error_message = error_message;
                }

                cartbox.error_date = date ? common.convertDateToMMDDYY(new Date(date)) : cartbox.charge_capture ? common.convertDateToMMDDYY(new Date(cartbox.charge_capture)) : cartbox.charge_date ? common.convertDateToMMDDYY(new Date(cartbox.charge_date)) : "";
              } else {
                cartbox.error_message = "CC Issue";

                if (cartbox.charge_error) {
                  if (cartbox.charge_error.includes(";")) {
                    cartbox.error_message = cartbox.charge_error.split(";")[0];
                  } else {}
                }

                cartbox.error_date = cartbox.charge_capture ? common.convertDateToNumberDate(new Date(cartbox.charge_capture)) : "";
              }
            }

            return cartbox;
          });

          var actualAddress = JSON.parse(data.results[0].customer.actual_address);
          obj.loadCustomerAddresses(data.results[0].customer._KEY, actualAddress);

          obj.filteredCartboxes = data.results.forEach(function (i) {
            if (i.purchase && i.purchase.street) {
              i.purchase.street = i.purchase.street.replace("'", "");
            }
            i.checked = false;
          });
        });

        // console.log(obj.filteredCartboxes)
        obj.totalItems = res.results.length;
        obj.currentPage = 1;
        res.results.forEach(function (item) {

          // item.total = item.subtotal * (1 - item.off) + (item.extra_freight_cost || 0);
          item.total = item.price * (1 - item.off);
          if (!obj.growers[item.grower._KEY]) {
            obj.growers[item.grower._KEY] = item.grower;

            obj.growers[item.grower._KEY]['orders'] = 1;

            if (item.carrier_name.toLowerCase() === "fedex" || !item.carrier_name) {
              if (item.grower_approved) {
                obj.growers[item.grower._KEY]['grower_approved_fedex'] = 1;
              } else {
                obj.growers[item.grower._KEY]['grower_approved_fedex'] = 0;
              }
              obj.growers[item.grower._KEY]['fedex_orders'] = 1;
            }

            if (item.grower_approved) {
              obj.growers[item.grower._KEY]['grower_approved'] = 1;
            } else {
              obj.growers[item.grower._KEY]['grower_approved'] = 0;
            }
          } else {
            obj.growers[item.grower._KEY]['orders'] += 1;
            if (item.grower_approved) {
              obj.growers[item.grower._KEY]['grower_approved'] += 1;
            }

            if (item.carrier_name.toLowerCase() === "fedex" || !item.carrier_name) {

              if (item.grower_approved) {
                obj.growers[item.grower._KEY]['grower_approved_fedex'] += 1;
              }

              if (!obj.growers[item.grower._KEY]['fedex_orders']) {
                obj.growers[item.grower._KEY]['fedex_orders'] = 1;
              } else {
                obj.growers[item.grower._KEY]['fedex_orders'] += 1;
              }
            }
          }
        });

        obj.filterList();
      }, function (err) {
        obj.isLoading = false;
        console.log(err);
        alertify.error(err);
      });
    };

    obj.notCharge = function (cartbox) {
      if (obj.isBusy) {
        return;
      }

      common.confirmModal({
        title: 'Info',
        msj: 'Are you sure?',
        saveText: 'Yes',
        cancelText: 'No',
        size: 'sm'
      }, function () {
        obj.isBusy = true;
        var dialog = common.showDialogProgress({ msj: 'Processing...' });
        var auditObj = {
          action: 'ADMIN_GIFT',
          user: common.getUserData().key,
          date: new Date(),
          description: 'The following order: ' + cartbox.consecutive + ' has been marked as a gift by ' + common.getUserData().data.name,
          object_string: JSON.stringify(cartbox)
        };
        common.createAudit(auditObj, function (res) {
          var query = common.sbx.insert('cart_box', {
            '_KEY': cartbox._KEY,
            'charge_code': res.keys[0]
          });

          common.method.update(query).then(function () {
            var data = common.response.post_query.data;
            obj.isBusy = false;
            dialog.close();
            if (!data.success) {
              alertify.error(data.msg);
            }
          }).finally(function () {
            dialog.close();
            obj.load();
          });
        }, function (err) {
          dialog.close();
          obj.isBusy = false;
          alertify.error(err);
        });
      });
    };

    obj.openPackinglistModal = function (carrier) {

      if (!angular.equals(obj.growers, {})) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/admin/' + (carrier === "fedex" ? "packingListModalFedex" : "packingListModalDhl") + '.html',
          controller: 'adminPackingListCtrl',
          controllerAs: 'modal',
          bindToController: true,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            config: function config() {
              return {
                growers: obj.growers,
                isFedex: carrier === "fedex",
                date: common.convertDateToNumberDate(obj.packing_date)
              };
            }
          }
        });

        modalInstance.result.then(function () {}, function (reason) {
          console.log(reason);
        });
      } else {
        alertify.error('You have to choose a packing date.');
      }
    };

    obj.openCustomsModal = function (carrier) {
      if (!angular.equals(obj.growers, {})) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/admin/customsModal.html',
          controller: 'adminCustomsCtrl',
          controllerAs: 'modal',
          bindToController: true,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            config: function config() {
              return {
                modalConfig: $uibModal,
                growers: obj.growers,
                date: common.convertDateToNumberDate(obj.packing_date)
              };
            }
          }
        });

        modalInstance.result.then(function () {}, function (reason) {
          console.log(reason);
        });
      } else {
        alertify.error('You have to choose a packing date.');
      }
    };

    obj.changeAddress = function (cartbox) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/purchaseorders.packing.change_address.html',
        controller: 'adminPurchasePackingChangeAddressCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              purchase: cartbox.purchase,
              customer: cartbox.customer._KEY
            };
          }
        }
      });

      modalInstance.result.then(function () {
        init();
      }, function (reason) {
        console.log(reason);
      });
    };

    obj.chargeCartboxesByCustomer = function (cartbox) {

      common.confirmModal({
        title: 'Charge cartboxes',
        msj: 'Are you sure yo want to charge all cartboxes for ' + cartbox.customer.company_name + '?',
        saveText: 'Charge',
        cancelText: 'Cancel'
      }, function () {
        obj.isLoading = true;
        common.method.run({
          key: environment.cloudscript.chargeCartboxes,
          params: { chargeDate: common.convertDateToNumberDate(cartbox.packing_date), customer: cartbox.customer._KEY }
        }).then(function (response) {
          if (response.charges) {
            alertify.success('All cartboxes were charged for ' + cartbox.customer.company_name);
            obj.isLoading = false;
            obj.load();
          } else {
            obj.isLoading = false;
            alertify.error('Error occurred, please try again.');
            cb('Error occurred, please try again.');
          }
        }, function () {
          obj.isLoading = false;
          // modal.loading = false;
          alertify.error('Error occurred, please try again.');
          cb('Error occurred, please try again.');
        });
      });
    };

    obj.changePacking = function (cartbox) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/purchaseorders.packing.pick_date.html',
        controller: 'adminPurchasePackingPickDateCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              cartbox: cartbox
            };
          }
        }
      });

      modalInstance.result.then(function () {
        init();
      }, function (reason) {
        console.log(reason);
      });
    };

    obj.changeMultiPacking = function () {

      var cartboxes = obj.filteredCartboxes.filter(function (item) {
        return item.checked;
      });

      if (cartboxes.length === 0) {
        alertify.error('You have to select at least one cartbox.');
        return;
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/purchaseorders.packing.multi_pick_date.html',
        controller: 'adminPurchasePackingMultiPickDateCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              packing_date: obj.packing_date,
              cartboxes: cartboxes
            };
          }
        }
      });

      modalInstance.result.then(function () {
        init();
      }, function (reason) {
        console.log(reason);
      });
    };

    common.setValueIssue = function (issue) {
      obj.issue = issue;
    };
    common.setValueRestoreInventory = function (restoreInventory) {
      obj.restoreInventory = restoreInventory;
    };
    obj.deleteOrder = function (cartbox) {

      var MS_PER_DAY = 24 * 60 * 60 * 1000;

      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var packing = cartbox.packing_date;
      packing.setHours(0, 0, 0, 0);

      var daysElapsed = (packing - today) / MS_PER_DAY;

      console.log('daysElapsed', daysElapsed);

      common.confirmModal({
        title: 'Warning',
        msj: 'Are you sure? \n do you want to delete this order?',
        save: 'Yes',
        cancel: 'No',
        size: 'md',
        msjClass: 'h4',
        showRestoreInventory: true,
        // restoreInventory: common.convertNumberDateToDate(cartbox.packing_date) <= new Date()
        restoreInventory: daysElapsed > 3
      }, function () {
        var dialog = common.showDialogProgress({ msj: 'Deleting..' });
        cartbox.restore_inventory = obj.restoreInventory;

        admin.deleteBoxPurchase(cartbox, function (res) {
          dialog.close();
          alertify.success(res);
          var meta = {
            user_id: common.getUserData().data.id,
            user_type: 'ADMIN'
          };
          common.registerEvent(meta, 'box_deleted');
          obj.load();
        }, function (res) {
          dialog.close();
          alertify.error(res.error);
        });
      });
    };

    obj.clear = function () {
      obj.searchText = '';
      obj.chargeCode = '';
      obj.filterApproved = '';
      obj.dates.selected = [];
      obj.dates.existing = [], obj.dates.lastAdjustedMonth = [];
      obj.filterList();
    };

    obj.filterList = function () {
      obj.countries = [];
      if (Array.isArray(obj.cartboxes) && obj.cartboxes.length > 0) {

        obj.cartboxes.forEach(function (box) {
          if (box && box.grower && box.grower.country && box.grower.country._KEY) {
            if (!obj.countries.some(function (country) {
              return country._KEY === box.grower.country._KEY;
            })) {
              obj.countries.push(box.grower.country);
            }
          }
        });
      }

      obj.filteredCartboxes = $filter('filter')(obj.cartboxes, function (value) {

        var nameCustomer = value.customer ? value.customer.company_name.toLowerCase() : '';
        var nameGrower = value.grower.name.toLowerCase();
        var consecutive = String(value.consecutive);

        var productGroup = value.product_group ? value.product_group.common_name.toLowerCase() : "";
        var variety = value.variety ? value.variety.variety_name.toLowerCase() : "";
        var approved = true;

        var condition = !obj.chargeCode;

        if (obj.filterApproved) {
          if (obj.filterApproved === 'yes') {
            approved = !!value.grower_approved === true;
          } else {
            approved = !!value.grower_approved === false;
          }
        }
        if (obj.chargeCode) {
          switch (obj.chargeCode) {
            case 'charged':
              condition = !!value.charge_code;
              break;
            case 'notCharged':
              condition = !value.charge_code && !value.charge_error;
              break;
            case 'error':
              condition = !!(!value.charge_code && value.charge_error);
              break;
          }
        }

        if (obj.carrier.toLowerCase() === "fedex") {
          condition = value.carrier_name.toLowerCase() === "fedex";
        }

        if (obj.country) {
          condition = condition && obj.country.includes(value.grower.country._KEY);
        }

        return (nameCustomer.indexOf(obj.searchText.toLowerCase()) !== -1 || nameGrower.indexOf(obj.searchText.toLowerCase()) !== -1 || consecutive.indexOf(obj.searchText.toLowerCase()) !== -1 || productGroup.indexOf(obj.searchText.toLowerCase()) !== -1 || variety.indexOf(obj.searchText.toLowerCase()) !== -1) && condition && approved;
      });

      if (obj.filteredCartboxes) {
        obj.totalItems = obj.filteredCartboxes.length;
      } else {
        obj.totalItems = 0;
      }

      obj.currentPage = 1;
    };

    init();
  }

  function adminPurchasePackingChangeAddressCtrl($scope, alertify, floristSrv, growerSrv, adminSrv, commonSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;

    modal.isLoading = false;
    modal.current = angular.copy(config.purchase);
    modal.customer = config.customer;
    modal.states = [];

    modal.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    modal.save = function () {
      var purchase = modal.current;
      var state = modal.states.find(function (item) {
        return item._KEY === purchase.state;
      });
      var customerAddress = {
        customer: modal.customer,
        address_object: JSON.stringify({
          address: purchase.street,
          state: { name: state.state, abbr: state.state_iso },
          zipcode: purchase.zipcode,
          city: purchase.city
        })
      };
      modal.isLoading = true;
      adminSrv.updatePurchaseAddress(purchase, function (res) {
        if (res.success) {
          alertify.success('Address updated successfully.');
          adminSrv.insertCustomerAddress(customerAddress, function (data) {
            if (data.success) {
              alertify.success('Address added to customer addresses successfully.');
            } else {
              alertify.error(res.error);
            }
            modal.isLoading = false;
            $uibModalInstance.close();
          });
        } else {
          alertify.error(res.error);
        }
      });
    };

    function init() {
      modal.isLoading = true;
      floristSrv.getStatesList(function (res) {
        modal.states = res.results.sort(function (a, b) {
          return a.state.localeCompare(b.state);
        });
        modal.isLoading = false;
      }, function (error) {
        modal.isLoading = true;
        alertify.error(error.message);
        modal.isLoading = false;
      });
    }

    init();
  }

  function adminPurchasePackingPickDateCtrl($scope, alertify, floristSrv, growerSrv, adminSrv, commonSrv, $uibModalInstance, config, $rootScope) {
    var modal = this,
        common = commonSrv;
    $scope.closeDays = [];
    modal.order_in_advance = 0;
    modal.user = common.getUserData();
    modal.current = angular.copy(config.cartbox);
    modal.originalGrower = '';
    modal.currentGrower = '';
    modal.growers = [];
    modal.informCustomer = 'no';
    modal.isLoading = false;
    modal.initialPackingDelay = null;
    modal.manager = { name: '', email: '', phone: '' };
    var diffDays = 0;
    var shipDays = [];
    modal.cartboxItems = [];
    // let minDate = new Date();
    // minDate.setDate(minDate.getDate() - 1);
    // let maxDate = new Date(modal.current.packing_date.getTime() + 12096e5); // 12096e5 is 14 days in ms — removed: no 14-day cap

    modal.reason = 0;
    modal.reasons = ['Payment issue', 'Supply issue', 'FedEx issue'];

    // Configurar las opciones de fecha con la función disabled
    modal.dateOptions = {
      // minDate: minDate,
      // maxDate: maxDate,
      dateDisabled: disabled

    };

    function disabled(data) {
      var daysOfWeek = {
        "SUNDAYS": 0,
        "MONDAYS": 1,
        "TUESDAYS": 2,
        "WEDNESDAYS": 3,
        "THURSDAYS": 4,
        "FRIDAYS": 5,
        "SATURDAYS": 6
      };

      if (!($rootScope.closedDays && $rootScope.closedDays.length) || data.mode !== 'day') {
        return false;
      }

      var closedDays = $rootScope.closedDays.map(function (closedDay) {
        var dayName = closedDay.closedDays;

        if (!dayName) {
          return 'NOT_CLOSED';
        }

        return dayName.toUpperCase();
      }).filter(function (day) {
        return day in daysOfWeek;
      });

      var today = data.date.getDay();

      var closedDaysOfWeek = closedDays.map(function (day) {
        return daysOfWeek[day];
      });

      return closedDaysOfWeek.includes(today);
    }

    function init() {
      modal.isLoading = true;
      modal.currentGrower = modal.current.grower._KEY;
      modal.originalGrower = angular.copy(modal.current.grower);
      modal.manager.email = modal.current.customer.acc_manager;
      modal.packing_date = modal.current.packing_date;
      shipDays = [modal.current.grower.shipday_sunday, modal.current.grower.shipday_monday, modal.current.grower.shipday_tuesday, modal.current.grower.shipday_wednesday, modal.current.grower.shipday_thursday, modal.current.grower.shipday_friday, modal.current.grower.shipday_saturday];
      modal.setNewEtaDate();
      modal.country_managers = {};

      adminSrv.getMasterlistsByCartbox(modal.current._KEY, function (res) {
        if (res.success) {
          res.masterlists.forEach(function (item) {
            if (item.order_in_advance > modal.order_in_advance) {
              modal.order_in_advance = item.order_in_advance;
            }
          });
          modal.setNewChargeDate();
        } else {
          alertify.error(res.message);
        }
      });

      var query = common.sbx.with('manager').andWhereIsEqual('email', modal.manager.email).compile();

      common.method.query(common.urls.find, query).then(function (data) {
        if (data.data.row_count) {
          var manager = data.data.results[0];
          modal.manager.name = manager.name;
          modal.manager.phone = manager.phone;
        }
      });

      var queryRequest = common.sbx.with('cart_box_item').andWhereIsEqual('cart_box', modal.current._KEY).fetchModels(['stems_per_bunch', 'product_group', 'variety', 'grower']).compile();

      common.method.query(common.urls.find, queryRequest).then(function (data) {
        if (data.data.success) {
          var fetched_results = data.data.fetched_results;
          var results = data.data.results;
          var items = [];
          for (var i = 0; i < results.length; i++) {
            items.push({
              stems_per_bunch: fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch,
              urlImage: results[i].picture,
              variety: fetched_results.variety[results[i].variety].variety_name,
              prod_name: fetched_results.product_group[results[i].product_group].common_name,
              grower: fetched_results.grower[results[i].grower].company_name,
              city: fetched_results.grower[results[i].grower].city,
              quantity: results[i].quantity,
              price: results[i].price,
              total: (results[i].quantity * results[i].price).toFixed(2),
              percentage: results[i].percentage,
              stem_bunch: fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch,
              total_price_stem: (results[i].price / fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch).toFixed(3),
              total_stems: results[i].quantity * fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch

            });
          }
          modal.cartboxItems = items;
        }
      });

      growerSrv.list(function (data) {
        modal.growers = data.data;
        if (modal.user.ibf_role === 'COUNTRY_MANAGER') {
          var countries = modal.user.countries.map(function (item) {
            return item.country;
          });
          modal.growers = data.data.filter(function (item) {
            var found = countries.find(function (i) {
              return i === item.country;
            });
            return !!found;
          });
        }
        // minDate.setDate(minDate.getDate() + 1);
        modal.isLoading = false;
      }, function (err) {
        console.log(err);
      });
    }

    modal.packingDateChanged = function () {
      if (modal.packing_date) {
        var newPacking = common.convertDateToNumberDate(modal.packing_date);
        var currentPacking = common.convertDateToNumberDate(modal.current.packing_date);
        return newPacking !== currentPacking;
      } else {
        return false;
      }
    };

    modal.recalculateShipping = function () {
      var grower = modal.growers.find(function (grower) {
        return grower._KEY === modal.currentGrower;
      });
      shipDays = [grower.shipday_sunday, grower.shipday_monday, grower.shipday_tuesday, grower.shipday_wednesday, grower.shipday_thursday, grower.shipday_friday, grower.shipday_saturday];

      var day = modal.packing_date ? modal.packing_date.getDay() : modal.current.packing_date.getDay();

      // if(shipDays[day] === 0) {
      //   alertify.error('You must select new packing date, the selected grower doesn\'t has packing on ' + common.convertDateToNumberDate(modal.packing_date));
      //   modal.packing_date = null;
      //   modal.eta_date = null;
      //   modal.charge_date = null;
      // } else {
      modal.packing_date = modal.packing_date ? modal.packing_date : modal.current.packing_date;
      modal.setNewEtaDate();
      modal.setNewChargeDate();
      // }
    };

    modal.open = function (name, evt) {
      modal[name] = true;
      evt.preventDefault();
    };

    modal.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    modal.setNewChargeDate = function () {
      var date = new Date(modal.packing_date.toISOString());
      date.setDate(date.getDate() - modal.order_in_advance);
      modal.charge_date = date;
    };

    function daysDifferent(fecha1, fecha2) {
      // Convertir las fechas a objetos Date
      var date1 = new Date(fecha1);
      var date2 = new Date(fecha2);

      // Obtener la diferencia en milisegundos
      var diferenciaEnMilisegundos = Math.abs(date2 - date1);

      // Convertir la diferencia a días (1 día = 24 * 60 * 60 * 1000 milisegundos)
      return Math.ceil(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));
    }

    modal.setNewEtaDate = function () {

      var differentDay = daysDifferent(modal.current.packing_date, modal.current.eta_date);
      if (modal.initialPackingDelay === null && differentDay) {
        modal.initialPackingDelay = differentDay;
      }

      var date = new Date(modal.packing_date.toISOString());

      if (shipDays[date.getDay()] === 0 && modal.initialPackingDelay) {
        diffDays = modal.initialPackingDelay;
      } else {
        diffDays = shipDays[date.getDay()];
      }

      date.setDate(date.getDate() + diffDays);
      modal.eta_date = date;
    };

    modal.setNewEtaDateManually = function () {
      modal.eta_date = new Date(modal.eta_date.toISOString());
    };

    modal.save = function () {
      modal.onLoading = true;
      if (!modal.packing_date) {
        alertify.error('You must change the packing date.');
        return;
      }

      if (modal.packingDateChanged() && modal.reason === 0) {
        alertify.error('You must select a issue.');
        return;
      }

      var user = common.getUserData();
      modal.isLoading = true;
      var template_key = {
        1: 'Payment',
        2: 'Supply',
        3: 'Carrier'
      };

      async.waterfall([function (cb) {
        var query = common.sbx.with('manager_countries').andWhereIsEqual("copy_email", true).orWhereIsEqual("main_email", true).fetchModels(["user"]).compile();

        common.loadAllPages(query, function (res) {
          res.results.forEach(function (manager) {
            if (res.fetched_results.user[manager.user]) {
              manager.email = res.fetched_results.user[manager.user].user_email;
              if (!modal.country_managers[manager.country]) {
                modal.country_managers[manager.country] = {
                  from: "",
                  cc: [],
                  sign: manager.sign
                };
              }

              if (manager.email && manager.main_email) {
                modal.country_managers[manager.country].from = manager.email;
              }

              if (manager.copy_email && manager.email) {
                modal.country_managers[manager.country].cc.push(manager.email);
              }
            }
          });

          cb(null);
        }, cb);
      }, function (cb) {
        var object = {
          '_KEY': modal.current._KEY,
          'eta_date': common.convertDateToNumberDate(modal.eta_date),
          'packing_date': common.convertDateToNumberDate(modal.packing_date),
          'charge_date': common.convertDateToNumberDate(modal.charge_date)
        };
        if (modal.currentGrower !== modal.current.grower._KEY) {
          object.grower = modal.currentGrower;
        }

        var query = common.sbx.insert('cart_box', object);

        common.method.update(query).then(function () {
          var data = common.response.post_query.data;
          if (data.success) {
            cb(null);
          } else {
            cb(data.msg);
          }
        });
      }, function (cb) {
        var auditObj = {
          action: 'MOVE_CARTBOX',
          user: user.key,
          date: new Date(),
          description: 'The user ' + user.data.name + ' with the ID ' + user.data.id + ' moved order #' + modal.current.consecutive + ': packing date from ' + common.convertDateToNumberDate(modal.current.packing_date) + ' to ' + common.convertDateToNumberDate(modal.packing_date) + ', ETA from ' + common.convertDateToNumberDate(modal.current.eta_date) + ' to ' + common.convertDateToNumberDate(modal.eta_date),
          object_string: JSON.stringify(modal.current)
        };
        if (modal.packingDateChanged()) {
          auditObj.reason = modal.reasons[modal.reason - 1];
        }
        floristSrv.createAudit(auditObj, function () {
          cb(null);
        }, function () {
          cb(null);
        });
      }, function (cb) {
        var prev_eta = moment(modal.current.eta_date);
        var new_eta = moment(modal.eta_date);

        if (modal.packingDateChanged() && modal.informCustomer === 'yes' && common.convertDateToNumberDate(prev_eta) !== common.convertDateToNumberDate(new_eta)) {
          /*let template_key = {
            1: 'Payment',
            2: 'Supply',
            3: 'FedEx'
          };*/
          var _prev_eta = moment(modal.current.eta_date).startOf('day');
          var _new_eta = moment(modal.eta_date).startOf('day');
          var days_passed = moment.duration(_new_eta.diff(_prev_eta)).asDays();
          var delivery_day = _new_eta > _prev_eta ? 'later' : 'earlier';

          var mail = {
            'subject': (common.actual_domain === 96 ? "[TEST]" : '') + ' Attention: your order #' + modal.current.consecutive + ' is scheduled for a new delivery day',
            'domain': common.actual_domain,

            'to': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com' : modal.current.customer.office_email,
            'cc': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com' : modal.current.customer.acc_manager,
            'bcc': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com,bcc@ibuyflowers.com' : "bcc@ibuyflowers.com,Supportteam@ibuyflowers.com",
            'from': common.actual_domain === 96 ? 'info@ibuyflowers.com' : modal.current.customer.acc_manager ? modal.current.customer.acc_manager : 'info@ibuyflowers.com',
            // 'template_key': common.move_order_fedex,
            // 'from': 'info@ibuyflowers.com',
            'template_key': common.move_order_supply,
            'data': {
              'issue': template_key[modal.reason],
              'total': modal.current.total,
              'quantity': modal.current.current_items,
              'price': modal.current.price,
              'variety': modal.current.variety.variety_name,
              'grower': modal.current.grower.name,
              'city': modal.current.grower.city,
              'customer': modal.current.customer.company_name,
              'order': modal.current.consecutive,
              'prod_name': modal.current.product_group.common_name,
              'length': modal.current.length + 'cm',
              'grade': modal.current.grade ? modal.current.grade.grade : '',
              'prev_eta': common.method.addZero(modal.current.eta_date.getMonth() + 1) + '/' + modal.current.eta_date.getDate() + '/' + modal.current.eta_date.getFullYear(),
              'new_eta': common.method.addZero(modal.eta_date.getMonth() + 1) + '/' + modal.eta_date.getDate() + '/' + modal.eta_date.getFullYear(),
              'manager': modal.manager,
              'custom': modal.current.custom,
              'stems_per_bunch': modal.cartboxItems[0].stems_per_bunch,
              items: modal.cartboxItems,
              'days_passed': days_passed <= 1 ? Math.abs(days_passed) + ' day ' + delivery_day : Math.abs(days_passed) + ' days ' + delivery_day
            }
          };

          common.method.send_mail(mail).then(function () {
            cb(null);
          }, function () {
            cb(null);
          });
        } else {
          cb(null);
        }
      }, function (cb) {
        var from = 'farmmanager@ibuyflowers.com';
        var bcc = common.actual_domain === 96 ? ['fleris.ramirez@sbxcloud.com'] : ['bcc@ibuyflowers.com'];
        var grower_country = modal.originalGrower.country;
        var sign = "";

        if (modal.country_managers[grower_country]) {
          if (modal.country_managers[grower_country].cc.length > 0) {
            modal.country_managers[grower_country].cc.forEach(function (cc) {
              bcc.push(cc);
            });
          }

          if (modal.country_managers[grower_country].from) {
            from = modal.country_managers[grower_country].from;
          }

          if (modal.country_managers[grower_country].sign) {
            sign = modal.country_managers[grower_country].sign;
          }
        }

        if (modal.originalGrower._KEY !== modal.currentGrower) {
          var mail = {
            'subject': ' ' + (common.actual_domain === 96 ? "[TEST]" : '') + ' Attention: Your order #' + modal.current.consecutive + ' has been reassigned',
            'domain': common.actual_domain,

            'to': modal.originalGrower.email_address,
            'cc': modal.current.customer.acc_manager,
            "bcc": bcc.join(", "),
            'from': from,
            'template_key': common.move_order_grower_notification,
            'data': {
              'grower': modal.originalGrower.company_name,
              'action': 'was transferred to another grower',
              'order': modal.current.consecutive,
              'manager': modal.manager
            }
          };
          common.method.send_mail(mail).then(function () {
            cb(null);
          }, function () {
            cb(null);
          });
        } else {
          if (modal.packingDateChanged()) {

            var query = common.sbx.with('user').andWhereIsEqual('grower', modal.originalGrower._KEY).compile();

            common.loadAllPages(query, function (data) {

              var users = data.results.map(function (user) {
                return user.user_email;
              });

              var mail = {
                'subject': (common.actual_domain === 96 ? "[TEST]" : '') + ' Attention: your order #' + modal.current.consecutive + ' is scheduled for a new packing date',
                'domain': common.actual_domain,

                'to': common.actual_domain === 96 ? 'ramiro.guzman@sbxcloud.com' : modal.originalGrower.email_address,
                // 'cc': modal.current.customer.acc_manager,
                "cc": users.filter(function (mail) {
                  return mail !== modal.originalGrower.email_address;
                }).join(", "),
                "bcc": bcc.join(", "),
                'from': from,
                'template_key': common.move_order_grower_notification,
                'data': {
                  'grower': modal.originalGrower.company_name,
                  'action': ' is now scheduled with a new order packing date',
                  'old_packing_date': modal.current.packing_date.toLocaleDateString('en-US'),
                  'new_packing_date': modal.packing_date.toLocaleDateString('en-US'),
                  'order': modal.current.consecutive,
                  'manager': modal.manager,
                  sign: sign
                }
              };
              common.method.send_mail(mail).then(function () {
                cb(null);
              }, function () {
                cb(null);
              });
            }, cb);
          } else {
            cb(null);
          }
        }
      }, function (cb) {
        var currentGrower = modal.growers.find(function (grower) {
          return grower._KEY === modal.currentGrower;
        });

        if (modal.originalGrower._KEY !== modal.currentGrower) {
          var mail = {
            'subject': 'Attention: The order #' + modal.current.consecutive + ' has been assigned to you',
            'domain': common.actual_domain,
            'to': currentGrower.email_address,
            // 'to' : 'martin@socobox.co',
            'cc': modal.current.customer.acc_manager,
            'from': 'farmsupport@ibuyflowers.com',
            'template_key': common.move_order_grower_notification,
            'data': {
              'grower': currentGrower.company_name,
              'action': ' was transferred to you, with order packing for date ' + modal.current.packing_date.toLocaleDateString('en-US'),
              'order': modal.current.consecutive,
              'manager': modal.manager
            }
          };
          common.method.send_mail(mail).then(function () {
            cb(null);
          }, function () {
            cb(null);
          });
        } else {
          cb(null);
        }
      }], function (err, res) {
        modal.isLoading = false;
        if (err) {
          alertify.error(err);
        } else {
          alertify.success('Cartbox moved successfully.');
        }
        $uibModalInstance.close();
      });
    };

    init();
  }

  function adminPurchasePackingMultiPickDateCtrl($scope, alertify, floristSrv, growerSrv, adminSrv, commonSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.prev_packing_date = config.packing_date;
    modal.packing_date = config.packing_date;
    modal.eta_date = null;
    modal.onLoading = false;
    modal.informCustomerDhl = 'no';
    modal.informCustomer = 'no';
    modal.isLoading = false;
    // let maxDate = new Date((modal.prev_packing_date).getTime() + 12096e5); // 12096e5 is 14 days in ms — removed: no 14-day cap
    modal.reason = 0;
    modal.reasonDhl = 0;
    modal.reasons = ['Payment issue', 'Supply issue', 'Carrier issue'];
    modal.cartboxes = [];
    modal.managers = {};
    modal.cartboxItems = {};

    function getBoxProperties(box, carrier) {
      return {
        _KEY: box._KEY,
        consecutive: box.consecutive,
        grower: box.grower,
        customer: box.customer,
        carrier: carrier ? carrier : "",
        variety: box.variety,
        total: box.total,
        price: box.price,
        custom: box.custom,
        length: box.length,
        total_items: box.total,
        product_group: box.product_group,
        grade: box.grade,
        prev_eta_date: box.eta_date,
        prev_packing_date: box.packing_date,
        eta_date: common.convertDateToNumberDate(modal.eta_date_fedex),
        packing_date: common.convertDateToNumberDate(modal.packing_date_fedex)
      };
    }

    modal.open = function (name, evt) {
      modal[name] = true;
      evt.preventDefault();
    };

    modal.dateOptions = {
      // minDate: minDate,
      // maxDate: maxDate,
      // dateDisabled: disabled
    };

    modal.packingDateChanged = function () {
      if (modal.packing_date_fedex) {
        var newPacking = common.convertDateToNumberDate(modal.packing_date_fedex);
        var currentPacking = common.convertDateToNumberDate(modal.prev_packing_date);
        return newPacking !== currentPacking;
      } else {
        return false;
      }
    };

    modal.save = function () {
      // modal.onLoading = true;

      var boxesDhl = [];
      var boxesFedex = [];

      var totalBoxes = [];

      if (modal.cartboxes.some(function (cb) {
        return !cb.carrier || cb.carrier_name.toLowerCase() === "fedex";
      })) {

        if (!modal.packing_date_fedex) {
          alertify.error('You must change the packing date for Fedex boxes.');
          return;
        }

        if (!modal.eta_date_fedex) {
          alertify.error('You must change the eta date for Fedex boxes.');
          return;
        }

        if (modal.packingDateChanged() && modal.reason === 0) {
          alertify.error('You must select a issue for Fedex boxes.');
          return;
        }

        modal.cartboxes.filter(function (cb) {
          return !cb.carrier || cb.carrier_name.toLowerCase() === "fedex";
        }).forEach(function (box) {
          boxesFedex.push(getBoxProperties(box, "fedex"));
        });
      }

      totalBoxes = totalBoxes.concat(boxesDhl);
      totalBoxes = totalBoxes.concat(boxesFedex);

      // console.log(boxesDhl)
      // console.log(boxesFedex)
      // console.log("totalBoxes", totalBoxes)
      var user = common.getUserData();
      modal.isLoading = true;
      var template_key = {
        1: 'Payment',
        2: 'Supply',
        3: 'Carrier'
      };

      async.waterfall([function (cb) {
        var query = common.sbx.with('manager_countries').andWhereIsEqual("copy_email", true).orWhereIsEqual("main_email", true).fetchModels(["user"]).compile();

        common.loadAllPages(query, function (res) {
          res.results.forEach(function (manager) {
            if (res.fetched_results.user[manager.user]) {
              manager.email = res.fetched_results.user[manager.user].user_email;
              if (!modal.country_managers[manager.country]) {
                modal.country_managers[manager.country] = {
                  from: "",
                  cc: [],
                  sign: manager.sign
                };
              }

              if (manager.email && manager.main_email) {
                modal.country_managers[manager.country].from = manager.email;
              }

              if (manager.copy_email && manager.email) {
                modal.country_managers[manager.country].cc.push(manager.email);
              }
            }
          });

          cb(null);
        }, cb);
      }, function (cb) {
        var query = common.sbx.insert('cart_box', totalBoxes.map(function (box) {
          return {
            _KEY: box._KEY,
            eta_date: box.eta_date,
            packing_date: box.packing_date
          };
        }));

        common.method.update(query).then(function () {
          var data = common.response.post_query.data;
          if (data.success) {
            cb(null);
          } else {
            cb(data.msg);
          }
        });
      }, function (cb) {

        var audits = totalBoxes.map(function (box) {

          return {
            action: 'MOVE_CARTBOX',
            user: user.key,
            date: new Date(),
            description: 'The user ' + user.data.name + ' with the ID ' + user.data.id + ' moved order #' + box.consecutive + ': packing date from ' + common.convertDateToNumberDate(box.prev_packing_date) + ' to ' + box.packing_date + ', ETA from ' + common.convertDateToNumberDate(box.prev_eta_date) + ' to ' + box.eta_date,
            object_string: JSON.stringify(box),
            reason: modal.reasons[modal.reason - 1]
          };
        });

        console.log("audits", audits);

        floristSrv.createAudit(audits, function () {
          cb(null);
        }, function () {
          cb(null);
        });
      }, function (cb) {
        if (modal.informCustomer === 'yes' || modal.informCustomerDhl === 'yes') {
          /*let template_key = {
            1: 'Payment',
            2: 'Supply',
            3: 'FedEx'
          };*/

          var condition1 = function condition1(box) {
            return (!box.carrier || box.carrier.toLowerCase() === "fedex") && modal.informCustomer === 'yes';
          };

          var execution = totalBoxes.filter(function (box) {
            return condition1(box);
          }).map(function (box) {
            return function (cbL) {
              var prev_eta = box.prev_eta_date;
              var new_eta = common.convertNumberDateToDate(box.eta_date);
              // const days_passed = moment.duration(new_eta.diff(prev_eta)).asDays()

              var time1 = prev_eta.getTime();
              var time2 = new_eta.getTime();
              var differenceInMilliseconds = time2 - time1;
              var differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
              var delivery_day = box.eta_date > common.convertDateToNumberDate(prev_eta) ? 'later' : 'earlier';

              var eta = common.convertNumberDateToDate(box.eta_date);

              // const prev_eta = common.convertNumberDateToDate(box.prev_eta_date);

              var mail = {
                'subject': (common.actual_domain === 96 ? "[TEST]" : '') + ' Attention: your order #' + box.consecutive + ' is scheduled for a new delivery day',
                'domain': common.actual_domain,

                'to': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com' : box.customer.office_email,
                'cc': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com' : box.customer.acc_manager,
                'bcc': common.actual_domain === 96 ? 'fleris.ramirez@sbxcloud.com,bcc@ibuyflowers.com' : "bcc@ibuyflowers.com,Supportteam@ibuyflowers.com",
                'from': common.actual_domain === 96 ? 'info@ibuyflowers.com' : box.customer.acc_manager ? box.customer.acc_manager : 'info@ibuyflowers.com',
                // 'template_key': common.move_order_fedex,
                // 'from': 'info@ibuyflowers.com',
                'template_key': common.move_order_supply,
                'data': {
                  'issue': template_key[condition1 ? modal.reason : modal.reasonDhl],
                  'total': box.total,
                  'quantity': box.current_items,
                  'price': box.price,
                  'variety': box.variety.variety_name,
                  'grower': box.grower.name,
                  'city': box.grower.city,
                  'customer': box.customer.company_name,
                  'order': box.consecutive,
                  'prod_name': box.product_group.common_name,
                  'length': box.length + 'cm',
                  'grade': box.grade ? box.grade.grade : '',
                  'prev_eta': common.method.addZero(box.prev_eta_date.getMonth() + 1) + '/' + box.prev_eta_date.getDate() + '/' + box.prev_eta_date.getFullYear(),
                  'new_eta': common.method.addZero(eta.getMonth() + 1) + '/' + eta.getDate() + '/' + eta.getFullYear(),
                  'manager': modal.managers[box.customer.acc_manager],
                  'custom': box.custom,
                  'stems_per_bunch': modal.cartboxItems[box._KEY][0].stems_per_bunch,
                  items: modal.cartboxItems[box._KEY] ? modal.cartboxItems[box._KEY] : [],
                  'days_passed': differenceInDays <= 1 ? Math.abs(differenceInDays) + ' day ' + delivery_day : Math.abs(differenceInDays) + ' days ' + delivery_day
                }
              };

              common.method.send_mail(mail).then(function () {
                cbL(null);
              }, function () {
                cbL(null);
              });
            };
          });

          async.parallel(execution, function (err, results) {
            cb(null);
          });
        } else {
          cb(null);
        }
      }, function (cb) {
        var execution = totalBoxes.map(function (box) {
          return function (cbL) {
            var from = 'farmmanager@ibuyflowers.com';
            var bcc = ['bcc@ibuyflowers.com'];
            var grower_country = box.grower.country;
            var sign = "";
            console.log("box packing", box.packing_date);
            console.log("locale packing date", common.convertNumberDateToDate(box.packing_date).toLocaleDateString('en-US'));
            if (modal.country_managers[grower_country]) {
              if (modal.country_managers[grower_country].cc.length > 0) {
                modal.country_managers[grower_country].cc.forEach(function (cc) {
                  bcc.push(cc);
                });
              }

              if (modal.country_managers[grower_country].from) {
                from = modal.country_managers[grower_country].from;
              }

              if (modal.country_managers[grower_country].sign) {
                sign = modal.country_managers[grower_country].sign;
              }
            }

            var query = common.sbx.with('user').andWhereIsEqual('grower', box.grower._KEY).compile();

            common.loadAllPages(query, function (data) {

              var users = data.results.map(function (user) {
                return user.user_email;
              });

              var mail = {
                'subject': (common.actual_domain === 96 ? "[TEST]" : '') + ' Attention: your order #' + box.consecutive + ' is scheduled for a new packing date',
                'domain': common.actual_domain,

                'to': common.actual_domain === 96 ? 'ramiro.guzman@sbxcloud.com' : box.grower.email_address,
                // 'cc': modal.current.customer.acc_manager,
                "cc": users.filter(function (mail) {
                  return mail !== box.grower.email_address;
                }).join(", "),
                "bcc": bcc.join(", "),
                'from': from,
                'template_key': common.move_order_grower_notification,
                'data': {
                  'grower': box.grower.company_name,
                  'action': ' is now scheduled with a new order packing date',
                  'old_packing_date': box.prev_packing_date.toLocaleDateString('en-US'),
                  'new_packing_date': common.convertNumberDateToDate(box.packing_date).toLocaleDateString('en-US'),
                  'order': box.consecutive,
                  'manager': modal.managers[box.customer.acc_manager],
                  sign: sign
                }
              };
              common.method.send_mail(mail).then(function () {
                cbL(null);
              }, function () {
                cbL(null);
              });
            }, cbL);
          };
        });

        async.parallel(execution, function (err, results) {
          cb(null);
        });
      }], function (err, res) {
        modal.isLoading = false;
        if (err) {
          alertify.error(err);
        } else {
          alertify.success('Cartbox moved successfully.');
        }
        $uibModalInstance.close();
      });
    };

    modal.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function init() {
      modal.country_managers = {};
      modal.isLoading = true;
      modal.cartboxes = config.cartboxes;
      modal.isFedexEmail = modal.cartboxes.some(function (cb) {
        return !cb.carrier || cb.carrier_name.toLowerCase() === "fedex";
      });
      var query = common.sbx.with('manager').andWhereIsIn('email', modal.cartboxes.map(function (cartbox) {
        return cartbox.customer.acc_manager;
      })).compile();

      common.method.query(common.urls.find, query).then(function (data) {
        if (data.data.row_count) {
          data.data.results.forEach(function (manager) {
            if (!modal.managers[manager.email]) {
              modal.managers[manager.email] = {};
            }

            modal.managers[manager.email].name = manager.name;
            modal.managers[manager.email].phone = manager.phone;
          });
        }
      });

      var queryRequest = common.sbx.with('cart_box_item').andWhereIsIn('cart_box.consecutive', modal.cartboxes.map(function (cartbox) {
        return cartbox.consecutive;
      })).fetchModels(['stems_per_bunch', 'product_group', 'variety', 'grower']).compile();

      common.method.query(common.urls.find, queryRequest).then(function (data) {
        if (data.data.success) {

          var fetched_results = data.data.fetched_results;
          var results = data.data.results;
          // let items = [];
          for (var i = 0; i < results.length; i++) {

            var item = results[i];

            if (!modal.cartboxItems[item.cart_box]) {
              modal.cartboxItems[item.cart_box] = [];
            }

            modal.cartboxItems[item.cart_box].push({
              stems_per_bunch: fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch,
              urlImage: results[i].picture,
              variety: fetched_results.variety[results[i].variety].variety_name,
              prod_name: fetched_results.product_group[results[i].product_group].common_name,
              grower: fetched_results.grower[results[i].grower].company_name,
              city: fetched_results.grower[results[i].grower].city,
              quantity: results[i].quantity,
              price: results[i].price,
              total: (results[i].quantity * results[i].price).toFixed(2),
              percentage: results[i].percentage,
              stem_bunch: fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch,
              total_price_stem: results[i].price / fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch,
              total_stems: results[i].quantity * fetched_results.stems_per_bunch[results[i].stems_per_bunch].stems_per_bunch
            });
          }

          modal.isLoading = false;
        } else {
          modal.isLoading = false;
        }
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminPurchasePackingCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminAccountingCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'floristSrv', 'growerSrv', '$filter', '$uibModal', adminAccountingCtrl]);

  function adminAccountingCtrl($scope, alertify, $state, $stateParams, commonSrv, floristSrv, growerSrv, $filter, $uibModal) {
    var obj = this,
        common = commonSrv;

    function init() {
      obj.activeTab = $stateParams.tab ? obj.tabs[$stateParams.tab] : 0;
    }

    obj.gotoTab = function (tab) {
      $state.go('admin.accounting', { tab: tab });
    };

    obj.isCurrent = function (name) {
      return $state.is('admin.accounting.' + name);
    };

    obj.include = function (name) {
      return $state.includes('admin.accounting.' + name);
    };

    obj.tabs = {
      'balance': 0,
      'growers': 1,
      'customers': 2,
      'changeEmail': 3
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminAccountingCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminBalanceCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'floristSrv', 'growerSrv', '$filter', '$uibModal', adminBalanceCtrl]).controller('dayBalanceCtrl', ['$scope', '$uibModalInstance', 'commonSrv', 'config', '$filter', dayBalanceCtrl]);

  function dayBalanceCtrl($scope, $uibModalInstance, commonSrv, config, $filter) {
    $scope.year = '';
    $scope.month = '';
    $scope.grower = '';

    $scope.packingDates = [];
    $scope.newPackingDates = [];
    $scope.csvPackingDates = [];

    $scope.totalItems = 0;
    $scope.currentPage = 1;
    $scope.itemsPerPage = 20;
    $scope.cartboxItems = [];
    $scope.listCartBoxItems = [];

    function init() {
      $scope.month = config.month;
      $scope.grower = config.grower;
      $scope.year = config.year;

      $scope.packingDates = _.flatten(Object.keys($scope.grower.packingDates).map(function (key) {
        return Object.keys($scope.grower.packingDates[key]).map(function (key2) {
          return $scope.grower.packingDates[key][key2];
        });
      }));

      console.log($scope.packingDates);

      var mapping = $scope.packingDates.reduce(function (acc, item) {
        if (!acc[item.date.getDate()]) {
          acc[item.date.getDate()] = { total: 0, items: [], date: item.date };
        }
        acc[item.date.getDate()].items.push(item);
        acc[item.date.getDate()].total += item.total;
        return acc;
      }, {});

      $scope.newPackingDates = Object.keys(mapping).map(function (key) {
        return mapping[key];
      });

      $scope.csvPackingDates = $scope.newPackingDates.map(function (item) {
        return { date: $filter('date')(item.date, 'MM/dd/yyyy'), balance: $filter('currency')(item.total) };
      });

      $scope.packingDates.forEach(function (pd) {
        pd.cartboxItems.forEach(function (cartBoxItem) {
          var cartBoxI = {
            PO: cartBoxItem.cart_box.purchase.consecutive,
            consecutive: pd.consecutive,
            date: $filter('date')(pd.date, 'MM/dd/yyyy'),
            customer: cartBoxItem.cart_box.customer.company_name,
            growerTotal: cartBoxItem.total_price
          };
          $scope.cartboxItems.push(cartBoxI);
        });
        $scope.totalItems = $scope.cartboxItems.length;
      });

      var cartBoxI = {
        PO: '',
        consecutive: '',
        date: '',
        customer: '',
        growerTotal: $scope.grower.total
      };
      $scope.cartboxItems.push(cartBoxI);

      $scope.csvPackingDates.push({
        date: 'Total',
        balance: $scope.grower.total
      });
    }

    $scope.close = function () {
      $uibModalInstance.close();
    };

    init();
  }

  function adminBalanceCtrl($scope, alertify, $state, $stateParams, commonSrv, floristSrv, growerSrv, $filter, $uibModal) {

    var obj = this,
        common = commonSrv,
        fs = floristSrv,
        gs = growerSrv;

    var today = new Date();
    obj.year = today.getFullYear();
    obj.month = today.getMonth().toString();
    obj.growers = [];
    obj.tableGrowers = [];
    obj.csvGrowers = [];

    obj.onLoading = false;
    obj.currentGrower = {};
    obj.conditions = {
      start_date: '',
      end_date: '',
      grower: 'allGrowers'
    };

    obj.totalBalance = obj.totalBalanceClient = 0;
    obj.keys = Object.keys;

    obj.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function init() {
      gs.list(function (res) {
        obj.growers = res.data.sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });
      });
    }

    obj.growerSelect = function (growers) {
      obj.tableGrowers = [];
      obj.csvGrowers = [];
      obj.totalBalance = 0;
      async.eachLimit(growers, 5, function (grower, next) {
        var aux = { grower: grower._KEY, start_date: obj.conditions.start_date, end_date: obj.conditions.end_date };
        fs.listOrdersByPackingDateAndGrower(aux, function (data) {
          grower.packingDates = data.map;
          grower.total = $filter('currency')(data.total);
          obj.totalBalance += data.total;
          obj.tableGrowers.push(grower);

          next();
        });
      }, function (err) {
        obj.onLoading = false;
        obj.tableGrowers.sort(function (a, b) {
          return a.company_name.localeCompare(b.company_name);
        });
        obj.csvGrowers = obj.tableGrowers.map(function (grower) {
          return { grower: grower.company_name, totalGrower: grower.total };
        });
        obj.csvGrowers.push({ grower: 'Total', totalGrower: $filter('currency')(obj.totalBalance) });
      });
    };

    obj.reload = function () {
      obj.onLoading = true;
      obj.currentGrower = obj.growers.find(function (grower) {
        return grower._KEY === obj.conditions.grower;
      });
      var parseMonth = parseInt(obj.month, 10);
      obj.conditions.start_date = new Date(obj.year, parseMonth, 1).numDateWithoutTimeZone();
      obj.conditions.end_date = new Date(obj.year, parseMonth + 1, 0).numDateWithoutTimeZone();

      if (obj.conditions.grower === 'allGrowers') obj.growerSelect(obj.growers);else obj.growerSelect([obj.currentGrower]);
    };

    obj.openModal = function (grower) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/accounting.dayBalanceModal.html',
        controller: 'dayBalanceCtrl',
        controllerAs: 'modal',
        bindToController: true,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              grower: grower,
              month: obj.months[obj.month],
              year: obj.year
            };
          }
        }
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminBalanceCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminSeasonCtrl', ['$scope', 'alertify', '$state', '$stateParams', '$filter', '$uibModal', 'commonSrv', 'adminSrv', adminSeasonCtrl]);

  function adminSeasonCtrl($scope, alertify, $state, $stateParams, $filter, $uibModal, commonSrv, adminSrv) {
    var obj = this,
        common = commonSrv;

    obj.seasons = [];
    obj.currentSeasons = [];
    obj.loading = true;
    obj.itemsPerPage = 15;
    obj.totalItems = 0;
    obj.currentPage = 1;
    obj.season_base = commonSrv.publicPathV3;
    obj.tempImage = 'images/image-placeholder.png';
    obj.search = '';

    function init() {
      adminSrv.getSeasons(function (data) {
        obj.seasons = data;
        obj.loading = false;
        obj.currentSeasons = obj.seasons = $filter('orderBy')(obj.seasons, 'from');

        obj.totalItems = obj.seasons.length;
      });
    }

    obj.filterSeasons = function () {
      obj.currentSeasons = $filter('filter')(obj.seasons, obj.search);
    };

    obj.deletedSearch = function () {
      obj.search = '';
      obj.currentSeasons = obj.seasons;
    };

    obj.updateSeason = function (season) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/seasons.edit.html',
        controller: 'adminSeasonEditCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              season: season
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        console.log(data);
      });
    };

    obj.updateSeasonsMasterlist = function (season) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/seasons.masterlist.html',
        controller: 'adminSeasonsEditMasterlist',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              season: season
            };
          }
        }
      });
      modalInstance.result.then(function (data) {
        console.log(data);
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminSeasonCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminSeasonEditCtrl', ['$scope', 'alertify', '$state', '$stateParams', '$filter', 'commonSrv', 'adminSrv', '$uibModalInstance', 'config', adminSeasonEditCtrl]).controller('adminSeasonsEditMasterlist', ['$scope', 'alertify', '$state', '$stateParams', '$filter', 'commonSrv', 'adminSrv', '$uibModalInstance', 'config', adminSeasonsEditMasterlist]);

  function adminSeasonEditCtrl($scope, alertify, $state, $stateParams, $filter, commonSrv, adminSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.placeholder = 'images/image-placeholder.png';
    modal.season_base = commonSrv.publicPathV3;
    modal.isLoading = false;

    function init() {
      if (config.season) {
        modal.season = config.season;
      } else {
        modal.season = {};
      }
      modal.tempImage = modal.season.image ? modal.season_base + modal.season.image : modal.placeholder;
    }

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.open = function (name, evt) {
      modal[name] = true;
      evt.preventDefault();
    };

    $scope.fileAdded = function (input) {
      modal.tempImage = URL.createObjectURL(input.files[0]);
    };

    modal.requirements = function () {
      return !modal.season.label || !modal.season.from || !modal.season.to;
    };

    modal.save = function () {
      if (modal.requirements()) {
        alertify.error('Some fields were missing!');
        return;
      }

      var season = {
        label: modal.season.label,
        from: commonSrv.convertDateToNumberDate(modal.season.from),
        to: commonSrv.convertDateToNumberDate(modal.season.to),
        exclude_bulk_promotion: modal.season.exclude_bulk_promotion
      };

      if (modal.season._KEY) {
        season._KEY = modal.season._KEY;

        adminSrv.updateSeasons(season, function (res) {
          if (modal.myFile) {
            modal.uploadFile();
          }
          alertify.success('Season updated successfully');
          modal.close();
        }, function (error) {
          alertify.error('Error occurred, try again.');
        });
      } else {
        adminSrv.addSeasons(season, function (res) {
          modal.season._KEY = res.data.keys[0];
          if (modal.myFile) {
            modal.uploadFile();
          }
          alertify.success('Season saved successfully');
          modal.close();
        }, function (error) {
          alertify.error('Error occurred, try again.');
        });
      }
    };

    modal.uploadFile = function () {
      modal.loading = true;

      var myBlob = common.dataURItoBlob(modal.myFile.compressed.dataURL);
      var myFile = new File([myBlob], modal.myFile.file.name);

      var fd = new FormData();
      fd.append('file', myFile, modal.myFile.file.name);
      fd.append('model', JSON.stringify({ key: common.season_images_folder_key }));

      adminSrv.uploadFileToUrl(fd, function (res) {
        if (res) {
          var season = {
            _KEY: modal.season._KEY || '',
            image: common.seasons_images_folder_name + modal.myFile.file.name
          };

          adminSrv.updateSeasons(season, function (res) {}, function (error) {
            alertify.error('Error occurred, try again.');
          });

          alertify.success('Product group image successfully uploaded.');
        } else {
          alertify.error('An error has occurred, please try again.');
        }
        modal.loading = false;
      });
    };

    init();
  }

  function adminSeasonsEditMasterlist($scope, alertify, $state, $stateParams, $filter, commonSrv, adminSrv, $uibModalInstance, config) {
    var modal = this,
        common = commonSrv;
    modal.currentMasterlist = [];
    modal.currentMasterlistTotalItems = [];
    modal.isLoadingMasterlist = false;
    modal.currentPage = 1;
    modal.search = '';
    modal.totalItems = 0;

    modal.currentMasterlistPage = 1;
    modal.currentTotalItems = 0;
    modal.currentSearch = '';
    modal.pageSize = 10;
    modal.masterlist = [];
    modal.loadingCurrentItems = true;

    function init() {
      if (config.season) {
        modal.season = config.season;
      } else {
        modal.season = {};
      }
      modal.tempImage = modal.season.image ? modal.season_base + modal.season.image : modal.placeholder;
      modal.loadSeasonsMasterlist();
    }

    modal.close = function () {
      $uibModalInstance.dismiss();
    };

    modal.loadSeasonsMasterlist = function () {
      modal.loadingCurrentItems = true;
      var params = {
        season: modal.season._KEY,
        page: modal.currentMasterlistPage,
        pageSize: modal.pageSize,
        search: modal.currentSearch || ''
      };
      adminSrv.getSeasonsMasterlist(params, function (res) {
        modal.loadingCurrentItems = false;
        modal.currentMasterlist = res.results || [];
        modal.currentTotalItems = res.totalItems;
      }, function (error) {
        alertify.error('Error occurred when fetching masterlist');
      });
    };

    modal.addSeasonsMasterlist = function (add_masterlist) {
      var params = {
        season: modal.season._KEY,
        add_masterlist: add_masterlist._KEY
      };

      adminSrv.getSeasonMasterlist(params, function (res) {
        var existMasterlist = res.results.length > 0;

        if (existMasterlist) {
          alertify.error('This seasons already has this masterlist added to it');
        } else {
          adminSrv.addSeasonsMasterlist(params, function (res) {
            if (modal.currentTotalItems >= modal.pageSize) {
              modal.loadSeasonsMasterlist();
            } else {
              modal.currentMasterlist.push(add_masterlist);
            }
            alertify.success('Masterlist added to this season');
          });
        }
      });
    };

    modal.deleteSeasonsMasterlist = function (add_masterlist) {
      var params = {
        season: modal.season._KEY,
        add_masterlist: add_masterlist._KEY
      };

      adminSrv.deleteSeasonMasterlist(params, function (res) {
        modal.loadSeasonsMasterlist();
        alertify.success('Masterlist deleted from this season');
      });
    };

    modal.pages = function () {
      modal.searchMasterlist(modal.search, modal.currentPage);
    };

    modal.searchMasterlist = function (search, page) {
      modal.isLoadingMasterlist = true;
      var params = {
        season: modal.season._KEY,
        search: search,
        page: page,
        pageSize: modal.pageSize
      };
      adminSrv.getMasterListSearch(params, function (data) {
        modal.isLoadingMasterlist = false;
        modal.masterlist = data.results;
        modal.totalItems = data.totalItems;
      }, function (error) {
        alertify.error('An error has occurred searching inventory');
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminSeasonEditCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminUpdateInventoryCtrl', ['$scope', 'alertify', '$state', '$stateParams', '$filter', 'commonSrv', 'adminSrv', 'productSrv', 'environment', adminUpdateInventoryCtrl]);

  function adminUpdateInventoryCtrl($scope, alertify, $state, $stateParams, $filter, commonSrv, adminSrv, productSrv, environment) {
    var obj = this,
        common = commonSrv;
    obj.loading = false;
    obj.lists = {
      countries: [],
      growers: [],
      masterlists: []
    };

    obj.conditions = {
      country: 'all',
      grower: 'all',
      masterlist: 'all'
    };

    obj.masterlistConfig = {
      create: false,
      highlight: true,
      valueField: '_KEY',
      delimiter: '|',
      sortField: 'search_name',
      searchField: ['search_name'],
      placeholder: 'Select Masterlist',
      maxItems: 1,
      render: {
        option: function option(data) {
          return '<div class="option"><span class="title">' + data.search_name + '</span></div>';
        },
        item: function item(data) {
          return '<div class="item"><span class="item">' + data.search_name + '</span></div>';
        }
      },
      onInitialize: function onInitialize(selectize) {
        // receives the selectize object as an argument

        obj.masterlistSelectize = selectize;
      }
    };

    function init() {
      obj.loading = true;
      commonSrv.listCountries(function (res) {
        obj.lists.countries = res.countries;
        obj.lists.countries.unshift({ _KEY: 'all', country_iso: 'All', country: 'All' });
        obj.loading = false;
      }, function (err) {
        alertify.error(err.message);
        obj.loading = false;
      });
    }

    obj.filterGrowersList = function () {
      if (obj.conditions.country === 'all') {
        obj.lists.growers = [];
      } else {
        obj.loading = true;
        adminSrv.getGrowersByCountry(obj.conditions.country, function (err, res) {
          obj.loading = false;
          if (err) {
            return alertify.error(err.message);
          }
          obj.lists.growers = res.growers;
          obj.lists.growers.unshift({ _KEY: 'all', company_name: 'All' });
        });
      }
    };

    obj.filterMasterlist = function () {
      if (obj.conditions.grower === 'all') {
        obj.lists.masterlists = [];
      } else {
        obj.loading = true;
        var fetch = ['variety.color', 'product_group', 'grade'];
        productSrv.loadMasterlistByGrower(obj.conditions.grower, fetch, function (res) {
          var fetched = res.fetched_results;
          obj.lists.masterlists = res.results.map(function (m) {
            var variety = fetched.variety[m.variety];
            var pg = fetched.product_group[m.product_group];
            var grade = fetched.grade[m.grade];
            var color = fetched.color[variety.color];
            m.search_name = pg.common_name + ' ' + variety.variety_name + ' <strong>' + color.color_name + '</strong>' + (grade ? ' (' + grade.grade + ') ' : ' ') + m.length + 'cm';
            return m;
          }).sort(function (a, b) {
            return a.search_name.localeCompare(b.search_name);
          });
          obj.loading = false;
        }, function (err) {
          alertify.error(err.message);
          obj.loading = false;
        });
      }
    };

    obj.updateInventory = function () {
      var type = undefined;
      var value = undefined;
      if (obj.conditions.masterlist !== 'all') {
        type = 'masterlist';
        value = obj.conditions.masterlist;
      } else {
        if (obj.conditions.grower !== 'all') {
          type = 'grower';
          value = obj.conditions.grower;
        } else {
          if (obj.conditions.country !== 'all') {
            type = 'country';
            value = obj.conditions.country;
          }
        }
      }

      obj.loading = true;
      common.method.run({
        key: environment.cloudscript.updateAllMasterlistInventory,
        params: { type: type, value: value }
      }).then(function () {
        alertify.success('Masterlist added to update queue.');
        obj.loading = false;
      }, function () {
        alertify.error('Error occurred, please try again.');
        obj.loading = false;
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminUpdateInventoryCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminShoppingsListViewCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', 'shoppingListSrv', adminShoppingsListViewCtrl]).controller('shoppingListItemsCtrl', ['$scope', '$uibModalInstance', 'commonSrv', 'config', '$filter', shoppingListItemsCtrl]);

  function shoppingListItemsCtrl($scope, $uibModalInstance, commonSrv, config, $filter) {
    function init() {
      $scope.shoppingList = config.shoppingList;
    }

    $scope.close = function () {
      $uibModalInstance.close();
    };

    init();
  }
  function adminShoppingsListViewCtrl($scope, alertify, commonSrv, $uibModal, shoppingListSrv) {
    var obj = this,
        common = commonSrv,
        sl = shoppingListSrv;

    function init() {
      obj.conditions = { customer: null, id: null };
    }

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    obj.dateChanged = function (date) {
      obj.conditions[date] = common.convertDateToNumberDate(obj[date]);
    };
    /******************************************
     * Get the standing order for the grower
     */
    obj.getShoppingLists = function () {
      obj.onLoading = true;
      sl.getShoppingLists(obj.conditions, function (_ref) {
        var list = _ref.list;

        obj.list = list.sort(function (a, b) {
          return b.consecutive - a.consecutive;
        });
        obj.onLoading = false;
        obj.mainList = list.sort(function (a, b) {
          return b.consecutive - a.consecutive;
        });
      }, function (error) {
        alertify.error(error);
        obj.list = [];
      });
    };
    obj.clear = function () {
      obj.list = [];
      obj.conditions = { customer: null, id: null, initial_date: null, open_end_date: null };
    };

    obj.openModal = function (shoppingList) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/shopping_list.shoppingListItemsModal.html',
        controller: 'shoppingListItemsCtrl',
        bindToController: true,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              shoppingList: shoppingList
            };
          }
        }
      });
    };

    obj.convertNumberDateToDate = function (number) {
      return common.convertNumberDateToDate(number);
    };
    init();
  }
})(angular);
//# sourceMappingURL=adminShoppingsListViewCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminShoppingListProductsCtrl', ['$scope', 'alertify', 'commonSrv', '$uibModal', 'shoppingListSrv', adminShoppingListProductsCtrl]);

  function adminShoppingListProductsCtrl($scope, alertify, commonSrv, $uibModal, shoppingListSrv) {
    var obj = this,
        common = commonSrv,
        sl = shoppingListSrv;
    obj.labels = [];
    obj.values = [];
    obj.conditions = {};

    function init() {}

    obj.open = function (name, evt) {
      obj[name] = true;
      evt.preventDefault();
    };

    obj.getChartData = function () {
      if (!$scope.$$phase) {
        $scope.$apply(function () {
          obj.dataTransform();
        });
      } else {
        obj.dataTransform();
      }
    };

    obj.dataTransform = function () {
      obj.labels = [];
      obj.values = [];
      obj.data.forEach(function (i) {
        obj.labels.push(i.name);
        obj.values.push(i.quantity - i.bought);
      });
      console.log(obj.labels);
    };

    obj.getProducts = function () {
      obj.data = obj.products;
      obj.getChartData();
    };

    obj.getVarieties = function (productGroup) {
      if (productGroup && productGroup.varieties) {
        obj.data = _.values(productGroup.varieties).sort(function (a, b) {
          return a.adherence - b.adherence;
        });
        obj.getChartData();
      }
    };

    obj.onClick = function (points, evt) {
      if (points && points[0] && points[0]._index) {
        obj.getVarieties(obj.data[points[0]._index]);
      }
    };

    obj.dateChanged = function (date) {
      obj.conditions[date] = common.convertDateToNumberDate(obj[date]);
    };

    obj.getShoppingLists = function () {
      sl.getShoppingLists(obj.conditions, function (_ref) {
        var items = _ref.items;

        items = items.reduce(function (result, item) {
          var productGroup = item.product_group._KEY;
          var variety = item.variety._KEY;

          if (item.bought > item.quantity) {
            item.bought = item.quantity;
          }

          if (!result[productGroup]) {
            result[productGroup] = Object.assign({}, item);
            result[productGroup].name = item.product_group.common_name;
            result[productGroup].varieties = {};
          } else {
            result[productGroup].quantity += item.quantity;
            result[productGroup].bought += item.bought;
          }
          if (!result[productGroup].varieties[variety]) {
            result[productGroup].varieties[variety] = Object.assign({}, item);
          } else {
            result[productGroup].varieties[variety].quantity += item.quantity;
            result[productGroup].varieties[variety].bought += item.bought;
          }

          result[productGroup].varieties[variety].adherence = common.roundTo(result[productGroup].varieties[variety].bought * 100 / result[productGroup].varieties[variety].quantity, 2) || 0;
          result[productGroup].adherence = common.roundTo(result[productGroup].bought * 100 / result[productGroup].quantity, 2) || 0;

          return result;
        }, {});
        console.log(items);
        obj.products = _.values(items).sort(function (a, b) {
          return a.adherence - b.adherence;
        });
        obj.data = obj.products;
        obj.getChartData();
      }, function (error) {
        alertify.error(error);
        obj.data = [];
      });
    };

    obj.convertNumberDateToDate = function (number) {
      return common.convertNumberDateToDate(number);
    };
    init();
  }
})(angular);
//# sourceMappingURL=adminShoppingListProductsCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminChangeEmailCtrl', ['$scope', 'alertify', 'commonSrv', 'environment', adminChangeEmailCtrl]);

  function adminChangeEmailCtrl($scope, alertify, commonSrv, environment) {
    var obj = this,
        common = commonSrv;
    obj.emailChangeRequest = [];

    obj.loadingAction = {
      accept: false,
      reject: false
    };
    obj.isLoading = true;
    obj.optionsFilter = [{ id: 1, type: 'name' }, { id: 2, type: 'state' }, { id: 3, type: 'margin' }];

    function init() {
      obj.getEmailChangeRequest();
    }

    obj.filterConfig = {
      create: false,
      highlight: true,
      valueField: 'id',
      delimiter: '|',
      searchField: ['type'],
      placeholder: 'Filter by',
      maxItems: 1,
      render: {
        option: function option(data, escape) {
          return '<div class="option">' + '<span class="title">' + escape(data.type) + '</span>' + '</div>';
        },
        item: function item(data, escape) {
          return '<div class="item">' + '<span class="item">' + escape(data.type) + '</span>' + '</div>';
        }
      }
    };
    obj.getEmailChangeRequest = function () {

      common.method.run({
        key: environment.cloudscript.getEmailChangeRequest,
        params: {}
      }).then(function (response) {
        obj.isLoading = false;
        if (response.success) {
          obj.emailChangeRequest = response.data;
        } else {
          alertify.error('An error occurred while loading the data');
          obj.isLoading = false;
        }
      }).catch(function (err) {
        alertify.error('An error has occurred on the server');
        obj.isLoading = false;
      });
    };

    obj.postEmailChangeRequest = function (user_id, email, _KEY, status, current_email, first_name, user_key, is_admin, customer_key) {
      var date = new Date();
      var dateTime = moment(date).format('DD/MM/YY [at] HH:mm a');

      common.confirmModal({
        title: 'Accept email change',
        msj: 'Are you sure? \n Do you want to accept the email change?',
        save: 'Yes',
        cancel: 'No'
      }, function () {
        obj.loadingAction.accept = true;
        var domain_id = environment.domain;
        common.method.postData('/user/v1/email', { user_id: user_id, email: email, domain_id: domain_id }).then(function () {
          var response = common.response.post.data;

          if (response.success) {
            obj.loadingAction.accept = false;
            obj.isLoading = false;
            obj.isLoading = true;

            alertify.success('The email has been changed');
            var params = {
              data: {
                _KEY: _KEY,
                current_email: email,
                new_email: '',
                status: status,
                to: current_email,
                name: first_name,
                updateEmail: email,
                date: dateTime,
                user_key: user_key,
                is_admin: is_admin,
                customer_key: customer_key
              }
            };
            common.method.run({
              key: environment.cloudscript.updateEmailChangeRequest,
              params: params
            }).then(function (response) {
              if (response.success) {
                alertify.success('The email has been updated');
                obj.getEmailChangeRequest();
              } else {
                alertify.error('Error updating, try again.');
                obj.isLoading = false;
              }
            }).catch(function (err) {
              obj.loadingAction.accept = false;
              obj.isLoading = false;
              alertify.error('An error has occurred on the server');
            });
          } else {
            alertify.error(response.error);
            obj.loadingAction.accept = false;
            obj.isLoading = false;
          }
        }).catch(function (err) {
          alertify.error('An error has occurred on the server');
        });
      });
    };

    obj.rejectedEmailChangeRequest = function (_KEY, status, current_email, first_name) {
      var params = {
        data: {
          _KEY: _KEY,
          status: status,
          to: current_email,
          name: first_name
        }
      };

      common.confirmModal({
        title: 'Reject email change',
        msj: 'Are you sure? \n Do you want to reject the email change?',
        save: 'Yes',
        cancel: 'No'
      }, function () {
        obj.loadingAction.reject = true;
        common.method.run({
          key: environment.cloudscript.updateEmailChangeRequest,
          params: params
        }).then(function (response) {
          obj.isLoading = true;
          if (response.success) {
            obj.loadingAction.reject = false;

            alertify.success('The email has been denied the change request');
            obj.getEmailChangeRequest();
          } else {
            alertify.error('Error updating, try again.');
            obj.loadingAction.reject = false;
            obj.isLoading = false;
          }
        }).catch(function (err) {
          alertify.error('An error has occurred on the server');
          obj.loadingAction.reject = false;
          obj.isLoading = false;
        });
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminChangeEmailCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('adminInventoryCtrl', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', '$uibModal', 'environment', adminInventoryCtrl]);

  function adminInventoryCtrl($scope, alertify, $state, commonSrv, sessionSrv, $uibModal, environment) {
    var inv = this,
        today = new Date(),
        common = commonSrv,
        session = sessionSrv;

    inv.include = function (name) {
      return $state.includes('country.inventory.' + name);
    };

    inv.inventories = [];
    inv.copyVarieties = [];
    inv.varieties = [];
    inv.copyInventory = [];
    inv.productGroups = [];
    inv.loading = false;
    inv.week = null;
    inv.week_to = null;
    inv.searchText = "";
    inv.prevText = "";
    inv.selectedGrower = "";
    inv.selectedVariety = "";
    inv.selectedProductGroup = "";
    inv.growers = [];
    inv.isManager = false;
    inv.totalItems = 0;

    inv.page = 1;

    inv.popup1 = {
      opened: false
    };

    inv.popup2 = {
      opened: false
    };

    inv.open1 = function () {
      inv.popup1.opened = true;
    };

    inv.open2 = function () {
      inv.popup2.opened = true;
    };

    function sliceInventory(inventory) {
      return inventory.slice(inv.page * 10 - 10, inv.page * 10);
    }

    inv.filterList = function (filter_from) {

      if (inv.selectedGrower) {
        inv.inventories = sliceInventory(inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }));
        inv.totalItems = inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }).length;

        if ((!filter_from || filter_from && filter_from !== "grower") && inv.copyVarieties.length > 0) {
          if (inv.selectedProductGroup) {
            inv.varieties = inv.copyVarieties.filter(function (variety) {
              return variety.product_group === inv.selectedProductGroup;
            });
          }

          if (inv.selectedVariety && !inv.selectedProductGroup) {
            inv.selectedProductGroup = inv.varieties.find(function (variety) {
              return variety._KEY === inv.selectedVariety;
            }).product_group;
          }
        } else {
          var query = common.sbx.with('add_masterlist').andWhereIsEqual('active', true).andWhereIsEqual('grower', inv.selectedGrower).fetchModels(["variety.color", "product_group"]);

          inv.loading = true;

          common.loadAllPages(query.compile(), function (response) {
            inv.varieties = Object.values(response.fetched_results.variety);
            inv.productGroups = Object.values(response.fetched_results.product_group).sort(function (a, b) {
              return (a.common_name ? a.common_name : "").localeCompare(b.common_name ? b.common_name : "");
            });

            inv.varieties = inv.varieties.map(function (variety) {

              var product_group = inv.productGroups.find(function (product_group) {
                return product_group._KEY === variety.product_group;
              });
              if (product_group) {
                variety.variety_name = product_group.common_name + " " + variety.variety_name;
              }

              if (variety.color && !variety.color.color_name) {
                variety.color = response.fetched_results.color[variety.color];
              }

              return variety;
            }).sort(function (a, b) {
              return (a.variety_name ? a.variety_name : "").localeCompare(b.variety_name ? b.variety_name : "");
            });

            if (inv.selectedProductGroup) {
              inv.varieties = inv.varieties.filter(function (variety) {
                return variety.product_group === inv.selectedProductGroup;
              });
            }

            if (inv.selectedVariety && !inv.selectedProductGroup) {
              inv.selectedProductGroup = inv.varieties.find(function (variety) {
                return variety._KEY === inv.selectedVariety;
              }).product_group;
            }

            inv.copyVarieties = inv.varieties;

            inv.loading = false;
          }, function (err) {
            inv.loading = false;
          });
        }

        // inv.varieties = inv.copyVarieties.filter(variety => variety.grower === inv.selectedGrower)
      } else {
        // inv.varieties = inv.copyVarieties
        if (inv.searchText) {
          var searchInventory = inv.copyInventory.filter(function (inventory) {
            return JSON.stringify(inventory).toLowerCase().includes(inv.searchText.toLowerCase());
          });
          inv.inventories = sliceInventory(searchInventory);
          inv.totalItems = searchInventory.length;
        } else {
          inv.inventories = sliceInventory(inv.copyInventory);
          inv.totalItems = inv.copyInventory.length;
        }
      }
    };

    function getMonday() {
      var d = new Date();
      var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    // function disabled2(data) {
    //   var date = data.date,
    //     mode = data.mode;
    //   return (
    //     mode === 'day' &&
    //     (date.getDay() === 0 ||
    //       date.getDay() === 1 ||
    //       date.getDay() === 2 ||
    //       date.getDay() === 3 ||
    //       date.getDay() === 4 ||
    //       date.getDay() === 6)
    //   );
    // }

    inv.dateOptions1 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      // minDate: getMonday(new Date()),
      startingDay: 1
    };

    inv.dateOptions2 = {
      dateDisabled: disabled1,
      formatYear: 'yy',
      maxDate: new Date(today.getFullYear() + 3, 5, 22),
      // minDate: getMonday(new Date()),
      startingDay: 1
    };

    inv.checkDates = function () {
      // inv.getInventory();
    };

    inv.clear = function () {
      // inv.inventories = sliceInventory(inv.copyInventory)
      inv.copyInventory = [];
      inv.inventories = [];
      inv.searchText = "";
      inv.selectedGrower = "";
      inv.selectedVariety = "";
      inv.selectedProductGroup = "";
      inv.week = null;
      inv.week_to = null;
      // inv.week = null
      // inv.getInventory()
      // inv.week = null
      // inv.getInventory()
    };

    inv.showClear = function () {
      return !!inv.searchText || !!inv.selectedGrower || !!inv.week;
    };

    inv.disableInventory = function (inventory) {
      common.confirmModal({
        title: 'Disable inventory',
        msj: 'Are you sure that you want disable the current inventory for the week ' + inventory.week + " and set quantity equal to 0?",
        saveText: 'Yes'
      }, function () {

        inv.loading = true;
        var query = common.sbx.insert('inventory', { _KEY: inventory._KEY, quantity: 0, freeze: true });

        common.method.update(query).then(function (data) {
          if (data.success) {
            inv.recordInventoryDeletionAudit(inventory);
            inv.getInventory();
            alertify.log('Disabling inventory...');

            common.method.run({
              key: environment.cloudscript.ibf_removeInventoryCart,
              params: {
                inventory: inventory._KEY,
                masterlist: inventory.masterlist._KEY
              }
            }).then(function (res) {
              if (res.success) {
                alertify.success('the inventory was disabled.');
                inv.loading = false;
              } else {
                inv.loading = false;
              }
            });
          } else {
            inv.loading = false;
            alertify.error('Error updating, try again.');
          }
        });
      });
    };

    inv.recordInventoryDeletionAudit = function (inventoryItem) {
      var selectedGrowerName = inv.growers.find(function (grower) {
        return grower._KEY === inv.selectedGrower;
      }).company_name || '';
      var currentUserFullName = '(' + [common.getUserData().data.first_name, common.getUserData().data.last_name].filter(Boolean).join(' ') + ')';

      var auditLogEntries = {
        action: 'DELETE_INVENTORY',
        user: common.getUserData().key,
        date: new Date(),
        description: 'The user ' + currentUserFullName + ' delete an inventory for week ' + common.convertDateToNumberDate(inv.week) + ' for the grower ' + selectedGrowerName,
        object_string: JSON.stringify({
          grower: inventoryItem.grower._KEY,
          masterlist: inventoryItem.masterlist._KEY,
          inventory: inventoryItem._KEY,
          UoM: inventoryItem.masterlist.UoM,
          product_group: inventoryItem.product_group._KEY,
          variety: inventoryItem.variety._KEY,
          freeze: "true"
        })
      };

      var query = common.sbx.insert("audit", auditLogEntries);

      common.method.insert(query).then(function (data) {

        if (data.success) {} else {}
      });
    };

    inv.updateInventory = function (inventory) {
      common.confirmModal({
        title: 'Update inventory',
        msj: 'Are you sure that you want update the current inventory for the week ' + inventory.week + " and set quantity equal to " + inventory.quantity + "?",
        saveText: 'Yes'
      }, function () {

        inv.loading = true;
        var query = common.sbx.insert('inventory', { _KEY: inventory._KEY, quantity: inventory.quantity });

        common.method.update(query).then(function (data) {
          if (data.success) {
            inv.loading = false;
            getInventory();
            alertify.success('the inventory was updated.');
          } else {
            inv.loading = false;
            alertify.error('Error updating, try again.');
          }
        });
      });
    };

    inv.nextPage = function () {
      if (inv.selectedGrower) {
        inv.inventories = sliceInventory(inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }));
      } else {
        inv.inventories = sliceInventory(inv.copyInventory);
      }
    };

    function setInventories(response, fetch) {
      inv.inventories = response.results.map(function (inventory) {
        inventory["grower"] = fetch["grower"][inventory["grower"]];
        if (inventory["grower"] && !inv.growers.some(function (grower) {
          return grower._KEY === inventory["grower"]._KEY;
        })) {
          inv.growers.push(inventory["grower"]);
        }

        inventory["variety"] = fetch["variety"][inventory["variety"]];

        if (!inventory["variety"]["color"].color_name) {
          inventory["variety"]["color"] = fetch["color"][inventory["variety"]["color"]];
        }

        inventory["masterlist"] = fetch["add_masterlist"][inventory["masterlist"]];

        if (inventory["masterlist"]["grade"] && !inventory["masterlist"]["grade"].grade) {
          inventory["masterlist"]["grade"] = fetch["grade"][inventory["masterlist"]["grade"]];
        }

        inventory["product_group"] = fetch["product_group"][inventory["masterlist"]["product_group"]];
        return inventory;
      }).sort(function (a, b) {
        return a.variety.variety_name.localeCompare(b.variety.variety_name);
      }).sort(function (a, b) {
        return a.masterlist.length - b.masterlist.length;
      });

      inv.copyInventory = inv.inventories;
      inv.inventories = sliceInventory(inv.copyInventory);
      inv.totalItems = inv.copyInventory.length;

      inv.loading = false;
    }

    inv.getInventory = function (search) {

      if (inv.isManager) {
        if (!inv.selectedGrower) {
          alertify.error('Please select a grower.');
          return;
        }
      }

      // if (!inv.week_to){
      //   alertify.error('Please select end week range.');
      //   return;
      // }

      if (!inv.selectedVariety && !inv.selectedProductGroup) {
        alertify.error('Please select a variety or product group.');
        return;
      }

      inv.loading = true;
      var query = null;

      var week = inv.week ? inv.week : getMonday();
      // const week_to = inv.week_to ? inv.week_to : null


      if (common.getUserData().ibf_role === "COUNTRY_MANAGER") {
        var countries = common.getUserData().countries;

        if (countries && countries.length > 0) {
          countries = countries.map(function (country) {
            return country.country;
          });

          query = common.sbx.with('inventory').andWhereIsEqual('masterlist.active', true).andWhereIsIn('grower.country', countries).andWhereIsEqual('grower', inv.selectedGrower);
          // .setPageSize(10)
        }
      } else {
        if (common.getUserData().grower) {
          query = common.sbx.with('inventory').andWhereIsEqual('masterlist.active', true).andWhereIsEqual('grower', common.getUserData().grower);
          // .setPageSize(10)
        }
      }

      if (query) {

        if (inv.selectedVariety) {
          query.andWhereIsEqual('variety', inv.selectedVariety);
        }

        if (inv.selectedProductGroup) {
          query.andWhereIsEqual('variety.product_group', inv.selectedProductGroup);
        }

        query.andWhereIsEqual('week', common.convertDateToNumberDate(week))
        // query.andWhereLessOrEqualThan('week', common.convertDateToNumberDate(week_to))

        .fetchModels(["grower", "variety.color", "masterlist.product_group", "masterlist.grade"]);

        common.loadPage(query.compile(), inv.page, function (response) {
          setInventories(response, response.fetched_results);
        }, function (err) {});
      }

      // if (inv.week && query) {
      //   query.andWhereIsEqual("week", common.convertDateToNumberDate(inv.week))
      // }

    };

    function init() {

      inv.isManager = common.getUserData().ibf_role === "COUNTRY_MANAGER";

      inv.loading = true;

      inv.week = getMonday();

      common.method.run({
        key: environment.cloudscript.loadDependencies,
        params: { includes: ['grower'] }
      }).then(function (res) {
        if (res.success) {
          res = res.results;
          var growersMap = common.arrayToMap(res.grower.filter(function (item) {
            return item.active;
          }), '_KEY');
          // const varietyMap = common.arrayToMap(res.variety, '_KEY');
          // const masterlistMap = common.arrayToMap(res.add_masterlist, '_KEY');
          // inv.varieties = common.removeDuplicateFromArrayObj(res.variety.sort((a, b) => (a.variety_name ? a.variety_name : "").localeCompare(b.variety_name ? b.variety_name : "")), "variety_name")
          inv.growers = res.grower.filter(function (item) {
            return item.active;
          }).sort(function (a, b) {
            return a.company_name.localeCompare(b.company_name);
          });
          inv.loading = false;
          //
          //
          //
          // inv.varieties = inv.varieties.reduce((arr, variety) => {
          //   const masterlist = Object.keys(masterlistMap).find(key => masterlistMap[key].variety === variety._KEY)
          //   if(masterlist){
          //     const newObj = Object.assign({grower: masterlistMap[masterlist].grower}, variety);
          //
          //     arr.push(newObj)
          //   }
          //
          //   return arr
          // }, [])
          //
          // inv.copyVarieties = inv.varieties


          inv.dependenciesCache = {
            grower: growersMap,
            variety: {},
            product_group: {}
          };
        }
      });
    }

    init();
  }
})(angular);
//# sourceMappingURL=adminInventoryCtrl.js.map

"use strict";

(function (angular) {
  angular.module("ibf").controller("growerSetupStandingOrdersCntrl", ["$state", "commonSrv", "alertify", growerSetupStandingOrdersCntrl]);

  function growerSetupStandingOrdersCntrl($state, commonSrv, alertify) {
    var obj = this,
        common = commonSrv;

    obj.infoStandingOrder = false;
    obj.loading = true;
    obj.user = common.getUserData();

    var content = this,
        common = commonSrv;

    function init() {
      if (obj.user.grower) {

        var query = commonSrv.sbx.with('grower').whereWithKeys([obj.user.grower]).compile();
        commonSrv.loadAllPages(query, function (res) {
          if (res && res.results) {
            var grower = res.results[0];
            obj.infoStandingOrder = grower.so_quantity_duplication;
            obj.loading = false;
          } else {
            obj.loading = false;
          }
        }, function (err) {
          obj.loading = false;
        });
      } else {
        obj.loading = false;
      }
    }

    content.isCurrent = function (name) {
      return $state.is("grower.setup." + name);
    };

    content.include = function (name) {
      return $state.includes("grower.setup." + name);
    };

    obj.updatePropertySoQuantityDuplicationGrower = function (grower, value) {
      var query = {
        domain: common.actual_domain,
        rows: [{
          so_quantity_duplication: value,
          _KEY: grower
        }],
        row_model: "grower"
      };

      common.method.query(common.urls.update, query).then(function () {
        var data = common.response.post_query.data;

        if (data.success) {
          alertify.success("Your choice has been successfully updated.");
          obj.infoStandingOrder = value;
        } else {
          alertify.error(data.msg);
        }
      });
    };

    obj.showModalConfirm = function (user, valueSoQuantityDuplication) {
      common.confirmModal({
        msj: '<div class="d-flex pt-2"><i class="fa fa-warning text-warning mr-2 mt-2 font-22"></i> <p class="px-2">Are you sure that you want to change the quantity doubling for Valentine\'s day and Mother\'s day? It does not affect the currently approved Standing Orders, only the new ones.</p> </div>',
        saveText: "No, go back",
        cancelText: "Yes",
        saveBtnColor: "btn-cancel-border-pink px-md-4",
        cancelBtnColor: "btn-dark-pink  px-4rem",
        size: "md"
      }, function () {}, function () {
        obj.updatePropertySoQuantityDuplicationGrower(user, valueSoQuantityDuplication);
      });
    };

    obj.showTermsAndConditions = function () {
      common.confirmModal({
        msj: '<div class="d-flex pt-2"><i class="fa fa-warning text-warning mr-2 mt-2 font-22"></i> ' + '<p class="px-2">By selecting “Yes” to double the quantities for Standing Orders during the week before ' + 'Valentine’s Day and Mother’s Day, you agree that this change will only apply to new yearly weekly Standing ' + 'Orders created and approved after the setting is updated. Existing approved Standing Orders will remain ' + 'unaffected. By enabling holiday quantity doubling, you commit to delivering double the agreed quantity of ' + 'products to customers who have opted into this service at the same price per unit as specified in their ' + 'original yearly weekly Standing Orders.</p> ' + '</div>',
        saveText: "Ok",
        saveBtnColor: "btn-cancel-border-pink px-md-4",
        cancelBtnColor: "btn-dark-pink  px-4rem",
        size: "md",
        hideCancel: true
      }, function () {}, function () {
        // obj.updatePropertySoQuantityDuplicationGrower(user, valueSoQuantityDuplication);
      });
    };

    obj.handleInfoStandingOrderChange = function (value) {

      var user = obj.user.grower;
      obj.infoStandingOrder = value;

      if (obj.infoStandingOrder === "no") {
        obj.showModalConfirm(user, false);
      } else {
        obj.showModalConfirm(user, true);
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=growerSetupStadingOrders.js.map

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (angular) {
  angular.module("ibf").controller("adminDeleteMultipleInventoryCtrl", ["$scope", "alertify", "$state", "commonSrv", "sessionSrv", "$uibModal", "environment", adminDeleteMultipleInventoryCtrl]);

  function adminDeleteMultipleInventoryCtrl($scope, alertify, $state, commonSrv, sessionSrv, $uibModal, environment) {
    var inv = this,
        today = new Date(),
        common = commonSrv,
        session = sessionSrv;

    inv.include = function (name) {
      return $state.includes("country.inventory." + name);
    };

    inv.inventories = [];
    inv.copyVarieties = [];
    inv.varieties = [];
    inv.copyInventory = [];
    inv.productGroups = [];
    inv.loading = false;
    inv.week = null;
    inv.endDate = null;
    inv.searchText = "";
    inv.selectedGrower = "";
    inv.selectedVariety = "";
    inv.selectedProductGroup = "";
    inv.growers = [];
    inv.isManager = false;
    inv.totalItems = 0;
    inv.checkedAllItems = false;

    inv.page = 1;

    inv.popup1 = {
      opened: false
    };

    inv.popup3 = {
      opened: false
    };

    inv.open1 = function () {
      inv.popup1.opened = true;
    };

    inv.open3 = function () {
      inv.popup3.opened = true;
    };

    function sliceInventory(inventory) {
      return inventory.slice(inv.page * 10 - 10, inv.page * 10);
    }

    inv.filterList = function (filter_from) {
      if (inv.selectedGrower) {
        inv.inventories = sliceInventory(inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }));
        inv.totalItems = inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }).length;

        if ((!filter_from || filter_from && filter_from !== "grower") && inv.copyVarieties.length > 0) {
          if (inv.selectedProductGroup) {
            inv.varieties = inv.copyVarieties.filter(function (variety) {
              return variety.product_group === inv.selectedProductGroup;
            });
          }

          if (inv.selectedVariety && !inv.selectedProductGroup) {
            inv.selectedProductGroup = inv.varieties.find(function (variety) {
              return variety._KEY === inv.selectedVariety;
            }).product_group;
          }
        } else {
          var query = common.sbx.with("add_masterlist").andWhereIsEqual("active", true).andWhereIsEqual("grower", inv.selectedGrower).fetchModels(["variety.color", "product_group"]);

          inv.loading = true;

          common.loadAllPages(query.compile(), function (response) {
            inv.varieties = Object.values(response.fetched_results.variety);
            inv.productGroups = Object.values(response.fetched_results.product_group).sort(function (a, b) {
              return (a.common_name ? a.common_name : "").localeCompare(b.common_name ? b.common_name : "");
            });

            inv.varieties = inv.varieties.map(function (variety) {
              var product_group = inv.productGroups.find(function (product_group) {
                return product_group._KEY === variety.product_group;
              });
              if (product_group) {
                variety.variety_name = product_group.common_name + " " + variety.variety_name;
              }

              if (variety.color && !variety.color.color_name) {
                variety.color = response.fetched_results.color[variety.color];
              }

              return variety;
            }).sort(function (a, b) {
              return (a.variety_name ? a.variety_name : "").localeCompare(b.variety_name ? b.variety_name : "");
            });

            if (inv.selectedProductGroup) {
              inv.varieties = inv.varieties.filter(function (variety) {
                return variety.product_group === inv.selectedProductGroup;
              });
            }

            if (inv.selectedVariety && !inv.selectedProductGroup) {
              inv.selectedProductGroup = inv.varieties.find(function (variety) {
                return variety._KEY === inv.selectedVariety;
              }).product_group;
            }

            inv.copyVarieties = inv.varieties;

            inv.loading = false;
          }, function (err) {
            inv.loading = false;
          });
        }
      } else {
        if (inv.searchText) {
          var searchInventory = inv.copyInventory.filter(function (inventory) {
            return JSON.stringify(inventory).toLowerCase().includes(inv.searchText.toLowerCase());
          });
          inv.inventories = sliceInventory(searchInventory);
          inv.totalItems = searchInventory.length;
        } else {
          inv.inventories = sliceInventory(inv.copyInventory);
          inv.totalItems = inv.copyInventory.length;
        }
      }
    };

    function getMonday() {
      var d = new Date();
      var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    }

    function disabled1(data) {
      var date = data.date,
          mode = data.mode;
      return mode === "day" && (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 4 || date.getDay() === 5);
    }

    function getDateOptions(disabledFn) {
      return {
        dateDisabled: disabledFn,
        formatYear: "yy",
        maxDate: new Date(today.getFullYear() + 3, 5, 22),
        startingDay: 1
      };
    }

    inv.dateOptions1 = getDateOptions(disabled1);

    inv.dateOptions3 = getDateOptions(disabled1);

    inv.clear = function () {
      inv.copyInventory = [];
      inv.inventories = [];
      inv.searchText = "";
      inv.selectedGrower = "";
      inv.selectedVariety = "";
      inv.selectedProductGroup = "";
      inv.week = null;
      inv.endDate = null;
    };

    inv.showClear = function () {
      return !!inv.searchText || !!inv.selectedGrower || !!inv.week || !!inv.endDate;
    };

    inv.nextPage = function () {
      if (inv.selectedGrower) {
        inv.inventories = sliceInventory(inv.copyInventory.filter(function (inventory) {
          return inventory.grower._KEY === inv.selectedGrower;
        }));
      } else {
        inv.inventories = sliceInventory(inv.copyInventory);
      }
    };

    function setInventories(response, fetch) {
      inv.inventories = response.results.map(function (inventory) {
        inventory["grower"] = fetch["grower"][inventory["grower"]];
        if (inventory["grower"] && !inv.growers.some(function (grower) {
          return grower._KEY === inventory["grower"]._KEY;
        })) {
          inv.growers.push(inventory["grower"]);
        }

        inventory["variety"] = fetch["variety"][inventory["variety"]];

        if (!inventory["variety"]["color"].color_name) {
          inventory["variety"]["color"] = fetch["color"][inventory["variety"]["color"]];
        }

        inventory["masterlist"] = fetch["add_masterlist"][inventory["masterlist"]];

        if (inventory["masterlist"]["grade"] && !inventory["masterlist"]["grade"].grade) {
          inventory["masterlist"]["grade"] = fetch["grade"][inventory["masterlist"]["grade"]];
        }

        inventory["product_group"] = fetch["product_group"][inventory["masterlist"]["product_group"]];
        return inventory;
      }).sort(function (a, b) {
        return a.week - b.week;
      }).sort(function (a, b) {
        return a.variety.variety_name.localeCompare(b.variety.variety_name);
      }).sort(function (a, b) {
        return a.masterlist.length - b.masterlist.length;
      });

      inv.copyInventory = inv.inventories;

      inv.inventories = sliceInventory(inv.copyInventory);
      inv.totalItems = inv.copyInventory.length;

      inv.loading = false;
    }

    inv.getCartboxesItemsKeys = function (keys) {
      var query = common.sbx.with("cart_box_item").andWhereIn('inventory', keys).andWhereIsNull('cart_box.purchase');

      return new Promise(function (resolve, reject) {
        common.loadAllPages(query.compile(), function (response) {

          resolve(response);
        }, function (err) {

          reject(err);
        });
      });
    };

    inv.getInventory = function (search) {
      if (inv.isManager) {
        if (!inv.selectedGrower) {
          alertify.error("Please select a grower.");
          return;
        }
      }

      if (!inv.selectedVariety && !inv.selectedProductGroup) {
        alertify.error("Please select a variety or product group.");
        return;
      }
      if (!inv.week) {
        alertify.error("Start date is required. Please select a date");
        return;
      }
      if (!inv.endDate) {
        alertify.error("End date is required. Please select a date");
        return;
      }

      var userData = common.getUserData();

      // COUNTRY_MANAGER must have countries assigned; LOGISTICS_SUPPORT is not country-scoped.
      if (userData.ibf_role === "COUNTRY_MANAGER" && !(userData.countries && userData.countries.length > 0)) {
        alertify.error("Your user has no countries assigned.");
        return;
      }

      inv.loading = true;
      var query = null;

      var startOfWeek = inv.week ? inv.week : getMonday();
      var endOfWeek = inv.endDate ? common.convertDateToNumberDate(inv.endDate) : null;

      if (inv.isManager) {
        query = common.sbx.with("inventory").andWhereIsEqual("masterlist.active", true).andWhereIsEqual("grower", inv.selectedGrower);
      } else if (common.getUserData().grower) {
        query = common.sbx.with("inventory").andWhereIsEqual("masterlist.active", true).andWhereIsEqual("grower", common.getUserData().grower);
      }

      if (query) {
        if (inv.selectedVariety) {
          query.andWhereIsEqual("variety", inv.selectedVariety);
        }

        if (inv.selectedProductGroup) {
          query.andWhereIsEqual("variety.product_group", inv.selectedProductGroup);
        }

        if (startOfWeek) query.andWhereGreaterOrEqualThan("week", common.convertDateToNumberDate(startOfWeek));
        if (endOfWeek) query.andWhereLessOrEqualThan("week", endOfWeek);

        query.fetchModels(["grower", "variety.color", "masterlist.product_group", "masterlist.grade"]);

        common.loadAllPages(query.compile(), function (response) {
          try {
            setInventories(response, response.fetched_results);
          } catch (e) {
            console.error("Error loading inventory", e);
            inv.loading = false;
            alertify.error("Unable to load the inventory. Please try again.");
          }
        }, function (err) {
          inv.loading = false;
          alertify.error("Unable to load the inventory. Please try again.");
        });
      } else {
        inv.loading = false;
        alertify.error("No grower available for this user.");
      }
    };

    function getEndDate(startDate) {
      var endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);
      return endDate;
    }

    inv.updateEndDate = function () {
      if (inv.week) {
        var endDate = new Date(inv.week);

        endDate.setDate(endDate.getDate() + 7);

        inv.endDate = endDate;
      }
    };

    inv.recordInventoryDeletionAudit = function (inventories) {
      var selectedGrowerName = inv.growers.find(function (grower) {
        return grower._KEY === inv.selectedGrower;
      }).company_name || '';
      var currentUserFullName = "(" + [common.getUserData().data.first_name, common.getUserData().data.last_name].filter(Boolean).join(' ') + ")";
      var auditLogEntries = inventories.map(function (inventoryItem) {
        return {
          action: 'DELETE_INVENTORY',
          user: common.getUserData().key,
          date: new Date(),
          description: "The user " + currentUserFullName + " delete an inventory for week " + common.convertDateToNumberDate(inv.week) + " for the grower " + selectedGrowerName,
          object_string: JSON.stringify({
            grower: inventoryItem.grower._KEY,
            masterlist: inventoryItem.masterlist._KEY,
            UoM: inventoryItem.masterlist.UoM,
            product_group: inventoryItem.product_group._KEY,
            variety: inventoryItem.variety._KEY,
            inventory: inventoryItem._KEY,
            freeze: "true"
          })
        };
      });
      var chunk = _.chunk(auditLogEntries, 300);
      async.eachSeries(chunk, function (items, next) {
        var query = common.sbx.insert("audit", items);

        common.method.insert(query).then(function (data) {

          next();
        });
      });
    };

    inv.sbxQueue = function (inventories) {

      var auditLogEntries = inventories.map(function (inventoryItem) {
        return {
          name: "remove_cart_box_from_inventory_disabled",
          params: JSON.stringify({ inventory: inventoryItem._KEY }),
          user: common.getUserData().key
        };
      });
      var chunk = _.chunk(auditLogEntries, 300);
      async.eachSeries(chunk, function (items, next) {
        var query = common.sbx.insert("sbx_queue", items);

        common.method.insert(query).then(function (data) {
          next();
        });
      });
    };

    function init() {
      inv.isManager = common.getUserData().ibf_role === "COUNTRY_MANAGER" || common.getUserData().ibf_role === "LOGISTICS_SUPPORT";

      inv.loading = true;

      inv.week = getMonday();
      inv.endDate = getEndDate(inv.week);

      common.method.run({
        key: environment.cloudscript.loadDependencies,
        params: { includes: ["grower"] }
      }).then(function (res) {
        if (res.success) {
          res = res.results;
          var growersMap = common.arrayToMap(res.grower.filter(function (item) {
            return item.active;
          }), "_KEY");

          inv.growers = res.grower.filter(function (item) {
            return item.active;
          }).sort(function (a, b) {
            return a.company_name.localeCompare(b.company_name);
          });
          inv.loading = false;

          inv.dependenciesCache = {
            grower: growersMap,
            variety: {},
            product_group: {}
          };
        }
      });
    }

    inv.hasCheckedInventories = function () {
      return inv.copyInventory && inv.copyInventory.some(function (item) {
        return item.checked;
      });
    };

    inv.toggleAllItems = function () {
      inv.checkedAllItems = !inv.checkedAllItems;
      inv.copyInventory.forEach(function (item) {
        if (item.quantity > 0) {
          item.checked = inv.checkedAllItems;
        }
      });
    };

    inv.onChangeChecked = function (_KEY) {
      var items = inv.inventories.map(function (item) {
        if (item._KEY === _KEY) {
          item.checked = !item.checked;
        }
        return item;
      });

      inv.checkedAllItems = items.every(function (item) {
        return item.checked;
      });
    };

    function getErrorMessage(error) {
      var messageError = "Unable to remove inventory from the cart. Please try again later.";

      if (typeof error === "string") {
        return error;
      }

      if ((typeof error === "undefined" ? "undefined" : _typeof(error)) === "object" && error !== null && Object.keys(error).length > 0) {
        return JSON.stringify(error);
      }

      return messageError;
    }

    inv.resetInventoryChecks = function () {
      inv.inventories.forEach(function (item) {
        item.checked = false;
      });
    };

    inv.disableInventory = function (inventories, onSuccess, onError) {
      var messageError = "Unable to update the inventory at this time. Please try again later.";

      var chunk = _.chunk(inventories, 300);
      async.eachSeries(chunk, function (items, next) {

        var query = common.sbx.insert("inventory", items.map(function (inventory) {
          return {
            _KEY: inventory._KEY,
            quantity: 0,
            freeze: true
          };
        }));

        common.method.update(query).then(function (data) {

          if (data.success) {

            inv.recordInventoryDeletionAudit(inventories);
            inv.sbxQueue(inventories);
            next();
            var inventoriesKeys = inventories.map(function (item) {
              return item._KEY;
            });
            var chunks = _.chunk(inventoriesKeys, 50);
            async.eachSeries(chunks, function (chunk, next) {
              inv.getCartboxesItemsKeys(chunk).then(function (res) {
                if (res && res.results.length > 0) {
                  var cartboxItemsKeys = res.results.map(function (item) {
                    return item._KEY;
                  });
                  var cartboxChunks = _.chunk(cartboxItemsKeys, 15);

                  async.eachSeries(cartboxChunks, function (cartboxChunk, callback) {
                    if (cartboxChunk.length > 0) {
                      common.method.run({
                        key: environment.cloudscript.deleteMultiplesCartboxes,
                        params: { cartboxItemsKeys: cartboxChunk }
                      }).then(function () {
                        callback();
                      }).catch(function (err) {
                        callback(err);
                      });
                    } else {
                      callback();
                    }
                  }, next);
                } else {
                  next();
                }
              }).catch(function (err) {
                next(err);
              });
            }, function (err) {
              if (err) {
                console.log("Error", err);
              }
              onSuccess();
            });
          } else {
            onError({
              inv: items,
              error: data.message || messageError,
              isInventoryRemovalError: false
            });
          }
        });
      }, function (err) {
        onSuccess(err);
      });
    };

    inv.deleteMultipleInventories = function () {
      var inventories = inv.copyInventory.filter(function (item) {
        return item.checked;
      });

      var selectedInventories = [];
      if (inventories.length === 0) {
        alertify.error("Select the items to update");
        return;
      }

      selectedInventories = inventories.reduce(function (acc, item) {
        if (item.checked) {
          acc.push(item);
        }
        return acc;
      }, []);

      var weekDate = inv.week ? common.convertDateToNumberDate(inv.week) : null;
      var endDate = inv.endDate ? common.convertDateToNumberDate(inv.endDate) : null;
      var msj = "Are you sure you want to disable the selected inventories for week " + weekDate + (endDate ? " and end date " + endDate : "") + " and set quantity to 0?";

      common.confirmModal({
        title: "Disable Multiple Inventories",
        msj: msj,
        saveText: "Yes",
        cancelText: "No, go back",
        size: "sm"
      }, function () {
        var dialog = common.showDialogProgress({ msj: "Deleting..." });
        inv.loading = true;

        inv.disableInventory(selectedInventories, function (data) {
          dialog.close();
          inv.resetInventoryChecks();
          inv.checkedAllItems = false;
          inv.loading = false;

          alertify.success("Inventories have been updated");
          inv.getInventory();
        }, function (error) {
          dialog.close();

          inv.loading = false;
          inv.checkedAllItems = false;
          inv.resetInventoryChecks();
          alertify.error(error.error || "An error occurred while disabling the inventory.");

          inv.resetInventoryChecks();

          if (!error.isInventoryRemovalError) {
            var _error$inv$reduce = error.inv.reduce(function (acc, inventory) {
              acc.product.push(inventory.product_group.common_name);
              acc.variety.push(inventory.variety.variety_name);
              return acc;
            }, { product: [], variety: [] }),
                product = _error$inv$reduce.product,
                variety = _error$inv$reduce.variety;

            var message = "Products: " + product.join(", ") + "\nVarieties: " + variety.join(", ");

            common.confirmModal({
              title: "Inventory Not Disabled",
              msj: message,
              saveText: "Ok",
              size: "sm",
              cancelText: "Close",
              showButton: false
            }, function () {});
            inv.getInventory();
          } else {
            inv.getInventory();
          }
        });
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=adminDeleteMultipleInventoryCtrl.js.map
